import React, { useState, useEffect, useMemo, useRef } from "react"
import { useNavigate, useParams, useLocation, Link } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"
import { FormProvider, useFieldArray, useForm, useWatch } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import {
  RichTextEditor,
  UFDate,
  UFEditor,
  UFInput,
  UFInputNumber,
} from "../../../components/Common/Fields/Input"
import LoadingButton from "../../../components/Common/LoadingButton"
import lightTrash from "../../../assets/icons/light-trash.svg"
import close from "../../../assets/icons/close.svg"
import moment from "moment"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { fetchPurchase } from "../../../services/procurement/purchaseOrder"
import { ContentState, convertToRaw, EditorState } from "draft-js"
import draftToHtml from "draftjs-to-html"
import Unit from "../../../components/Common/chooseFields/unit"
import { useDispatch, useSelector } from "react-redux"
import FinanceLedgersLi from "../../../components/Common/chooseFields/ledgers"
import {
  fetchFinanceJournal,
  fetchFinanceVoucherSingle,
  fetchFinanceVoucherSingleNew,
  postFinanceVoucher,
} from "../../../services/finance/finance"
import VoucherTypes from "../../../components/Common/chooseFields/voucherTypes"
import ProductList from "../../../components/Common/chooseFields/productList"
import ProjectNo from "../../../components/Common/chooseFields/projectno"
import closeIcon from "../../../assets/icons/close.svg"
import {
  fetchMRRequesting,
  fetchRequestPOvoucher,
  fetchRfqReference,
} from "../../../services/procurement/materialrequest"
import VoucherEntryLi from "../../../components/Common/chooseFields/voucherEntryLi"
import VoucherEntrySearch from "."
import DebitCreditDrop from "../../../components/Common/chooseFields/debitCredit"
import StockProductList from "../../../components/Common/chooseFields/stockProduct"
import RFQList from "../../../components/Common/chooseFields/rfqLi"
import htmlToDraft from "html-to-draftjs"
import MRRequstingLi from "../../../components/Common/chooseFields/materialRequstionLi"
import NumberFormat from "../../../utils/numberFormat"
import ManufactureLi from "../../../components/Common/chooseFields/manufactureLi"
import TrashIcon from "../../../assets/icons/iconComponents/trashIcon"
import { getFinanceVoucherLi } from "../../../services/Settings/dropdown"
import SkeletonLoading from "../../../components/VerticalLayout/SkeletonLoader"
import SkeletonLoadingvoucher from "./skelitonvouher"
import { changeSidebarSize } from "../../../store/actions"
import { getCode } from "../../../services/inventory"
import ReferenceType from "../../../components/Common/chooseFields/refType"
import { toSnakeCase } from "../../../utils/toSnakeCase"
import { capitalize, set, values } from "lodash"
import NatureOfTransactions from "../../../components/Common/chooseFields/natureOfTransactions"
import FinCostCenterLi from "../../../components/Common/chooseFields/costCenterFinLi"
import { openAndPrintFile } from "../../../utils/handleDownload"
import DebitCreditDrops from "../../../components/Common/chooseFields/debitCreditTypes"
import BankPaymentType from "../../../components/Common/chooseFields/paymentType"
import BankCurrency from "../../../components/Common/chooseFields/bankCurrency"
import Draggable from "react-draggable"

const EditVoucherEntry = ({ fromDashboard, poValue, toggle }) => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Voucher Entry${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""

  const navigate = useNavigate()
  const { editId } = useParams()
  const id = fromDashboard ? "" : editId
  console.log(`editId`, editId)
  const [isLoading, setIsLoading] = useState(false)
  const [isVoucherLoading, setIsVoucherLoading] = useState(false)
  const [idPO, setIdPO] = useState()
  const [responseData, setResponseData] = useState()
  const [vatCheck, setVatCheck] = useState(false)
  const [discountCheck, setDiscountCheck] = useState(false)
  const [discountAfterCheck, setDiscountAfterCheck] = useState(false)
  const [shippingCheck, setShippingCheck] = useState(false)
  const [othersCheck, setOthersCheck] = useState(false)
  const [pdcCheck, setPdcCheck] = useState(false)
  const [costCenterCheck, setCostCenterCheck] = useState(true)
  const [retentionCheck, setRetentionCheck] = useState(false)
  const [advRetentionCheck, setAdvRetentionCheck] = useState(false)
  const [modal, setModal] = useState(false)
  const [viewVouchersLi, setViewVouchersLi] = useState(false)
  const [contraId, setContraId] = useState(null)
  const [poData, setPoData] = useState()
  const [projectId, setProjectID] = useState()
  const [viewData, setViewData] = useState()
  const [voucherId, setVoucherId] = useState()
  const [voucherParId, setVoucherParentId] = useState()
  const [materialData, setMaterialData] = useState()
  const [rSelected, setRSelected] = useState(2)
  const [activeItemId, setActiveItemId] = useState(null)
  const [confirmModal, setConfirmModal] = useState(false)
  const [printID, setPrintID] = useState(false)
  const [transactionModal, setTransactionModal] = useState(false)
  const [bankModal, setBankModal] = useState(false)
  const [ccModal, setCCModal] = useState(false)
  const [editPartial, setEditPartial] = useState(false) // For edit partial payment modal Edited By: Adithyan

  const [selectedAgainstRef, setSelectedAgainstRef] = useState([])

  const natureRefs = useRef([])

  const dispatch = useDispatch()

  const now = moment()
  const desimalrange = localStorage.getItem("desimalrange")

  const toggleSelect = () => setModal(!modal)
  const toggleSelectModal = () => {
    console.log(`viewData toggleSelectModal`, viewData)

    // const removeIds = watch("voucher_contra_partial_pay")?.map((item, i) => i)
    // removeIds &&
    //   removeIds?.length > 1 &&
    //   removeIds?.map(i => contraPartialListRemove(i))
    // setValue(`voucher_contra.${viewData?.currIndex}.account_id`, null)
    // setValue(`voucher_contra.${viewData?.currIndex}.partial_payments`, [])
    // setValue(`voucher_contra.${viewData?.currIndex}.account_id`, null)

    setModal(!modal)
  }

  const body = document.body.getAttribute("data-sidebar-size")

  const schema = yup.object().shape({
    ...(discountCheck && {
      discount: yup
        .string()
        .matches(
          /^([+]?)\d+(\.\d{1,4})?$/,
          "Discount must be a positive number"
        )
        .test(
          "is-not-negative",
          "Discount cannot be negative",
          value => parseFloat(value) >= 0
        ),
    }),
    ...(shippingCheck && {
      shipping_charge: yup
        .string()
        .matches(
          /^([+]?)\d+(\.\d{1,4})?$/,
          "Discount must be a positive number"
        )
        .test(
          "is-not-negative",
          "Discount cannot be negative",
          value => parseFloat(value) >= 0
        ),
    }),
    ...(othersCheck && {
      other_charge: yup
        .string()
        .matches(
          /^([+]?)\d+(\.\d{1,4})?$/,
          "Discount must be a positive number"
        )
        .test(
          "is-not-negative",
          "Discount cannot be negative",
          value => parseFloat(value) >= 0
        ),
    }),
    voucher_id: yup.mixed().required("Voucher Type is Required"),
    po_date: yup.mixed().required("Date is Required"),
    ...(retentionCheck && {
      retention_id: yup.mixed().required("Retention is Required"),
    }),
    ...(advRetentionCheck && {
      adv_retention_id: yup.mixed().required("Advance Retention is Required"),
    }),
    ...(vatCheck && {
      vat_id: yup.mixed().required("VAT is Required"),
    }),
    ...(([1, 3, 6, 8, 21].includes(Number(voucherId)) ||
      [1, 3, 6, 8, 21].includes(Number(voucherParId)) ||
      (([13, 15, 4, 18].includes(voucherId) ||
        [13, 15, 4, 18].includes(Number(voucherParId))) &&
        rSelected == 2)) && {
      voucher_contra: yup.array().of(
        yup.object().shape({
          account_id: yup.mixed().required("Account Head is Required"),
          nature: yup.mixed().required("Type is Required"),
          debit: yup
            .string()
            .matches(
              /^([+]?)\d+(\.\d{1,4})?$/,
              "Debit Amount must be a valid number with up to 4 digits after the decimal point"
            )
            .required("Debit Amount is required"),
          credit: yup
            .string()
            .matches(
              /^([+]?)\d+(\.\d{1,4})?$/,
              "Credit Amount must be a valid number with up to 4 digits after the decimal point"
            )
            .required("Credit Amount is required"),
        })
      ),
    }),
    ...((voucherId == 16 || voucherParId == 16) && {
      credit_id: yup.mixed().required("Party Name is Required"),
      address: yup.string().required("Address is Required"),
      voucher_materials: yup.array().of(
        yup.object().shape({
          product_id: yup.mixed().required("Product Code is Required"),
          qnt: yup
            .string()
            .matches(
              /^([+]?)\d+(\.\d{1,2})?$/,
              "Quantity must be a number with up to 4 decimal places"
            )
            .required("Quantity is required"),
          unit_price: yup
            .string()
            .matches(
              /^([+]?)\d+(\.\d{1,4})?$/,
              "Unit Price must be a number with up to 4 decimal places"
            )
            .required("Unit Price is required"),
        })
      ),
      // voucher_contra: yup.array().of(
      //   yup
      //     .object()
      //     .shape({
      //       account_id: yup.mixed().required("Particulars is Required"),
      //       debit: yup
      //         .string()
      //         .matches(
      //           /^([+]?)\d+(\.\d{1,4})?$/,
      //           "Debit Amount must be a valid number with up to 4 digits after the decimal point"
      //         )
      //         .nullable(),
      //       credit: yup
      //         .string()
      //         .matches(
      //           /^([+]?)\d+(\.\d{1,4})?$/,
      //           "Credit Amount must be a valid number with up to 4 digits after the decimal point"
      //         )
      //         .nullable(),
      //     })
      //     .test(
      //       "debit-or-credit",
      //       "Either Debit or Credit must be greater than 0",
      //       value => {
      //         const debit = parseFloat(value.debit || "0")
      //         const credit = parseFloat(value.credit || "0")
      //         return debit > 0 || credit > 0
      //       }
      //     )
      // ),
    }),
    ...((voucherId == 15 || voucherParId == 15) &&
      rSelected == 1 && {
        credit_id: yup.mixed().required("Party Name is Required"),
        debit_id: yup.mixed().required("Purchase Ledger is Required"),
        voucher_purchase: yup.array().of(
          yup.object().shape({
            qnt: yup
              .number()
              .typeError("Quantity must be a number")
              .required("Quantity is required")
              .test(
                "max-qnt",
                "Quantity exceeds available quantity",
                function (value) {
                  const { ordered_quantity, already_created } =
                    this.options.parent
                  const maxAllowed =
                    (ordered_quantity || 0) - (already_created || 0)
                  return value <= maxAllowed
                }
              ),
          })
        ),
      }),
    ...((voucherId == 13 || voucherParId == 13) &&
      rSelected == 1 && {
        credit_id: yup.mixed().required("Party Name is Required"),
        debit_id: yup.mixed().required("Sales Account is Required"),
        sale_total: yup.string().required("Amount is Required"),
      }),
    ...(([13, 15].includes(Number(voucherId)) ||
      [13, 15].includes(Number(voucherParId))) &&
      rSelected == 3 && {
        credit_id: yup.mixed().required("Party Name is Required"),
      }),
    ...((voucherId == 13 || voucherParId == 13) &&
      rSelected == 4 && {
        credit_id: yup.mixed().required("Party Name is Required"),
        debit_id: yup.mixed().required("Sales Account is Required"),
      }),
    // payable_account: yup.mixed().required("Purchase Ledger is required"),
    //   recieved_date: yup
    //     .mixed()
    //     .test(
    //       "is-future-date",
    //       "Make sure the received date is forward-looking",
    //       function (value) {
    //         if (!value) return true
    //         const currentDate = moment()
    //         const selectedDate = moment(value)
    //         return selectedDate.isSameOrBefore(currentDate, "day")
    //       }
    //     )
    //     .required("Received date is required"),
    //   grnproductlist: yup.array().of(
    //     yup.object().shape({
    //       product_code: yup.mixed().required("product code is required"),
    //       description: yup.string().required("description is required"),
    //       unit: yup.mixed().required("Unit is Required"),
    //       received_quantity: yup
    //         .string()
    //         .matches(
    //           /^\d*(\.\d+)?$/,
    //           "Pending quantity must be a non-negative number"
    //         )
    //         .test(
    //           "max",
    //           "pending quantity must not exceed the ordered quantity",
    //           function (value) {
    //             const { pending_quantity } = this.parent
    //             return parseInt(value) <= pending_quantity
    //           }
    //         )
    //         .required("pending quantity is required"),
    //     })
    //   ),
  })

  const location = useLocation()

  const loggedUser = useSelector(state => state?.Login.loggedUser)

  const {
    control,
    handleSubmit,
    watch,
    reset,
    getValues,
    setValue,
    setFocus,
    clearErrors,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldFocusError: true,
    defaultValues: {
      po_id: null,
      other_charge: 0,
      shipping_charge: 0,
      po_date: moment(now, "YYYY-MM-DD").toDate(),
      code_edit: 0,
      voucher_materials: [
        {
          qnt: "",
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
        },
      ],
      voucher_purchase: [
        {
          qnt: "",
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
        },
      ],
      voucher_receipt: [
        {
          qnt: 0,
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
        },
      ],
      voucher_materialout: [
        {
          qnt: 0,
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
          amount: 0,
        },
      ],
      voucher_destination: [
        {
          qnt: 0,
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
          amount: 0,
        },
      ],
      voucher_source: [
        {
          qnt: 0,
          product_id: null,
          unit_price: "",
          sub_price: "",
          unit: null,
          id: "",
        },
      ],
      voucher_contra: [
        {
          nature:
            [8, 3, 15].includes(voucherId) ||
            [8, 3, 15].includes(Number(voucherParId))
              ? { label: "Dr", value: "debit" }
              : { label: "Cr", value: "credit" },
          account_id: null,
          debit: "",
          credit: "",
          voucher_id: null,
          partial_payments: [],
        },
      ],
      voucher_sales_acc: [
        {
          amount: 0,
          rate: "",
          account_id: null,
        },
      ],
      voucher_contra_partial_pay: [
        {
          nature: { label: "Cr", value: "credit" },
          account_id: null,
          amount: 0,
          date: moment(now, "DD-MM-MMMM").toDate(),
          // credit: 0,
          voucher_id: null,
          // partial_payments: [],
        },
      ],
    },
  })
  const getUniqueCode = async (code, modal, type, date) => {
    const response = await getCode(code, modal, type, date)
    if (!editId) {
      setValue("code", response?.code?.code)
    }
    setValue("code_edit", response?.code?.manualoverride)
    setValue("monthly_reset", response?.code?.monthly_reset)
  }
  console.log(`code_edit`, watch("code_edit"))

  useEffect(() => {
    // if (!editId) {
    getUniqueCode(
      "ref_number",
      "VoucherEntry",
      `Voucher - ${
        watch(`voucher_id`)?.label
          ? ucfirst(watch(`voucher_id`)?.label)
          : "Contra"
      }`
    )
    // }
  }, [])
  useEffect(() => {
    const resetValue = getValues()
    console.log(`resetValue`, resetValue)
    setValue("code", resetValue?.code)
    setValue("po_date", resetValue?.po_date)
    if (watch("voucher_id")) {
      setVoucherId(watch("voucher_id")?.value)
      setVoucherParentId(watch("voucher_id")?.parent_id)
    }
    if (
      (watch("voucher_id")?.value == 3 ||
        watch("voucher_id")?.parent_id == 3) &&
      !editId
    ) {
      // setValue(`voucher_contra.${0}.nature`, { label: "Dr", value: "debit" })
      setValue(`voucher_contra.${0}.amount`, 0)
    }
    // if (watch("voucher_id")?.value == 6 && !editId) {
    //   setValue(`voucher_contra.${0}.nature`, { label: "Cr", value: "credit" })
    // }
    if (
      (watch("voucher_id")?.value == 16 ||
        watch("voucher_id")?.parent_id == 16) &&
      !editId &&
      loggedUser
    ) {
      let activeGeneral = getDescriptionByCategoryId(
        loggedUser?.active_terms,
        1
      )
      let activeDeliver = getDescriptionByCategoryId(
        loggedUser?.active_terms,
        2
      )
      setValue(
        "general_terms",
        activeGeneral ? formatTemplate(activeGeneral) : ""
      )
      setValue(
        "delivery_terms",
        activeDeliver ? formatTemplate(activeDeliver) : ""
      )
    }
    if (
      (watch("voucher_id")?.value == 15 ||
        watch("voucher_id")?.parent_id == 15) &&
      [1, 2, 3].includes(rSelected) &&
      !editId
    ) {
      // setValue("ref_code", "")
      // setValue("ref_date", moment(now, "DD-MM-YYYY").toDate())
    }
  }, [watch("voucher_id")])

  console.log(`codeee`, watch("code"))

  const getDescriptionByCategoryId = (terms, categoryId) => {
    const term = terms?.find(term => term.category_id === categoryId)
    return term?.description || null // Return description or null if not found
  }

  const formatTemplate = html => {
    let editorState = EditorState.createEmpty()
    if (html === null) {
      return editorState
    }
    const contentBlock = htmlToDraft(html)
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    )
    editorState = EditorState.createWithContent(contentState)
    return editorState
  }

  const {
    fields: poFields,
    append: materialAppend,
    remove: materialRemove,
  } = useFieldArray({
    control,
    name: "grnproductlist",
  })
  const watchTest = useWatch({
    control,
    name: "grnproductlist",
    defaultValue: poFields,
  })
  useEffect(() => {
    if (location?.state?.id) {
      reset({
        voucher_id:
          location?.state && location?.state?.chkField == "MR"
            ? {
                label: "Stock Journal",
                value: 12,
                voucher_type: "Stock Journal",
              }
            : {
                label: "Purchase Order",
                value: 16,
                voucher_type: "Purchase Order",
              },
      })

      getUniqueCode(
        "ref_number",
        "VoucherEntry",
        `Voucher - ${
          location?.state && location?.state?.chkField == "MR"
            ? "Stock Journal"
            : "Purchase Order"
        }`
      )
      setActiveItemId(
        location?.state && location?.state?.chkField == "MR" ? 12 : 16
      )

      if (location?.state?.type === "from_po") {
        setCardOpen(false)
      }

      // fetchPotData(location?.state?.id)
    }
    if (location?.state?.chkField == "MR") {
      fetchMaterialRequstiotion(location?.state?.id)
      setValue("material_requisition_id", {
        label: location?.state?.code,
        value: location?.state?.id,
      })
    } else if (location?.state && location?.state?.chkField != "MR") {
      fetchRfqData(location?.state?.id)
      setIdPO(location?.state?.id)
    }
    setValue(
      "address",
      loggedUser?.settings?.companyaddress
        ? loggedUser?.settings?.companyaddress
        : ""
    )
  }, [location])

  useEffect(() => {
    if (fromDashboard) {
      reset({
        po_id: poValue?.value && {
          label: poValue?.label,
          value: poValue?.value,
        },
      })

      handlePoChange(poValue)
    }
  }, [fromDashboard])

  const getPercentRev = (a, b) => {
    return ((Number(a) / Number(b)) * 100).toFixed(desimalrange)
  }

  const handleDateContraPartial = (e, index) => {
    console.log(`e`, e)
  }

  useEffect(() => {
    // const fetchEditData = async id => {
    //   const response = await fetchFinanceVoucherSingle(id)
    //   let materialDataArr
    //   if (
    //     response?.data?.voucher_id == 15 &&
    //     response?.data?.voucher_invoice == "Purchase Invoice"
    //   ) {
    //     materialDataArr = response?.data?.purchasevoucher?.materials?.map(
    //       dt => ({
    //         id: dt?.id,
    //         product_id: {
    //           label: dt?.product?.product_code,
    //           value: dt?.product?.id,
    //         },
    //         po_material_id: dt?.po_material_id,
    //         unit: {
    //           label: dt?.product?.unit?.unit_code,
    //           value: dt?.product?.unit?.id,
    //         },
    //         description: dt?.product?.description,
    //         already_created:
    //           Number(dt?.used_quantity || 0) - Number(dt?.voucher_quantity),
    //         ordered_quantity:
    //           dt?.voucher_from == 1 ? dt?.grn_quantity : dt?.po_quantity,
    //         qnt: dt?.voucher_quantity,
    //         unit_price: dt?.unit_price,
    //         sub_price: Number(dt?.voucher_quantity) * Number(dt?.unit_price),
    //       })
    //     )
    //   } else if (
    //     response?.data?.voucher_id == 4 &&
    //     response?.data?.voucher_invoice == "Purchase Invoice"
    //   ) {
    //     materialDataArr = response?.data?.purchasevoucher?.materials?.map(
    //       dt => ({
    //         id: dt?.id,
    //         product_id: {
    //           label: dt?.product?.product_code,
    //           value: dt?.product?.id,
    //         },
    //         unit: {
    //           label: dt?.product?.unit?.unit_code,
    //           value: dt?.product?.unit?.id,
    //         },
    //         description: dt?.product?.description,
    //         already_created: dt?.used_quantity || 0,
    //         ordered_quantity:
    //           dt?.voucher_from == 1 ? dt?.grn_quantity : dt?.po_quantity,
    //         qnt: dt?.voucher_quantity,
    //         unit_price: dt?.unit_price,
    //         sub_price: Number(dt?.voucher_quantity) * Number(dt?.unit_price),
    //       })
    //     )
    //   } else if (response?.data?.voucher_id == 16) {
    //     materialDataArr = response?.data?.purchaseorder?.materials?.map(dt => ({
    //       id: dt?.id,
    //       product_id: {
    //         label: dt?.product?.product_code,
    //         value: dt?.product?.id,
    //       },
    //       unit: {
    //         label: dt?.product?.unit?.unit_code,
    //         value: dt?.product?.unit?.id,
    //       },
    //       description: dt?.product?.description,
    //       qnt: dt?.po_quantity,
    //       unit_price: dt?.unit_price,
    //       sub_price: Number(dt?.po_quantity) * Number(dt?.unit_price),
    //     }))
    //   } else if (
    //     [13, 18].includes(response?.data?.voucher_id) &&
    //     response?.data?.voucher_invoice == "Sales Product Invoice"
    //   ) {
    //     const chkMap =
    //       response?.data?.voucher_id == 13
    //         ? response?.data?.salesvoucher
    //         : response?.data?.salesvoucher
    //     materialDataArr = chkMap?.materials?.map(dt => ({
    //       id: dt?.id,
    //       product_id: {
    //         label: dt?.product?.product_code,
    //         value: dt?.product?.id,
    //       },
    //       unit: {
    //         label: dt?.product?.unit?.unit_code,
    //         value: dt?.product?.unit?.id,
    //       },
    //       description: dt?.product?.description,
    //       qnt: Number(
    //         response?.data?.voucher_id == 13 ? dt?.so_quantity : dt?.so_quantity
    //       ).toFixed(desimalrange || 2),
    //       unit_price: Number(dt?.unit_price).toFixed(desimalrange || 2),
    //       sub_price: Number(
    //         Number(
    //           response?.data?.voucher_id == 13
    //             ? dt?.so_quantity
    //             : dt?.so_quantity
    //         ) * Number(dt?.unit_price)
    //       ).toFixed(desimalrange || 2),
    //     }))
    //   } else if (response?.data?.voucher_id == 7) {
    //     materialDataArr = response?.data?.grns?.materials?.map(dt => ({
    //       id: dt?.id,
    //       product_id: {
    //         label: dt?.product?.product_code,
    //         value: dt?.product?.id,
    //       },
    //       unit: {
    //         label: dt?.product?.unit?.unit_code,
    //         value: dt?.product?.unit?.id,
    //       },
    //       description: dt?.product?.description,
    //       po_quantity: dt?.po_quantity,
    //       qnt: dt?.grn_quantity,
    //       unit_price: dt?.unit_price,
    //       sub_price: Number(dt?.po_quantity) * Number(dt?.unit_price),
    //     }))
    //   } else if (response?.data?.voucher_id == 11) {
    //     materialDataArr = response?.data?.material_out_voucher?.items?.map(
    //       dt => ({
    //         id: dt?.id,
    //         product_id: {
    //           label: dt?.material?.product_code,
    //           value: dt?.material?.id,
    //         },
    //         description: dt?.material?.description,
    //         qnt: dt?.quantity,
    //       })
    //     )
    //   } else if (response?.data?.voucher_id == 12) {
    //     materialDataArr = response?.data?.storeHistory?.map(dt => ({
    //       id: dt?.id,
    //       material_id: {
    //         label: dt?.product_id?.product_code,
    //         value: dt?.product_id?.id,
    //       },
    //       rate: dt?.rate,
    //       qnt: dt?.quantity,
    //       amount: Number(dt?.rate) * Number(dt?.quantity),
    //     }))
    //   } else {
    //     materialDataArr = response?.data?.details?.map(dt => ({
    //       product_id: {
    //         label: dt?.product?.product_code,
    //         value: dt?.product?.id,
    //       },
    //       description: dt?.product?.description,
    //       qnt: dt?.qnt,
    //       unit_price: dt?.unit_price,
    //     }))
    //   }
    //   let contraArr = response?.data?.journalEntry?.journal_entry_details?.map(
    //     dt => ({
    //       nature: {
    //         label: Number(dt?.debit_amount) > 0 ? "Dr" : "Cr",
    //         value: Number(dt?.debit_amount) > 0 ? "debit" : "credit",
    //       },
    //       account_id: {
    //         label: dt?.ledger?.name,
    //         value: dt?.ledger?.id,
    //         ...dt?.ledger,
    //       },
    //       debit: Number(dt?.debit_amount),
    //       credit: Number(dt?.credit_amount),
    //       cost_center_id: dt?.cost_center_id
    //         ? {
    //             ...dt?.costcenter,
    //             label: dt?.costcenter?.name,
    //             value: dt?.costcenter?.id,
    //           }
    //         : null,
    //       transaction_type: dt?.transaction_type?.id
    //         ? {
    //             label: dt?.transaction_type?.label,
    //             value: dt?.transaction_type?.id,
    //           }
    //         : null,
    //       // voucher_id:
    //       partial_payments: dt?.voucher_partial_payment?.map(partial => ({
    //         id: partial?.id,
    //         amount: partial?.amount,
    //         chk: dt?.id,
    //         nature: {
    //           value: partial?.credit_debit,
    //           label: partial?.credit_debit == "debit" ? "Dr" : "Cr",
    //         },
    //         code: partial?.code,
    //         ref_id: {
    //           value: partial?.ref_id,
    //           label:
    //             partial?.ref_id == 1
    //               ? "Advance"
    //               : partial?.ref_id == 2
    //               ? "Against Ref"
    //               : "New Ref",
    //         },
    //         date: partial?.date,
    //         parent_ledger_id: partial?.parent_ledger_id,
    //         ...(partial?.parent_voucher_entry_id && {
    //           voucher_id: partial?.parent_voucher_entry_id,
    //         }),
    //       })),

    //       ...(dt?.bank_payments?.length && {
    //         bank_date: moment(dt?.bank_payments[0]?.date).format("DD-MM-YYYY"),
    //         instrument_no: dt?.bank_payments[0]?.instrument_no,
    //         instrument_date: moment(
    //           dt?.bank_payments[0]?.instrument_date
    //         ).format("DD-MM-YYYY"),
    //         bank_amount: dt?.bank_payments[0]?.amount,
    //         remarks: dt?.bank_payments[0]?.remarks,
    //         payment_type_id: dt?.bank_payments[0]?.payment_type_id
    //           ? {
    //               label: dt?.bank_payments[0]?.payment_type_value?.value,
    //               value: dt?.bank_payments[0]?.payment_type_value?.id,
    //             }
    //           : null,
    //         currency: dt?.bank_payments[0]?.currency
    //           ? {
    //               label: dt?.bank_payments[0]?.currency_value?.value,
    //               value: dt?.bank_payments[0]?.currency_value?.id,
    //             }
    //           : null,
    //       }),
    //     })
    //   )

    //   let saleAccArrRe =
    //     response?.data?.journalEntry?.journal_entry_details?.slice(0, -1)

    //   let saleAccArr = saleAccArrRe?.map((dt, index) => ({
    //     account_id: {
    //       label: dt?.ledger?.name,
    //       value: dt?.ledger?.id,
    //       ...dt?.ledger,
    //     },
    //     amount:
    //       Number(dt?.credit_amount) &&
    //       response?.data?.voucher_invoice == "Sales Account"
    //         ? Number(dt?.credit_amount)
    //         : Number(dt?.debit_amount) &&
    //           response?.data?.voucher_invoice == "Sales Account"
    //         ? -Number(dt?.debit_amount)
    //         : Number(dt?.debit_amount) &&
    //           response?.data?.voucher_invoice == "Purchase Account"
    //         ? Number(dt?.debit_amount)
    //         : -Number(dt?.credit_amount),

    //     rate:
    //       index === 0
    //         ? ""
    //         : `${
    //             Number(dt?.debit_amount) &&
    //             response?.data?.voucher_invoice == "Sales Account"
    //               ? "-"
    //               : Number(dt?.credit_amount) &&
    //                 response?.data?.voucher_invoice == "Purchase Account"
    //               ? "-"
    //               : ""
    //           }${(
    //             (Number(dt?.credit_amount || dt?.debit_amount) /
    //               Number(
    //                 saleAccArrRe[0]?.credit_amount ||
    //                   saleAccArrRe[0]?.debit_amount
    //               )) *
    //             100
    //           ).toFixed(2)}`,
    //   }))

    //   // let partialPaymentArr =

    //   const journalEntryDetails =
    //     response?.data?.journalEntry?.journal_entry_details || []

    //   const hasAccountId3 = journalEntryDetails.some(
    //     detail => detail?.account_id == 3
    //   )
    //   const hasAccountId4 = journalEntryDetails.some(
    //     detail => detail?.account_id == 4
    //   )

    //   const hasAccountId2 = journalEntryDetails.some(
    //     detail => detail?.account_group_id == 2
    //   )

    //   const hasAccountGroupId4 = journalEntryDetails.some(
    //     detail => detail?.ledger?.account_group_id == 4
    //   )

    //   const hasAccountGroupId17 = journalEntryDetails.some(
    //     detail => detail?.ledger?.account_group_id == 17
    //   )
    //   console.log(`hasAccountId2`, hasAccountId2)
    //   setRetentionCheck(hasAccountId2)
    //   setAdvRetentionCheck(hasAccountGroupId4)

    //   const shippingCharge = hasAccountId3
    //     ? journalEntryDetails.find(detail => detail?.account_id == 3)
    //         ?.debit_amount || 0
    //     : 0
    //   const otherCharge = hasAccountId3
    //     ? journalEntryDetails.find(detail => detail?.account_id == 4)
    //         ?.debit_amount || 0
    //     : 0

    //   setShippingCheck(
    //     Number(response?.data?.purchaseorder?.shipping_charge) != 0
    //       ? true
    //       : false
    //   )
    //   setOthersCheck(
    //     Number(response?.data?.purchaseorder?.other_charge) != 0 ? true : false
    //   )
    //   setVatCheck(response?.data?.vat != 0 ? true : false)
    //   setDiscountCheck(response?.data?.discount != 0 ? true : false)
    //   setRSelected(
    //     response?.data?.voucher_invoice == "Purchase Voucher" ||
    //       response?.data?.voucher_invoice == "Sales Voucher"
    //       ? 2
    //       : response?.data?.voucher_invoice == "Sales Account" ||
    //         response?.data?.voucher_invoice == "Purchase Account"
    //       ? 3
    //       : response?.data?.voucher_invoice == "Sales Product Invoice"
    //       ? 4
    //       : 1
    //     // response?.data?.storeHistory?.length &&
    //     //   response?.data?.storeHistory[0]?.activity == "remove"
    //     //   ? 1
    //     //   : 2
    //   )
    //   let saleSub = 0
    //   if (response?.data?.voucher_id == 13) {
    //     // const subtotal = Number(response?.data?.sub_total)
    //     const subtotal = journalEntryDetails?.[0]?.debit_amount
    //     const vatAmt =
    //       journalEntryDetails.find(
    //         detail => detail?.ledger?.account_group_id == 17
    //       )?.credit_amount || 0
    //     const advRetAmt =
    //       journalEntryDetails.find(
    //         detail => detail?.ledger?.account_group_id == 4
    //       )?.debit_amount || 0
    //     const retAmt =
    //       journalEntryDetails.find(
    //         detail => detail?.ledger?.account_group_id == 2
    //       )?.debit_amount || 0

    //     // const vatPer = Number(response?.data?.vat) / 100
    //     // const vatAmount = Number(subtotal * vatPer).toFixed(3)

    //     console.log(`subtotal subtotal`, subtotal, vatAmt, advRetAmt, retAmt)

    //     saleSub =
    //       Number(vatAmt) != 0
    //         ? Number(
    //             Number(subtotal) -
    //               Number(vatAmt) +
    //               Number(advRetAmt) +
    //               Number(retAmt)
    //           ).toFixed(desimalrange || 2)
    //         : Number(response?.data?.sale_total).toFixed(desimalrange || 2)
    //   } else if ([4, 18, 15].includes(response?.data?.voucher_id)) {
    //     // const subtotal = Number(response?.data?.sub_total)
    //     const subtotal = journalEntryDetails?.[0]?.debit_amount
    //       ? journalEntryDetails?.[0]?.debit_amount
    //       : journalEntryDetails?.[0]?.credit_amount
    //     const vatEntry = journalEntryDetails.find(
    //       detail => detail?.ledger?.account_group_id === 17
    //     )

    //     const vatAmt = vatEntry
    //       ? vatEntry.credit_amount || vatEntry.debit_amount || 0
    //       : 0
    //     // Advance return amount (account_group_id == 4)
    //     const advRetEntry = journalEntryDetails.find(
    //       detail => detail?.ledger?.account_group_id == 4
    //     )
    //     const advRetAmt = advRetEntry
    //       ? advRetEntry.debit_amount || advRetEntry.credit_amount || 0
    //       : 0

    //     // Return amount (account_group_id == 2)
    //     const retEntry = journalEntryDetails.find(
    //       detail => detail?.ledger?.account_group_id == 2
    //     )
    //     const retAmt = retEntry
    //       ? retEntry.debit_amount || retEntry.credit_amount || 0
    //       : 0

    //     // const vatPer = Number(response?.data?.vat) / 100
    //     // const vatAmount = Number(subtotal * vatPer).toFixed(3)

    //     console.log(`subtotal subtotal`, subtotal, vatAmt, advRetAmt, retAmt)

    //     saleSub =
    //       Number(vatAmt) != 0
    //         ? Number(
    //             Number(subtotal) -
    //               Number(vatAmt) +
    //               Number(advRetAmt) +
    //               Number(retAmt)
    //           ).toFixed(2)
    //         : subtotal
    //   }

    //   // const vatAmount = journalEntryDetails
    //   //   .filter(entry => entry.ledger?.account_group_id === 17)
    //   //   .map(entry => entry.credit_amount)
    //   const vatAmount = journalEntryDetails
    //     .filter(entry => entry.ledger?.account_group_id === 17)
    //     .map(entry => entry.credit_amount || entry.debit_amount || 0)

    //   const vatCalType = journalEntryDetails?.find(
    //     entry => entry.ledger?.account_group_id === 17
    //   )?.ledger?.vat_cal

    //   const vatCalAmt =
    //     vatCalType == 1
    //       ? Number(saleSub) -
    //         Number(
    //           journalEntryDetails
    //             .filter(entry => entry.ledger?.account_group_id === 2)
    //             .map(entry => entry.debit_amount) || 0
    //         ) -
    //         Number(
    //           journalEntryDetails
    //             .filter(entry => entry.ledger?.account_group_id === 4)
    //             .map(entry => entry.debit_amount) || 0,
    //           saleSub || 0
    //         )
    //       : saleSub || 0

    //   console.log(`materialDataArr materialDataArr`, materialDataArr)

    //   const costCheck =
    //     response?.data?.journalEntry?.journal_entry_details.find(
    //       entry => entry.costcenter?.id
    //     )

    //   reset({
    //     code: response?.data?.ref_number,
    //     inv_date: response?.data?.inv_date,
    //     chk_sale_total: response?.data?.sale_total || 0,
    //     cost_center_id:
    //       costCheck &&
    //       [
    //         "response?.data?.voucher_invoice",
    //         "Purchase Invoice",
    //         "Sales Invoice",
    //       ].includes(response?.data?.voucher_invoice)
    //         ? {
    //             ...costCheck,
    //             label: costCheck?.costcenter?.name,
    //             value: costCheck?.costcenter?.id,
    //           }
    //         : null,
    //     inv_num: response?.data?.inv_num
    //       ? {
    //           value: response?.data?.parent_voucher?.id,
    //           label: response?.data?.parent_voucher?.ref_number,
    //         }
    //       : null,
    //     ref_code: response?.data?.ref_code,
    //     // ref_code: response?.data?.journalEntry?.journal_entry_details?.find(
    //     //   detail => detail?.voucher_partial_payment?.length > 0
    //     // )?.voucher_partial_payment?.[0]?.code,
    //     // response?.data?.journalEntry?.journal_entry_details?.[0]
    //     //   ?.voucher_partial_payment?.[0]?.code,
    //     ref_date: response?.data?.ref_date,
    //     // ref_date: response?.data?.journalEntry?.journal_entry_details?.find(
    //     //   detail => detail?.voucher_partial_payment?.length > 0
    //     // )?.voucher_partial_payment?.[0]?.date,
    //     // response?.data?.journalEntry?.journal_entry_details?.[0]
    //     //   ?.voucher_partial_payment?.[0]?.date,
    //     retention_id: hasAccountId2
    //       ? {
    //           label: journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 2
    //           )?.ledger.name,
    //           value: journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 2
    //           )?.account_id,
    //           ...journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 2
    //           )?.ledger,
    //         }
    //       : null,
    //     adv_retention_id: hasAccountGroupId4
    //       ? {
    //           label: journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 4
    //           )?.ledger.name,
    //           value: journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 4
    //           )?.account_id,
    //           ...journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 4
    //           )?.ledger,
    //         }
    //       : null,
    //     vat_id: hasAccountGroupId17
    //       ? {
    //           label: journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 17
    //           )?.ledger.name,
    //           value: journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 17
    //           )?.account_id,
    //           ...journalEntryDetails.find(
    //             entry => entry.ledger?.account_group_id === 17
    //           )?.ledger,
    //         }
    //       : null,
    //     retention: hasAccountId2
    //       ? journalEntryDetails
    //           .filter(entry => entry.ledger?.account_group_id === 2)
    //           .map(entry => entry.debit_amount)
    //       : 0,
    //     retention_amount: getPercentRev(
    //       journalEntryDetails
    //         .filter(entry => entry.ledger?.account_group_id === 2)
    //         .map(entry => entry.debit_amount) || 0,
    //       saleSub || 0
    //     ),
    //     vat_amount: getPercentRev(vatAmount || 0, vatCalAmt || 0),
    //     adv_retention: hasAccountGroupId4
    //       ? journalEntryDetails
    //           .filter(entry => entry.ledger?.account_group_id === 4)
    //           .map(entry => entry.debit_amount)
    //       : 0,
    //     adv_retention_amount: getPercentRev(
    //       journalEntryDetails
    //         .filter(entry => entry.ledger?.account_group_id === 4)
    //         .map(entry => entry.debit_amount) || 0,
    //       saleSub || 0
    //     ),
    //     voucher_id: {
    //       label: response?.data?.voucher_type?.voucher_type,
    //       value: response?.data?.voucher_id,
    //       voucher_type: response?.data?.voucher_type?.voucher_type,
    //     },
    //     material_request_id: {
    //       label: response?.data?.purchaseorder
    //         ? response?.data?.purchaseorder?.material_request?.code
    //         : response?.data?.recipt_note?.purchase_order?.voucher_entry
    //             ?.ref_number,
    //       value: response?.data?.purchaseorder
    //         ? response?.data?.purchaseorder?.material_request?.id
    //         : response?.data?.recipt_note?.purchase_order?.voucher_entry?.id,
    //     },
    //     rfq_id: response?.data?.purchaseorder?.rfq_id
    //       ? {
    //           label: response?.data?.purchaseorder?.rfq?.code,
    //           value: response?.data?.purchaseorder?.rfq_id,
    //         }
    //       : null,
    //     manufacturing_journal_id: {
    //       label: response?.data?.manufacturing_journal?.code,
    //       value: response?.data?.manufacturing_journal?.id,
    //     },
    //     purchase_order_id_ref: {
    //       label: response?.data?.recipt_note
    //         ? response?.data?.recipt_note?.purchase_order?.voucher_entry
    //             ?.ref_number
    //         : response?.data?.purchasevoucher?.purchase_order?.voucher_entry
    //             ?.ref_number,
    //       value: response?.data?.recipt_note
    //         ? response?.data?.recipt_note?.purchase_order?.voucher_entry?.id
    //         : response?.data?.purchasevoucher?.purchase_order?.voucher_entry
    //             ?.id,
    //     },
    //     project_code: {
    //       label: response?.data?.project?.project_code,
    //       value: response?.data?.project?.id,
    //     },
    //     request_date: response?.data?.purchaseorder?.date,
    //     exp_Delivery_date: response?.data?.purchaseorder?.exp_Delivery_date,
    //     ...(response?.data?.voucher_id == 13 && { sale_unit: "Lsm" }),
    //     ...(response?.data?.voucher_id == 13 && { sale_qty: "1" }),
    //     address: response?.data?.purchaseorder?.address,
    //     narration: response?.data?.narration,
    //     po_date: response?.data?.date,
    //     discount: response?.data?.discount,
    //     net_total:
    //       response?.data?.voucher_id == 13
    //         ? journalEntryDetails?.[0]?.debit_amount
    //         : journalEntryDetails?.[0]?.credit_amount,
    //     // sale_total: response?.data?.sub_total,
    //     shipping_charge: response?.data?.purchaseorder?.shipping_charge
    //       ? response?.data?.purchaseorder?.shipping_charge
    //       : shippingCharge,
    //     other_charge: response?.data?.purchaseorder?.other_charge
    //       ? response?.data?.purchaseorder?.other_charge
    //       : otherCharge,
    //     voucher_materials: materialDataArr,
    //     voucher_purchase: materialDataArr,
    //     voucher_receipt: materialDataArr,
    //     voucher_materialout: materialDataArr,
    //     voucher_source: materialDataArr,
    //     voucher_contra: contraArr,
    //     voucher_sales_acc: saleAccArr,
    //     sub_total:
    //       response?.data?.vat != 0
    //         ? Number(saleSub).toFixed(desimalrange)
    //         : response?.data?.sub_total,
    //     sale_total: saleSub,
    //     credit_id:
    //       response?.data?.voucher_id == 13
    //         ? {
    //             label: response?.data?.debit?.name,
    //             value: response?.data?.debit?.id,
    //           }
    //         : {
    //             label: response?.data?.credit?.name,
    //             value: response?.data?.credit?.id,
    //           },
    //     debit_id:
    //       response?.data?.voucher_id == 13
    //         ? {
    //             label: response?.data?.credit?.name,
    //             value: response?.data?.credit?.id,
    //           }
    //         : {
    //             label: response?.data?.debit?.name,
    //             value: response?.data?.debit?.id,
    //           },
    //     project_ids: {
    //       label: response?.data?.project?.project_code,
    //       value: response?.data?.project?.id,
    //       id: response?.data?.project?.id,
    //       amount: response?.data?.project?.amount,
    //     },
    //     general_terms: response?.data?.purchaseorder?.general_terms
    //       ? formatTemplate(response?.data?.purchaseorder?.general_terms)
    //       : "",
    //     delivery_terms: response?.data?.purchaseorder?.delivery_terms
    //       ? formatTemplate(response?.data?.purchaseorder?.delivery_terms)
    //       : "",
    //   })
    // }

    const fetchEditData = async id => {
      const response = await fetchFinanceVoucherSingle(id)
      console.log(`response --`, response)
      const params = {
        // id: response?.data?.id,
        // voucher_id: response?.data?.voucher_id,
        // with_journal:
        //   [1, 3, 6, 7, 21].includes(Number(response?.data?.voucher_id)) ||
        //   ([13, 15, 4, 18].includes(Number(response?.data?.voucher_id)) &&
        //     (response?.data?.voucher_invoice == "Purchase Voucher" ||
        //       response?.data?.voucher_invoice == "Sales Voucher" ||
        //       response?.data?.voucher_invoice == "Sales Account" ||
        //       response?.data?.voucher_invoice == "Purchase Account"))
        //     ? 1
        //     : 0,
        // with_journal_details:
        //   [1, 3, 6, 7, 21].includes(Number(response?.data?.voucher_id)) ||
        //   ([13, 15, 4, 18].includes(Number(response?.data?.voucher_id)) &&
        //     (response?.data?.voucher_invoice == "Purchase Voucher" ||
        //       response?.data?.voucher_invoice == "Sales Voucher" ||
        //       response?.data?.voucher_invoice == "Sales Account" ||
        //       response?.data?.voucher_invoice == "Purchase Account"))
        //     ? 1
        //     : 0,
        with_journal_details_partial:
          [1, 3, 6, 7, 21].includes(Number(response?.data?.voucher_id)) ||
          ([13, 15, 4, 18].includes(Number(response?.data?.voucher_id)) &&
            (response?.data?.voucher_invoice == "Purchase Voucher" ||
              response?.data?.voucher_invoice == "Sales Voucher" ||
              response?.data?.voucher_invoice == "Sales Account" ||
              response?.data?.voucher_invoice == "Purchase Account"))
            ? 1
            : 0,
        // with_journal_details_bank:
        //   [1, 3, 6, 7, 21].includes(Number(response?.data?.voucher_id)) ||
        //   ([13, 15, 4, 18].includes(Number(response?.data?.voucher_id)) &&
        //     (response?.data?.voucher_invoice == "Purchase Voucher" ||
        //       response?.data?.voucher_invoice == "Sales Voucher" ||
        //       response?.data?.voucher_invoice == "Sales Account" ||
        //       response?.data?.voucher_invoice == "Purchase Account"))
        //     ? 1
        //     : 0,
        // with_journal_details_acc_groups:
        //   [1, 3, 6, 7, 21].includes(Number(response?.data?.voucher_id)) ||
        //   ([13, 15, 4, 18].includes(Number(response?.data?.voucher_id)) &&
        //     (response?.data?.voucher_invoice == "Purchase Voucher" ||
        //       response?.data?.voucher_invoice == "Sales Voucher" ||
        //       response?.data?.voucher_invoice == "Sales Account" ||
        //       response?.data?.voucher_invoice == "Purchase Account"))
        //     ? 1
        //     : 0,
        with_purchase_order: response?.data?.voucher_id == 16 ? 1 : 0,
        with_purchase_voucher:
          [4, 15].includes(response?.data?.voucher_id) &&
          response?.data?.voucher_invoice == "Purchase Invoice"
            ? 1
            : 0,
        with_sales_voucher:
          [13, 18].includes(response?.data?.voucher_id) &&
          response?.data?.voucher_invoice == "Sales Product Invoice"
            ? 1
            : 0,
        with_details:
          [15].includes(response?.data?.voucher_id) &&
          response?.data?.voucher_invoice == "Purchase Account"
            ? 1
            : 0,
      }

      // const je = await fetchFinanceJournal(`?voucher_id=${id}`)
      // console.log(`je --`, je)

      handleFetchVouchers(params)
    }

    if (editId) {
      fetchEditData(editId)
    }
    if (!editId) dispatch(changeSidebarSize("sm"))
  }, [editId])

  const handleFetchVouchers = async params => {
    const response = await fetchFinanceVoucherSingleNew({ id: editId, params })
    let materialDataArr
    if (
      response?.data?.voucher_id == 15 &&
      response?.data?.voucher_invoice == "Purchase Invoice"
    ) {
      materialDataArr = response?.data?.purchasevoucher?.materials?.map(dt => ({
        id: dt?.id,
        product_id: {
          label: dt?.product?.product_code,
          value: dt?.product?.id,
        },
        po_material_id: dt?.po_material_id,
        unit: {
          label: dt?.product?.unit?.unit_code,
          value: dt?.product?.unit?.id,
        },
        description: dt?.product?.description,
        already_created:
          Number(dt?.used_quantity || 0) - Number(dt?.voucher_quantity),
        ordered_quantity:
          dt?.voucher_from == 1 ? dt?.grn_quantity : dt?.po_quantity,
        qnt: dt?.voucher_quantity,
        unit_price: dt?.unit_price,
        sub_price: Number(dt?.voucher_quantity) * Number(dt?.unit_price),
      }))
    } else if (
      response?.data?.voucher_id == 4 &&
      response?.data?.voucher_invoice == "Purchase Invoice"
    ) {
      materialDataArr = response?.data?.purchasevoucher?.materials?.map(dt => ({
        id: dt?.id,
        product_id: {
          label: dt?.product?.product_code,
          value: dt?.product?.id,
        },
        unit: {
          label: dt?.product?.unit?.unit_code,
          value: dt?.product?.unit?.id,
        },
        description: dt?.product?.description,
        already_created: dt?.used_quantity || 0,
        ordered_quantity:
          dt?.voucher_from == 1 ? dt?.grn_quantity : dt?.po_quantity,
        qnt: dt?.voucher_quantity,
        unit_price: dt?.unit_price,
        sub_price: Number(dt?.voucher_quantity) * Number(dt?.unit_price),
      }))
    } else if (response?.data?.voucher_id == 16) {
      materialDataArr = response?.data?.purchaseorder?.materials?.map(dt => ({
        id: dt?.id,
        product_id: {
          label: dt?.product?.product_code,
          value: dt?.product?.id,
        },
        unit: {
          label: dt?.product?.unit?.unit_code,
          value: dt?.product?.unit?.id,
        },
        description: dt?.product?.description,
        qnt: dt?.po_quantity,
        unit_price: dt?.unit_price,
        sub_price: Number(dt?.po_quantity) * Number(dt?.unit_price),
      }))
    } else if (
      [13, 18].includes(response?.data?.voucher_id) &&
      response?.data?.voucher_invoice == "Sales Product Invoice"
    ) {
      const chkMap =
        response?.data?.voucher_id == 13
          ? response?.data?.salesvoucher
          : response?.data?.salesvoucher
      materialDataArr = chkMap?.materials?.map(dt => ({
        id: dt?.id,
        product_id: {
          label: dt?.product?.product_code,
          value: dt?.product?.id,
        },
        unit: {
          label: dt?.product?.unit?.unit_code,
          value: dt?.product?.unit?.id,
        },
        description: dt?.product?.description,
        qnt: Number(
          response?.data?.voucher_id == 13 ? dt?.so_quantity : dt?.so_quantity
        ).toFixed(desimalrange || 2),
        unit_price: Number(dt?.unit_price).toFixed(desimalrange || 2),
        sub_price: Number(
          Number(
            response?.data?.voucher_id == 13 ? dt?.so_quantity : dt?.so_quantity
          ) * Number(dt?.unit_price)
        ).toFixed(desimalrange || 2),
      }))
    } else if (response?.data?.voucher_id == 7) {
      materialDataArr = response?.data?.grns?.materials?.map(dt => ({
        id: dt?.id,
        product_id: {
          label: dt?.product?.product_code,
          value: dt?.product?.id,
        },
        unit: {
          label: dt?.product?.unit?.unit_code,
          value: dt?.product?.unit?.id,
        },
        description: dt?.product?.description,
        po_quantity: dt?.po_quantity,
        qnt: dt?.grn_quantity,
        unit_price: dt?.unit_price,
        sub_price: Number(dt?.po_quantity) * Number(dt?.unit_price),
      }))
    } else if (response?.data?.voucher_id == 11) {
      materialDataArr = response?.data?.material_out_voucher?.items?.map(
        dt => ({
          id: dt?.id,
          product_id: {
            label: dt?.material?.product_code,
            value: dt?.material?.id,
          },
          description: dt?.material?.description,
          qnt: dt?.quantity,
        })
      )
    } else if (response?.data?.voucher_id == 12) {
      materialDataArr = response?.data?.storeHistory?.map(dt => ({
        id: dt?.id,
        material_id: {
          label: dt?.product_id?.product_code,
          value: dt?.product_id?.id,
        },
        rate: dt?.rate,
        qnt: dt?.quantity,
        amount: Number(dt?.rate) * Number(dt?.quantity),
      }))
    } else {
      materialDataArr = response?.data?.details?.map(dt => ({
        product_id: {
          label: dt?.product?.product_code,
          value: dt?.product?.id,
        },
        description: dt?.product?.description,
        qnt: dt?.qnt,
        unit_price: dt?.unit_price,
      }))
    }
    let contraArr = response?.data?.journalEntry?.journal_entry_details?.map(
      dt => ({
        nature: {
          label: Number(dt?.debit_amount) > 0 ? "Dr" : "Cr",
          value: Number(dt?.debit_amount) > 0 ? "debit" : "credit",
        },
        account_id: {
          label: dt?.ledger_name,
          value: dt?.ledger_id,
          ...dt,
        },
        debit: Number(dt?.debit_amount),
        credit: Number(dt?.credit_amount),
        cost_center_id: dt?.cost_center_id
          ? {
              ...dt?.costcenter,
              label: dt?.costcenter?.name,
              value: dt?.costcenter?.id,
            }
          : null,
        transaction_type: dt?.transaction_type?.id
          ? {
              label: dt?.transaction_type?.label,
              value: dt?.transaction_type?.id,
            }
          : null,
        // voucher_id:
        partial_payments: dt?.voucher_partial_payment?.map(partial => ({
          id: partial?.id,
          amount: partial?.amount,
          chk: dt?.id,
          nature: {
            value: partial?.credit_debit,
            label: partial?.credit_debit == "debit" ? "Dr" : "Cr",
          },
          code: partial?.code,
          ref_id: {
            value: partial?.ref_id,
            label:
              partial?.ref_id == 1
                ? "Advance"
                : partial?.ref_id == 2
                ? "Against Ref"
                : "New Ref",
          },
          date: partial?.date,
          bill_date: response?.data?.ref_date
            ? response?.data?.ref_date
            : response?.data?.date,
          parent_ledger_id: partial?.parent_ledger_id,
          ...(partial?.parent_voucher_entry_id && {
            voucher_id: partial?.parent_voucher_entry_id,
          }),
        })),
        cost_center_id: dt?.costcenter?.id
          ? {
              label: dt?.costcenter?.name,
              value: dt?.costcenter?.id,
              ...dt?.costcenter,
            }
          : null,
        transaction_type: dt?.transaction_type?.id
          ? {
              label: dt?.transaction_type?.label,
              value: dt?.transaction_type?.id,
              ...dt?.transaction_type,
            }
          : null,
        ...(dt?.bank_payments?.length && {
          bank_date: moment(dt?.bank_payments[0]?.date).format("DD-MM-YYYY"),
          instrument_no: dt?.bank_payments[0]?.instrument_no,
          instrument_date: moment(dt?.bank_payments[0]?.instrument_date).format(
            "DD-MM-YYYY"
          ),
          bank_amount: dt?.bank_payments[0]?.amount,
          remarks: dt?.bank_payments[0]?.remarks,
          payment_type_id: dt?.bank_payments[0]?.payment_type_id
            ? {
                label: dt?.bank_payments[0]?.payment_type_value?.value,
                value: dt?.bank_payments[0]?.payment_type_value?.id,
              }
            : null,
          currency: dt?.bank_payments[0]?.currency
            ? {
                label: dt?.bank_payments[0]?.currency_value?.value,
                value: dt?.bank_payments[0]?.currency_value?.id,
              }
            : null,
        }),
      })
    )

    let saleAccArrRe =
      response?.data?.journalEntry?.journal_entry_details?.slice(0, -1)

    let saleAccArr = saleAccArrRe?.map((dt, index) => ({
      account_id: {
        label: dt?.ledger_name,
        value: dt?.ledger_id,
        ...dt,
      },
      amount:
        Number(dt?.credit_amount) &&
        response?.data?.voucher_invoice == "Sales Account"
          ? Number(dt?.credit_amount)
          : Number(dt?.debit_amount) &&
            response?.data?.voucher_invoice == "Sales Account"
          ? -Number(dt?.debit_amount)
          : Number(dt?.debit_amount) &&
            response?.data?.voucher_invoice == "Purchase Account"
          ? Number(dt?.debit_amount)
          : -Number(dt?.credit_amount),

      rate:
        index === 0
          ? ""
          : `${
              Number(dt?.debit_amount) &&
              response?.data?.voucher_invoice == "Sales Account"
                ? "-"
                : Number(dt?.credit_amount) &&
                  response?.data?.voucher_invoice == "Purchase Account"
                ? "-"
                : ""
            }${(
              (Number(dt?.credit_amount || dt?.debit_amount) /
                Number(
                  saleAccArrRe[0]?.credit_amount ||
                    saleAccArrRe[0]?.debit_amount
                )) *
              100
            ).toFixed(2)}`,
    }))

    // let partialPaymentArr =

    const journalEntryDetails =
      response?.data?.journalEntry?.journal_entry_details || []

    const hasAccountId3 = journalEntryDetails.some(
      detail => detail?.account_id == 3
    )
    const hasAccountId4 = journalEntryDetails.some(
      detail => detail?.account_id == 4
    )

    const hasAccountId2 = journalEntryDetails.some(
      detail => detail?.account_group_id == 2
    )

    const hasAccountGroupId4 = journalEntryDetails.some(
      detail => detail?.account_group_id == 4
    )

    const hasAccountGroupId17 = journalEntryDetails.some(
      detail => detail?.account_group_id == 17
    )
    console.log(`hasAccountId2`, hasAccountId2)
    setRetentionCheck(hasAccountId2)
    setAdvRetentionCheck(hasAccountGroupId4)

    const shippingCharge = hasAccountId3
      ? journalEntryDetails.find(detail => detail?.account_id == 3)
          ?.debit_amount || 0
      : 0
    const otherCharge = hasAccountId3
      ? journalEntryDetails.find(detail => detail?.account_id == 4)
          ?.debit_amount || 0
      : 0

    setShippingCheck(
      Number(response?.data?.purchaseorder?.shipping_charge) != 0 ? true : false
    )
    setOthersCheck(
      Number(response?.data?.purchaseorder?.other_charge) != 0 ? true : false
    )
    setVatCheck(response?.data?.vat != 0 ? true : false)
    setDiscountCheck(response?.data?.discount != 0 ? true : false)
    setRSelected(
      response?.data?.voucher_invoice == "Purchase Voucher" ||
        response?.data?.voucher_invoice == "Sales Voucher"
        ? 2
        : response?.data?.voucher_invoice == "Sales Account" ||
          response?.data?.voucher_invoice == "Purchase Account"
        ? 3
        : response?.data?.voucher_invoice == "Sales Product Invoice"
        ? 4
        : 1
      // response?.data?.storeHistory?.length &&
      //   response?.data?.storeHistory[0]?.activity == "remove"
      //   ? 1
      //   : 2
    )
    let saleSub = 0
    if (response?.data?.voucher_id == 13) {
      // const subtotal = Number(response?.data?.sub_total)
      const subtotal = journalEntryDetails?.[0]?.debit_amount
      const vatAmt =
        journalEntryDetails.find(detail => detail?.account_group_id == 17)
          ?.credit_amount || 0
      const advRetAmt =
        journalEntryDetails.find(detail => detail?.account_group_id == 4)
          ?.debit_amount || 0
      const retAmt =
        journalEntryDetails.find(detail => detail?.account_group_id == 2)
          ?.debit_amount || 0

      // const vatPer = Number(response?.data?.vat) / 100
      // const vatAmount = Number(subtotal * vatPer).toFixed(3)

      console.log(`subtotal subtotal`, subtotal, vatAmt, advRetAmt, retAmt)

      saleSub =
        Number(vatAmt) != 0
          ? Number(
              Number(subtotal) -
                Number(vatAmt) +
                Number(advRetAmt) +
                Number(retAmt)
            ).toFixed(desimalrange || 2)
          : Number(response?.data?.sale_total).toFixed(desimalrange || 2)
    } else if ([4, 18, 15].includes(response?.data?.voucher_id)) {
      // const subtotal = Number(response?.data?.sub_total)
      const subtotal = journalEntryDetails?.[0]?.debit_amount
        ? journalEntryDetails?.[0]?.debit_amount
        : journalEntryDetails?.[0]?.credit_amount
      const vatEntry = journalEntryDetails.find(
        detail => detail?.account_group_id === 17
      )

      const vatAmt = vatEntry
        ? vatEntry.credit_amount || vatEntry.debit_amount || 0
        : 0
      // Advance return amount (account_group_id == 4)
      const advRetEntry = journalEntryDetails.find(
        detail => detail?.account_group_id == 4
      )
      const advRetAmt = advRetEntry
        ? advRetEntry.debit_amount || advRetEntry.credit_amount || 0
        : 0

      // Return amount (account_group_id == 2)
      const retEntry = journalEntryDetails.find(
        detail => detail?.account_group_id == 2
      )
      const retAmt = retEntry
        ? retEntry.debit_amount || retEntry.credit_amount || 0
        : 0

      // const vatPer = Number(response?.data?.vat) / 100
      // const vatAmount = Number(subtotal * vatPer).toFixed(3)

      console.log(`subtotal subtotal`, subtotal, vatAmt, advRetAmt, retAmt)

      saleSub =
        Number(vatAmt) != 0
          ? Number(
              Number(subtotal) -
                Number(vatAmt) +
                Number(advRetAmt) +
                Number(retAmt)
            ).toFixed(2)
          : subtotal
    }

    // const vatAmount = journalEntryDetails
    //   .filter(entry => entry.ledger?.account_group_id === 17)
    //   .map(entry => entry.credit_amount)
    const vatAmount = journalEntryDetails
      .filter(entry => entry.account_group_id === 17)
      .map(entry => entry.credit_amount || entry.debit_amount || 0)

    const vatCalType = journalEntryDetails?.find(
      entry => entry.account_group_id === 17
    )?.ledger?.vat_cal

    const vatCalAmt =
      vatCalType == 1
        ? Number(saleSub) -
          Number(
            journalEntryDetails
              .filter(entry => entry.account_group_id === 2)
              .map(entry => entry.debit_amount) || 0
          ) -
          Number(
            journalEntryDetails
              .filter(entry => entry.account_group_id === 4)
              .map(entry => entry.debit_amount) || 0,
            saleSub || 0
          )
        : saleSub || 0

    console.log(`materialDataArr materialDataArr`, materialDataArr)

    const costCheck = response?.data?.journalEntry?.journal_entry_details.find(
      entry => entry.costcenter?.id
    )
    reset({
      code: response?.data?.ref_number,
      inv_date: response?.data?.inv_date,
      chk_sale_total: response?.data?.sale_total || 0,
      voucher_id: {
        label: response?.data?.voucherType,
        value: response?.data?.voucher_id,
        voucher_type: response?.data?.voucherType,
      },
      cost_center_id:
        costCheck &&
        [
          "response?.data?.voucher_invoice",
          "Purchase Invoice",
          "Sales Invoice",
        ].includes(response?.data?.voucher_invoice)
          ? {
              ...costCheck,
              label: costCheck?.costcenter?.name,
              value: costCheck?.costcenter?.id,
            }
          : null,
      inv_num: response?.data?.inv_num
        ? {
            value: response?.data?.parent_voucher?.id,
            label: response?.data?.parent_voucher?.ref_number,
          }
        : null,
      ref_code: response?.data?.ref_code,
      // ref_code: response?.data?.journalEntry?.journal_entry_details?.find(
      //   detail => detail?.voucher_partial_payment?.length > 0
      // )?.voucher_partial_payment?.[0]?.code,
      // response?.data?.journalEntry?.journal_entry_details?.[0]
      //   ?.voucher_partial_payment?.[0]?.code,
      ref_date: response?.data?.ref_date,
      // ref_date: response?.data?.journalEntry?.journal_entry_details?.find(
      //   detail => detail?.voucher_partial_payment?.length > 0
      // )?.voucher_partial_payment?.[0]?.date,
      // response?.data?.journalEntry?.journal_entry_details?.[0]
      //   ?.voucher_partial_payment?.[0]?.date,
      retention_id: hasAccountId2
        ? {
            label: journalEntryDetails.find(
              entry => entry.account_group_id === 2
            )?.ledger_name,
            value: journalEntryDetails.find(
              entry => entry.account_group_id === 2
            )?.account_id,
            ...journalEntryDetails.find(entry => entry.account_group_id === 2)
              ?.ledger,
          }
        : null,
      adv_retention_id: hasAccountGroupId4
        ? {
            label: journalEntryDetails.find(
              entry => entry.account_group_id === 4
            )?.ledger_name,
            value: journalEntryDetails.find(
              entry => entry.account_group_id === 4
            )?.account_id,
            ...journalEntryDetails.find(entry => entry.account_group_id === 4)
              ?.ledger,
          }
        : null,
      vat_id: hasAccountGroupId17
        ? {
            label: journalEntryDetails.find(
              entry => entry.account_group_id === 17
            )?.ledger_name,
            value: journalEntryDetails.find(
              entry => entry.account_group_id === 17
            )?.account_id,
            ...journalEntryDetails.find(entry => entry.account_group_id === 17)
              ?.ledger,
          }
        : null,
      retention: hasAccountId2
        ? journalEntryDetails
            .filter(entry => entry.account_group_id === 2)
            .map(entry => entry.debit_amount)
        : 0,
      retention_amount: getPercentRev(
        journalEntryDetails
          .filter(entry => entry.account_group_id === 2)
          .map(entry => entry.debit_amount) || 0,
        saleSub || 0
      ),
      vat_amount: getPercentRev(vatAmount || 0, vatCalAmt || 0),
      adv_retention: hasAccountGroupId4
        ? journalEntryDetails
            .filter(entry => entry.account_group_id === 4)
            .map(entry => entry.debit_amount)
        : 0,
      adv_retention_amount: getPercentRev(
        journalEntryDetails
          .filter(entry => entry.account_group_id === 4)
          .map(entry => entry.debit_amount) || 0,
        saleSub || 0
      ),

      material_request_id: {
        label: response?.data?.purchaseorder
          ? response?.data?.purchaseorder?.material_request?.code
          : response?.data?.recipt_note?.purchase_order?.voucher_entry
              ?.ref_number,
        value: response?.data?.purchaseorder
          ? response?.data?.purchaseorder?.material_request?.id
          : response?.data?.recipt_note?.purchase_order?.voucher_entry?.id,
      },
      rfq_id: response?.data?.purchaseorder?.rfq_id
        ? {
            label: response?.data?.purchaseorder?.rfq?.code,
            value: response?.data?.purchaseorder?.rfq_id,
          }
        : null,
      manufacturing_journal_id: {
        label: response?.data?.manufacturing_journal?.code,
        value: response?.data?.manufacturing_journal?.id,
      },
      purchase_order_id_ref: {
        label: response?.data?.recipt_note
          ? response?.data?.recipt_note?.purchase_order?.voucher_entry
              ?.ref_number
          : response?.data?.purchasevoucher?.purchase_order?.voucher_entry
              ?.ref_number,
        value: response?.data?.recipt_note
          ? response?.data?.recipt_note?.purchase_order?.voucher_entry?.id
          : response?.data?.purchasevoucher?.purchase_order?.voucher_entry?.id,
      },
      project_code: {
        label: response?.data?.project?.project_code,
        value: response?.data?.project?.id,
      },
      request_date: response?.data?.purchaseorder?.date,
      exp_Delivery_date: response?.data?.purchaseorder?.exp_Delivery_date,
      ...(response?.data?.voucher_id == 13 && { sale_unit: "Lsm" }),
      ...(response?.data?.voucher_id == 13 && { sale_qty: "1" }),
      address: response?.data?.purchaseorder?.address,
      narration: response?.data?.narration,
      po_date: response?.data?.date,
      discount: response?.data?.discount,
      net_total:
        response?.data?.voucher_id == 13
          ? journalEntryDetails?.[0]?.debit_amount
          : journalEntryDetails?.[0]?.credit_amount,
      // sale_total: response?.data?.sub_total,
      shipping_charge: response?.data?.purchaseorder?.shipping_charge
        ? response?.data?.purchaseorder?.shipping_charge
        : shippingCharge,
      other_charge: response?.data?.purchaseorder?.other_charge
        ? response?.data?.purchaseorder?.other_charge
        : otherCharge,
      voucher_materials: materialDataArr,
      voucher_purchase: materialDataArr,
      voucher_receipt: materialDataArr,
      voucher_materialout: materialDataArr,
      voucher_source: materialDataArr,
      voucher_contra: contraArr,
      voucher_sales_acc: saleAccArr,
      sub_total:
        response?.data?.vat != 0
          ? Number(saleSub).toFixed(desimalrange)
          : response?.data?.sub_total,
      sale_total: saleSub,
      credit_id:
        response?.data?.voucher_id == 13
          ? {
              label: response?.data?.debit?.name,
              value: response?.data?.debit?.id,
            }
          : {
              label: response?.data?.credit?.name,
              value: response?.data?.credit?.id,
            },
      debit_id:
        response?.data?.voucher_id == 13
          ? {
              label: response?.data?.credit?.name,
              value: response?.data?.credit?.id,
            }
          : {
              label: response?.data?.debit?.name,
              value: response?.data?.debit?.id,
            },
      project_ids: {
        label: response?.data?.project?.project_code,
        value: response?.data?.project?.id,
        id: response?.data?.project?.id,
        amount: response?.data?.project?.amount,
      },
      general_terms: response?.data?.purchaseorder?.general_terms
        ? formatTemplate(response?.data?.purchaseorder?.general_terms)
        : "",
      delivery_terms: response?.data?.purchaseorder?.delivery_terms
        ? formatTemplate(response?.data?.purchaseorder?.delivery_terms)
        : "",
    })
  }

  // const handleFetchVouchers = async params => {
  //   const response = await fetchFinanceVoucherSingleNew({id: params.id, params})
  //   console.log(`response handleFetchVouchers`, response)
  // }

  const [refreshDropdown, setRefreshDropdown] = useState(false)

  const handleLedgerCreationSuccess = (newLedger, name) => {
    setRefreshDropdown(prev => !prev) // Refresh dropdown
    console.log(`newLedger`, newLedger, name)

    setValue(name, {
      label: newLedger?.data?.name,
      value: newLedger?.data?.id,
      ...newLedger?.data,
    })
    clearErrors(name)
    setValue("vat_amount", newLedger?.data?.vat_per || 0)

    let parts = []
    if (name.includes("voucher_contra") || name.includes("voucher_sales_acc")) {
      parts = name.split(".")
      if (parts[0] == "voucher_contra") {
        handleType(newLedger?.data, parts[1])
      }
      if (
        parts[0] == "voucher_sales_acc" &&
        newLedger?.data?.account_group_id == 17
      ) {
        setValue(
          `${parts[0]}.${parts[1]}.rate`,
          Number(newLedger?.data?.vat_per || 0)
        )
        handleRateChange(Number(newLedger?.data?.vat_per || 0), parts[1])
      }
      console.log(`parts`, watch(`${parts[0]}.${parts[1]}`))
    }
  }

  console.log(`rselected`, rSelected)

  const handleEditBankDetails = i => {
    const datas = getValues()

    console.log(`datas?.voucher_contra?.[i]`, datas?.voucher_contra[i])
    reset({
      ...datas,
      bank_date: datas?.voucher_contra[i]?.bank_date,
      instrument_no: datas?.voucher_contra[i]?.instrument_no,
      instrument_date: datas?.voucher_contra[i]?.instrument_date,
      bank_amount: Number(datas?.voucher_contra[i]?.bank_amount).toFixed(
        desimalrange || 2
      ),
      remarks: datas?.voucher_contra[i]?.remarks,
      payment_type_id: datas?.voucher_contra[i]?.payment_type_id,
      currency: datas?.voucher_contra[i]?.currency,
    })
  }

  const handleEditPartial = i => {
    const datas = getValues()
    console.log(`datas?.voucher_contra?.[i]`, datas?.voucher_contra?.[i], datas)

    const partialPayArr =
      datas?.voucher_contra?.[i]?.partial_payments ||
      [
        // {
        //   nature: datas?.voucher_contra?.[i]?.nature,
        //   amount:
        //     datas?.voucher_contra?.[i]?.debit != 0
        //       ? datas?.voucher_contra?.[i]?.debit
        //       : datas?.voucher_contra?.[i]?.credit,
        //   date: moment(now, "DD-MM-MMMM").toDate(),
        //   code: incrementCode(datas?.code),
        //   voucher_id: null,
        //   // partial_payments: [],
        // },
      ]
    console.log(
      `partialPayArr`,
      datas?.ref_date
        ? moment(datas?.ref_date).format("DD-MM-YYYY")
        : moment(datas?.po_date).format("DD-MM-YYYY")
    )

    const partialPayArrFiltered = partialPayArr?.map((dt, index) => ({
      nature: dt?.nature,
      ref_id: dt?.ref_id,
      code: dt?.code,
      parent_ledger_id: dt?.parent_ledger_id,
      // date: moment(dt?.date).format("DD-MM-YYYY"),
      amount: dt?.amount,
      chk: i,
      voucher_id: dt?.voucher_id,
      date: dt?.date,
      bill_date: dt?.bill_date,
    }))
    setViewData({
      voucher_type:
        datas?.voucher_contra?.[i]?.account_id?.account_group_id == 13
          ? 13
          : 15,
      ledger_id: datas?.voucher_contra?.[i]?.account_id?.id,
      currIndex: i,
    })
    setModal(true)

    reset({
      ...datas,
      voucher_contra_partial_pay: partialPayArrFiltered?.length
        ? partialPayArrFiltered
        : contraPartialListAppend({
            account_id: null,
            debit: 0,
            credit: 0,
            chk: viewData?.currIndex,
            ref_id: { label: "New Ref", value: 3 },
            date: moment(now, "DD-MM-YYYY").toDate(),
            amount: 0,
            code: incrementCode(watch("code")),
            nature:
              watch("voucher_id")?.value == 13 ||
              watch("voucher_id")?.parent_id == 13
                ? { label: "Dr", value: "debit" }
                : watch("voucher_id")?.value == 15 ||
                  watch("voucher_id")?.parent_id == 15
                ? { label: "Cr", value: "credit" }
                : watch(`voucher_contra.${i}.nature`),
          }),
    })
    console.log(
      `handleEditPartial`,
      partialPayArrFiltered?.length
        ? partialPayArrFiltered
        : contraPartialListAppend({
            account_id: null,
            debit: 0,
            credit: 0,
            chk: viewData?.currIndex,
            // amount: ,
            code: incrementCode(watch("code")),
            nature:
              watch("voucher_id")?.value == 13 ||
              watch("voucher_id")?.parent_id == 13
                ? { label: "Dr", value: "debit" }
                : watch("voucher_id")?.value == 15 ||
                  watch("voucher_id")?.parent_id == 15
                ? { label: "Cr", value: "credit" }
                : watch(`voucher_contra.${i}.nature`),
          })
    )
  }

  const {
    fields: materialFields,
    append: materialListAppend,
    remove: materialListRemove,
  } = useFieldArray({
    control,
    name: "voucher_materials",
  })
  const {
    fields: purchaseFields,
    append: purchaseListAppend,
    remove: purchaseListRemove,
  } = useFieldArray({
    control,
    name: "voucher_purchase",
  })

  const {
    fields: receiptFields,
    append: receiptListAppend,
    remove: receiptListRemove,
  } = useFieldArray({
    control,
    name: "voucher_receipt",
  })

  const {
    fields: materialOutFields,
    append: materialOutListAppend,
    remove: materialOutListRemove,
  } = useFieldArray({
    control,
    name: "voucher_materialout",
  })

  const {
    fields: stockTransferSourceFields,
    append: stockTransferSourceAppend,
    remove: stockTransferSourceRemove,
  } = useFieldArray({
    control,
    name: "voucher_source",
  })

  const {
    fields: stockTransferDestinationFields,
    append: stockTransferDestinationAppend,
    remove: stockTransferDestinationRemove,
  } = useFieldArray({
    control,
    name: "voucher_destination",
  })

  const {
    fields: contraFields,
    append: contraListAppend,
    remove: contraListRemove,
  } = useFieldArray({
    control,
    name: "voucher_contra",
  })
  const {
    fields: salesAccFields,
    append: salesAccAppend,
    remove: salesAccRemove,
  } = useFieldArray({
    control,
    name: "voucher_sales_acc",
  })

  const {
    fields: contraFieldsPartial,
    append: contraPartialListAppend,
    remove: contraPartialListRemove,
  } = useFieldArray({
    control,
    name: "voucher_contra_partial_pay",
  })

  const handleModalData = (i, onlyClose = false) => {
    const data = getValues()

    const chkDataName =
      data?.voucher_contra?.[i]?.nature?.label == "Dr" ? "credit" : "debit"
    const chkDataOtrName =
      data?.voucher_contra?.[i]?.nature?.label == "Dr" ? "debit" : "credit"

    const currAmount = chkDataName == data?.voucher_contra?.[i]

    console.log(`currAmount`, chkDataName, chkDataOtrName, data)

    const chkAmount = Number(
      (data?.voucher_contra || [])
        .reduce((sum, item) => {
          const value = parseFloat(item?.[chkDataName])
          return sum + (isNaN(value) ? 0 : value)
        }, 0)
        .toFixed(desimalrange || 2)
    )

    // const chkAmount = data?.voucher_contra.reduce(
    //   (sum, item) => sum + parseFloat(item?.[chkDataName] || 0),
    //   0
    // )
    const chkSameAmount = data?.voucher_contra.reduce(
      (sum, item) => sum + parseFloat(item?.[chkDataOtrName] || 0),
      0
    )

    const currAmt = data?.voucher_contra?.[i]?.[chkDataOtrName]

    console.log(`chkSameAmount`, chkSameAmount, currAmt, chkAmount)

    const totalAmount = data?.voucher_contra_partial_pay?.reduce(
      (sum, item) => sum + parseFloat(item.amount || 0),
      0
    )

    console.log(`ChkModal`, i, chkAmount, totalAmount, currAmt)
    // if (i != 0 && Number(currAmt) < Number(totalAmount)) {
    // if (Number(currAmt) < Number(totalAmount)) {
    //   toastError(`Amount cannot be greater than ${currAmt}`)
    //   return
    // } else if (Number(currAmt) > Number(totalAmount) ) {
    //   // if (Number(chkAmount) > Number(totalAmount)) {
    //   contraPartialListAppend({
    //     account_id: data?.credit_id?.value,
    //     debit: 0,
    //     credit: 0,
    //     chk: viewData?.currIndex,
    //     code: watch("code"),
    //     // incrementCode(
    //     //   data?.voucher_contra_partial_pay[
    //     //     data?.voucher_contra_partial_pay?.length - 1
    //     //   ]?.code
    //     //     ? data?.voucher_contra_partial_pay[
    //     //         data?.voucher_contra_partial_pay?.length - 1
    //     //       ]?.code
    //     //     : watch("code")
    //     // ),
    //     // code: incrementCode(
    //     //   data?.voucher_contra_partial_pay[
    //     //     data?.voucher_contra_partial_pay?.length - 1
    //     //   ]?.code
    //     //     ? data?.voucher_contra_partial_pay[
    //     //         data?.voucher_contra_partial_pay?.length - 1
    //     //       ]?.code
    //     //     : watch("code")
    //     // ),
    //     amount: Number(Number(currAmt) - Number(totalAmount)).toFixed(
    //       desimalrange
    //     ),
    //     nature: data?.voucher_contra[i]?.nature,
    //     date: moment(now, "DD-MM-MMMM").toDate(),
    //     ref_id: {
    //       label: "New Ref",
    //       value: 3,
    //     },
    //   })
    //   return
    //   // }
    // }

    if (!data?.voucher_contra?.[i]) {
      console.error(`Invalid index: ${i}`)
      return
    }

    // Replace partial_payments with the new array
    // const filtered = Array.isArray(data.voucher_contra_partial_pay)
    //   ? data.voucher_contra_partial_pay
    //   :
    //     []

    const filteredRaw = Array.isArray(data.voucher_contra_partial_pay)
      ? data.voucher_contra_partial_pay
      : []

    const mergeSameVoucherIds = arr => {
      const grouped = {}
      const result = []

      arr.forEach(item => {
        const vid = item.voucher_id
        if (vid !== undefined && vid !== null) {
          if (!grouped[vid]) {
            grouped[vid] = { ...item, amount: parseFloat(item.amount) }
          } else {
            grouped[vid].amount += parseFloat(item.amount)
          }
        } else {
          result.push(item)
        }
      })

      const merged = Object.values(grouped).map(item => ({
        ...item,
        amount: Number(item.amount).toFixed(desimalrange),
      }))

      return [...result, ...merged]
    }

    const filtered = mergeSameVoucherIds(filteredRaw)

    console.log(`filtered`, filtered)

    data.voucher_contra[i].partial_payments = filtered

    const totalamount = filtered.reduce(
      (sum, item) => sum + parseFloat(item.amount || 0),
      0
    )

    const updatedData = {
      ...data,
      voucher_contra: data.voucher_contra.map((item, idx) => {
        if (idx === i) {
          const updatedItem = { ...item, partial_payments: filtered }
          console.log("Updating index:", idx, "with item:", updatedItem)
          return updatedItem
        }
        return item
      }),
    }

    reset(updatedData)

    // Reset the form with the updated data
    // reset({
    //   ...data,
    //   voucher_contra: data.voucher_contra.map((item, idx) =>
    //     idx === i ? { ...item, partial_payments: filtered } : item
    //   ),
    // })

    console.log(`updatedData`, updatedData, totalamount)

    setValue(
      `voucher_contra.${i}.${
        data?.voucher_contra?.[i]?.nature?.value == "debit" ? "debit" : "credit"
      }`,
      Number(totalamount).toFixed(desimalrange || 2)
    )
    setValue(
      `voucher_contra.${i}.${
        data?.voucher_contra?.[i]?.nature?.value == "debit" ? "credit" : "debit"
      }`,
      0
    )

    setModal(onlyClose ? false : true)
    setViewData({ ...viewData, showCC: true, taxChk: 1 })
    setValue(
      "cost_center_id",
      data?.voucher_contra?.[i]?.cost_center_id?.value
        ? data?.voucher_contra?.[i]?.cost_center_id
        : null
    )
    setValue(
      "transaction_type",
      data?.voucher_contra?.[i]?.transaction_type?.value
        ? data?.voucher_contra?.[i]?.transaction_type
        : null
    )
    setCCModal(true)
    if (!onlyClose) {
      contraPartialListAppend({
        // nature: { label: chkDataOtrName == "debit" ? "Dr" : "Cr", value: chkDataOtrName },
        account_id: null,
        nature: data?.voucher_contra[i]?.nature,
        amount: 0,
        // date: moment(now, "DD-MM-MMMM").toDate(),
        date: filtered[filtered?.length - 1].date,
        bill_date: filtered[filtered?.length - 1].bill_date,
        chk: viewData?.currIndex,
        voucher_id: null,
        ref_id: {
          label: "New Ref",
          value: 3,
        },
      })
    } else {
      handleAppendContraRow()
    }
  }

  const handleTransactionModalData = i => {
    const dataVal = getValues()

    setValue(`voucher_contra.${i}.transaction_type`, dataVal?.transaction_type)
    setTransactionModal(false)
  }
  const handleBankModalData = i => {
    const dataVal = getValues()

    console.log(`dataVal`, viewData)

    setValue(`voucher_contra.${i}.date`, dataVal?.bank_date)
    setValue(`voucher_contra.${i}.instrument_no`, dataVal?.instrument_no)
    setValue(`voucher_contra.${i}.instrument_date`, dataVal?.instrument_date)
    setValue(`voucher_contra.${i}.currency`, dataVal?.currency)
    setValue(
      `voucher_contra.${i}.bank_amount`,
      Number(dataVal?.bank_amount).toFixed(desimalrange || 2)
    )
    setValue(`voucher_contra.${i}.remarks`, dataVal?.remarks)
    setValue(`voucher_contra.${i}.payment_type_id`, dataVal?.payment_type_id)
    setValue(`voucher_contra.${i}.is_pdc`, pdcCheck ? 1 : 0)
    setValue(
      `${
        watch(`voucher_contra.${i}.nature`)?.value == "debit"
          ? `voucher_contra.${i}.debit`
          : `voucher_contra.${i}.credit`
      }`,
      Number(dataVal?.bank_amount).toFixed(desimalrange || 2)
    )
    setValue(
      `${
        watch(`voucher_contra.${i}.nature`)?.value == "debit"
          ? `voucher_contra.${i}.credit`
          : `voucher_contra.${i}.debit`
      }`,
      0
    )
    setBankModal(false)
    setViewData({ ...viewData, showCC: true })
  }

  const handleCCModalData = i => {
    const dataVal = getValues()

    setValue(
      rSelected == 3
        ? `voucher_sales_acc.${i}.cost_center_id`
        : `voucher_contra.${i}.cost_center_id`,
      dataVal?.cost_center_id
    )
    setValue(
      rSelected == 3
        ? `voucher_sales_acc.${i}.transaction_type`
        : `voucher_contra.${i}.transaction_type`,
      dataVal?.transaction_type
    )
    setValue("cost_center_id", null)
    setValue("transaction_type", null)
    setCCModal(false)
  }

  console.log(`chk value test`, watch(`voucher_contra.0`))

  const incrementCode = code => {
    if (!code) return "1"

    const prefixMatch = code.match(/[A-Za-z]+/)
    const numberMatch = code.match(/\d+/)

    const prefix = prefixMatch ? prefixMatch[0] : ""
    const number = numberMatch ? numberMatch[0] : "0"

    const incremented = String(Number(number) + 1).padStart(
      number.length || 1,
      "0"
    )

    return prefix + incremented
  }

  const onKeyDown = event => {
    console.log(`event.key`, event)

    const targetName = event.target.name

    const isTargetField =
      /^voucher_contra\.\d+\.(debit|credit)$/.test(targetName) ||
      /^voucher_contra_partial_pay\.\d+\.amount$/.test(targetName) ||
      /^voucher_sales_acc\.\d+\.(rate|amount)$/.test(targetName)

    console.log(`isTargetField`, isTargetField)

    if (!isTargetField) return

    const voucherId = watch("voucher_id")?.value
    const voucherParentId = watch("voucher_id")?.parent_id
    const modalVoucherIds = [1, 3, 6, 8, 21]
    const conditionalVoucherIds = [13, 15]
    if (event.key === "Tab") {
      if (
        modal &&
        (conditionalVoucherIds.includes(voucherId) ||
          conditionalVoucherIds.includes(voucherParentId)) &&
        [1, 3].includes(rSelected)
      ) {
        event.preventDefault()
        handleSubmit(handleRegistration)()
      } else if (
        modal &&
        (modalVoucherIds.includes(voucherId) ||
          modalVoucherIds.includes(voucherParentId) ||
          ((conditionalVoucherIds.includes(voucherId) ||
            conditionalVoucherIds.includes(voucherParentId)) &&
            rSelected === 2) ||
          (([4, 18].includes(watch("voucher_id")?.value) ||
            [4, 18].includes(watch("voucher_id")?.parent_id)) &&
            rSelected === 2))
      ) {
        event.preventDefault()
        handleModalData(viewData?.currIndex)
      } else if (
        !modal &&
        (modalVoucherIds.includes(voucherId) ||
          modalVoucherIds.includes(voucherParentId) ||
          ((conditionalVoucherIds.includes(voucherId) ||
            conditionalVoucherIds.includes(voucherParentId)) &&
            rSelected === 2) ||
          (([4, 18].includes(watch("voucher_id")?.value) ||
            [4, 18].includes(watch("voucher_id")?.parent_id)) &&
            rSelected === 2))
      ) {
        event.preventDefault()
        // handleModalData(viewData?.currIndex);
        handleAppendContraRow()
      } else if (
        ([13, 15, 4, 18].includes(voucherId) ||
          [13, 15, 4, 18].includes(voucherParentId)) &&
        rSelected == 3 &&
        !modal
      ) {
        event.preventDefault()
        handleAppendSaleAccRow()
      }
    }
  }

  const watchVoucherId = watch("voucher_id")?.value

  console.log(`watchVoucherId`, watch("code"))

  useEffect(() => {
    if (
      [1, 3, 6, 8, 21].includes(Number(watch("voucher_id")?.value)) ||
      [1, 3, 6, 8, 21].includes(Number(watch("voucher_id")?.parent_id)) ||
      ((watch("voucher_id")?.value == 13 ||
        watch("voucher_id")?.parent_id == 13) &&
        rSelected == 2) ||
      rSelected == 3 ||
      ((watch("voucher_id")?.value == 15 ||
        watch("voucher_id")?.parent_id == 15) &&
        rSelected == 2) ||
      (([4, 18].includes(watch("voucher_id")?.value) ||
        [4, 18].includes(watch("voucher_id")?.parent_id)) &&
        rSelected == 2)
    ) {
      window.addEventListener("keydown", onKeyDown)
      return () => window.removeEventListener("keydown", onKeyDown)
    } else if (
      modal &&
      (watch("voucher_id")?.value == 13 ||
        watch("voucher_id")?.value == 15 ||
        watch("voucher_id")?.parent_id == 13 ||
        watch("voucher_id")?.parent_id == 15) &&
      rSelected == 1
    ) {
      window.addEventListener("keydown", onKeyDown)
      return () => window.removeEventListener("keydown", onKeyDown)
    }
  }, [modal, watchVoucherId, rSelected])

  const handleRegistration = async data => {
    console.log(`handleRegistration data :`, data)
    const generalTerms = data?.general_terms
      ? draftToHtml(convertToRaw(data?.general_terms?.getCurrentContent()))
      : ""
    const deliveryTerms = data?.delivery_terms
      ? draftToHtml(convertToRaw(data?.delivery_terms?.getCurrentContent()))
      : ""
    const reducedChkVal = Number(
      data?.voucher_sales_acc?.reduce(
        (sum, item) => sum + parseFloat(item.amount || 0),
        0
      )
    ).toFixed(desimalrange || 2)
    if (
      ([13, 15, 4, 18].includes(data?.voucher_id?.value) ||
        [13, 15, 4, 18].includes(data?.voucher_id?.parent_id)) &&
      [1, 3, 4].includes(rSelected) &&
      !modal
    ) {
      const removeIds = data?.voucher_contra_partial_pay?.map((item, i) => i)
      console.log(`removeIds`, removeIds)

      contraPartialListRemove([removeIds])
      setViewData({
        voucher_type: data?.voucher_id?.value,
        ledger_id: data?.credit_id?.value,
        currIndex: 0,
      })
      setModal(true)
      setValue(
        `voucher_contra_partial_pay.${0}.amount`,
        (data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13) &&
          rSelected == 1
          ? calculationSale("total_amount")
          : ([13, 15, 4, 18].includes(data?.voucher_id?.value) ||
              [13, 15, 4, 18].includes(data?.voucher_id?.parent_id)) &&
            rSelected == 3
          ? reducedChkVal
          : calculation("total_amount")
      )
      setValue(
        `voucher_contra_partial_pay.${0}.code`,
        data?.ref_code ? data?.ref_code : data?.code
      )
      setValue(
        `voucher_contra_partial_pay.${0}.date`,
        (data?.voucher_id?.value == 15 || data?.voucher_id?.parent_id == 15) &&
          rSelected == 1
          ? data?.ref_date
          : moment(now, "DD-MM-MMMM").toDate()
      )
      setValue(
        `voucher_contra_partial_pay.${0}.nature`,
        data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
          ? { label: "Dr", value: "debit" }
          : { label: "Cr", value: "credit" }
      )
      setValue(`voucher_contra_partial_pay.${0}.ref_id`, {
        label: "New Ref",
        value: 3,
      })
    } else {
      const calcuChkTotal =
        (data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13) &&
        rSelected == 1
          ? calculationSale("total_amount")
          : ([13, 15].includes(data?.voucher_id?.value) ||
              [13, 15].includes(data?.voucher_id?.parent_id)) &&
            rSelected == 3
          ? reducedChkVal
          : calculation("total_amount")
      const totalAmount = Number(
        data?.voucher_contra_partial_pay?.reduce(
          (sum, item) => sum + parseFloat(item.amount || 0),
          0
        )
      ).toFixed(desimalrange || 2)

      console.log(`calcuChkTotal reg`, calcuChkTotal, totalAmount)

      if (
        Number(totalAmount) > Number(calcuChkTotal) &&
        ([13, 15].includes(data?.voucher_id?.value) ||
          [13, 15].includes(data?.voucher_id?.parent_id)) &&
        !editId &&
        [1, 3, 4].includes(rSelected)
      ) {
        toastError(`Amount cannot be greater than ${calcuChkTotal}`)
        return
      } else if (
        Number(totalAmount) < Number(calcuChkTotal) &&
        ([13, 15].includes(data?.voucher_id?.value) ||
          [13, 15].includes(data?.voucher_id?.parent_id)) &&
        !editId &&
        [1, 3, 4].includes(rSelected)
      ) {
        toastError("Amount not equal")
        contraPartialListAppend({
          account_id: data?.credit_id?.value,
          debit: 0,
          credit: 0,
          chk: viewData?.currIndex,
          code: incrementCode(
            data?.voucher_contra_partial_pay[
              data?.voucher_contra_partial_pay?.length - 1
            ]?.code
              ? data?.voucher_contra_partial_pay[
                  data?.voucher_contra_partial_pay?.length - 1
                ]?.code
              : watch("code")
          ),
          amount: Number(Number(calcuChkTotal) - Number(totalAmount)).toFixed(
            desimalrange
          ),
          nature:
            data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
              ? { label: "Dr", value: "debit" }
              : { label: "Cr", value: "credit" },
          date: moment(now, "DD-MM-MMMM").toDate(),
          ref_id: {
            label: "New Ref",
            value: 3,
          },
        })
        return
      }

      console.log(`totalAmount`, totalAmount, calcuChkTotal)
      let productArray = []
      let valueArray = []
      let partialPaymentArr = []

      if (data?.voucher_id?.value === 3 || data?.voucher_id?.parent_id == 3) {
        const validGroups = [6]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "credit" && validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "For this voucher, at least one credit entry must belong to a Cash account group."
          )
          return false
        }
      } else if (
        data?.voucher_id?.value === 21 ||
        data?.voucher_id?.parent_id == 21
      ) {
        const validGroups = [5, 15]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "credit" && validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "For this voucher, at least one credit entry must belong to a Bank account group."
          )
          return false
        }
      } else if (
        data?.voucher_id?.value == 6 ||
        data?.voucher_id?.parent_id == 6
      ) {
        const validGroups = [5, 6]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "debit" && validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "For this voucher, at least one debit entry must belong to a Bank or Cash account group."
          )
          return false
        }
      } else if (
        (data?.voucher_id?.value == 15 || data?.voucher_id?.parent_id == 15) &&
        rSelected == 2
      ) {
        const validGroups = [27, 29, 28]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "debit" && validGroups.includes(Number(groupId))
        })

        // if (!isValid) {
        //   toastError(
        //     "Please select either Purchase Account or Expence in one entries."
        //   )
        //   return false
        // }
      } else if (
        (data?.voucher_id?.value == 15 || data?.voucher_id?.parent_id == 15) &&
        rSelected == 3
      ) {
        const validGroups = [27, 29]
        const isValid = data?.voucher_sales_acc?.some(item => {
          const groupId = item?.account_id?.account_group_id
          // const nature = item?.nature?.value
          return validGroups.includes(Number(groupId))
        })

        if (!isValid) {
          toastError(
            "Please select either Purchase Account or Direct Expence in one entries."
          )
          return false
        }
      } else if (
        (data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13) &&
        rSelected == 2
      ) {
        const validGroups = [26, 24]
        const isValid = data?.voucher_contra?.some(item => {
          const groupId = item?.account_id?.account_group_id
          const nature = item?.nature?.value
          return nature === "credit" && validGroups.includes(Number(groupId))
        })

        // if (!isValid) {
        //   toastError(
        //     "Please select either Sales Account or Direct Income in one entries."
        //   )
        //   return false
        // }
      } else if (
        (data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13) &&
        rSelected == 3
      ) {
        const validGroups = [26, 24]
        const isValid = data?.voucher_sales_acc?.some(item => {
          const groupId = item?.account_id?.account_group_id
          // const nature = item?.nature?.value
          return validGroups.includes(Number(groupId))
        })

        // if (!isValid) {
        //   toastError(
        //     "Please select either Sales Account or Direct Income in one entries."
        //   )
        //   return false
        // }
      }

      if (
        (data?.voucher_id?.value == 15 || data?.voucher_id?.parent_id == 15) &&
        rSelected == 1
      ) {
        productArray = data?.voucher_purchase?.map(e => ({
          product_id: editId ? e?.id : "",
          po_material_id: editId ? e?.po_material_id : e?.id,
          material_id: e?.product_id?.value,
          qnt: e?.qnt,
          unit_price: e?.unit_price,
          requested_quantity: e?.requested_quantity,
          voucher_from: e?.voucher_from,
          po_quantity: e?.po_quantity,
          grn_quantity: e?.grn_quantity,
        }))
        valueArray = [
          {
            amount: Number(
              Number(calculation("sub_total") || 0) -
                Number(calculation("discounted_amount_send") || 0) +
                Number(calculation("tax_total") || 0)
            ).toFixed(desimalrange),
            account_id: data?.credit_id?.value,
            type:
              data?.voucher_id?.value == 15 || data?.voucher_id?.parent_id == 15
                ? "credit"
                : "debit",
            partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
              amount: Number(item?.amount).toFixed(desimalrange),
              date: moment(item?.date).format("YYYY-MM-DD"),
              code: item?.code,
              ref_id: item?.ref_id?.value,
              credit_debit: item?.nature?.value,
              parent_ledger_id: data?.credit_id?.value,
              ...(item?.voucher_id && {
                parent_voucher_entry_id: item?.voucher_id,
              }),
            })),
          },
          {
            amount: (
              Number(calculation("total_amount") || 0) -
              Number(calculation("tax_total") || 0) -
              Number(data?.shipping_charge || 0) -
              Number(data?.other_charge || 0)
            ).toFixed(desimalrange),
            account_id: data?.debit_id?.value,
            cost_center_id: data?.cost_center_id?.value,
            type:
              data?.voucher_id?.value == 15 || data?.voucher_id?.parent_id == 15
                ? "debit"
                : "credit",
          },
          vatCheck && {
            amount: Number(calculation("tax_total")).toFixed(desimalrange),
            type: "debit",
            account_id: data?.vat_id?.value,
          },
          discountCheck && {
            amount: Number(calculation("discounted_amount_send")).toFixed(
              desimalrange
            ),
            type: "credit",
            account_id: 2,
          },
          shippingCheck && {
            amount: Number(data?.shipping_charge).toFixed(desimalrange),
            type: "debit",
            account_id: 3,
          },
          othersCheck && {
            amount: Number(data?.other_charge).toFixed(desimalrange),
            type: "debit",
            account_id: 4,
          },
          {
            amount: Number(calculation("sub_total") || 0).toFixed(desimalrange),
            account_id: 1,
            type: "debit",
          },
        ]
      } else if (
        (data?.voucher_id?.value == 4 || data?.voucher_id?.parent_id == 4) &&
        rSelected == 1
      ) {
        productArray = data?.voucher_purchase?.map(e => ({
          product_id: editId ? e?.id : "",
          material_id: e?.product_id?.value,
          qnt: e?.qnt,
          unit_price: e?.unit_price,
          requested_quantity: e?.requested_quantity,
          voucher_from: e?.voucher_from,
          po_quantity: e?.po_quantity,
          grn_quantity: e?.grn_quantity,
        }))
        valueArray = [
          {
            amount: Number(
              Number(calculation("sub_total") || 0) -
                Number(calculation("discounted_amount_send") || 0) +
                Number(calculation("tax_total") || 0)
            ).toFixed(desimalrange),
            account_id: data?.credit_id?.value,
            type: "debit",
            partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
              amount: Number(item?.amount).toFixed(desimalrange),
              date: moment(item?.date).format("YYYY-MM-DD"),
              code: item?.code,
              ref_id: item?.ref_id?.value,
              credit_debit: "debit",
              parent_ledger_id: data?.credit_id?.value,
              ...(item?.voucher_id && {
                parent_voucher_entry_id: item?.voucher_id,
              }),
            })),
          },
          {
            amount: (
              Number(calculation("total_amount") || 0) -
              Number(calculation("tax_total") || 0) -
              Number(data?.shipping_charge || 0) -
              Number(data?.other_charge || 0)
            ).toFixed(desimalrange),
            account_id: data?.debit_id?.value,
            cost_center_id: data?.cost_center_id?.value,
            type: "credit",
            // partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
            //   amount: Number(item?.amount).toFixed(2),
            //   date: moment(data?.date).format("YYYY-MM-DD"),
            //   code: item?.code,
            //   ref_id: item?.ref_id?.value,
            //   credit_debit: item?.nature?.value,
            //   parent_ledger_id: data?.credit_id?.value,
            //   ...(item?.voucher_id && {
            //     parent_voucher_entry_id: item?.voucher_id,
            //   }),
            // })),
          },
          vatCheck && {
            amount: Number(calculation("tax_total")).toFixed(desimalrange),
            type: "credit",
            account_id: data?.vat_id?.value,
          },
          discountCheck && {
            amount: Number(calculation("discounted_amount_send")).toFixed(
              desimalrange
            ),
            type: "debit",
            account_id: 2,
          },
          shippingCheck && {
            amount: Number(data?.shipping_charge).toFixed(desimalrange),
            type: "credit",
            account_id: 3,
          },
          othersCheck && {
            amount: Number(data?.other_charge).toFixed(desimalrange),
            type: "credit",
            account_id: 4,
          },
        ]
      } else if (
        (data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13) &&
        rSelected == 1
      ) {
        valueArray = [
          {
            amount: Number(
              Number(calculationSale("sub_total") || 0) -
                Number(data?.retention || 0) -
                Number(data?.adv_retention || 0) +
                Number(calculationSale("tax_total") || 0)
            ).toFixed(desimalrange),
            account_id: data?.credit_id?.value,
            type:
              data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
                ? "debit"
                : "credit",
            partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
              amount: Number(item?.amount).toFixed(desimalrange),
              date: moment(item?.date).format("YYYY-MM-DD"),
              code: item?.code,
              ref_id: item?.ref_id?.value,
              credit_debit: item?.nature?.value,
              parent_ledger_id: data?.credit_id?.value,
              ...(item?.voucher_id && {
                parent_voucher_entry_id: item?.voucher_id,
              }),
            })),
          },
          {
            amount: Number(calculationSale("sub_total") || 0)
              // -
              // Number(calculationSale("tax_total") || 0) + Number(data?.retention || 0)
              // Number(calculationSale("discounted_amount_send") || 0)
              .toFixed(desimalrange),
            account_id: data?.debit_id?.value,
            cost_center_id: data?.cost_center_id?.value,
            type:
              data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
                ? "credit"
                : "debit",
            // partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
            //   amount: Number(item?.amount).toFixed(2),
            //   date: moment(data?.date).format("YYYY-MM-DD"),
            //   code: item?.code,
            //   ref_id: item?.ref_id?.value,
            //   credit_debit: item?.nature?.value,
            //   parent_ledger_id: data?.credit_id?.value,
            //   ...(item?.voucher_id && {
            //     parent_voucher_entry_id: item?.voucher_id,
            //   }),
            // })),
          },
          vatCheck && {
            amount: Number(calculationSale("tax_total")).toFixed(desimalrange),
            type: "credit",
            account_id: data?.vat_id?.value,
          },
          discountCheck && {
            amount: Number(calculationSale("discounted_amount_send")).toFixed(
              desimalrange
            ),
            type: "credit",
            account_id: 2,
          },
          // shippingCheck && {
          //   amount: data?.shipping_charge,
          //   type: "debit",
          //   account_id: 3,
          // },
          // othersCheck && {
          //   amount: data?.other_charge,
          //   type: "debit",
          //   account_id: 4,
          // },
          retentionCheck && {
            amount: Number(data?.retention).toFixed(desimalrange),
            type: "debit",
            account_id: data?.retention_id?.value,
          },
          advRetentionCheck && {
            amount: Number(data?.adv_retention).toFixed(2),
            type: "debit",
            account_id: data?.adv_retention_id?.value,
          },
        ]
      } else if (
        (data?.voucher_id?.value == 18 || data?.voucher_id?.parent_id == 18) &&
        rSelected == 1
      ) {
        valueArray = [
          {
            amount: Number(
              Number(calculationSale("sub_total") || 0) -
                Number(data?.retention || 0) -
                Number(data?.adv_retention || 0) +
                Number(calculationSale("tax_total") || 0)
            ).toFixed(desimalrange),
            account_id: data?.credit_id?.value,
            type: "credit",
            partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
              amount: Number(item?.amount).toFixed(desimalrange),
              date: moment(item?.date).format("YYYY-MM-DD"),
              code: item?.code,
              ref_id: item?.ref_id?.value,
              credit_debit: item?.nature?.value,
              parent_ledger_id: data?.credit_id?.value,
              ...(item?.voucher_id && {
                parent_voucher_entry_id: item?.voucher_id,
              }),
            })),
          },
          {
            amount: Number(calculationSale("sub_total") || 0)
              // -
              // Number(calculationSale("tax_total") || 0) + Number(data?.retention || 0)
              // Number(calculationSale("discounted_amount_send") || 0)
              .toFixed(desimalrange),
            account_id: data?.debit_id?.value,
            type: "debit",
            cost_center_id: data?.cost_center_id?.value,
            // partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
            //   amount: Number(item?.amount).toFixed(2),
            //   date: moment(data?.date).format("YYYY-MM-DD"),
            //   code: item?.code,
            //   ref_id: item?.ref_id?.value,
            //   credit_debit: item?.nature?.value,
            //   parent_ledger_id: data?.credit_id?.value,
            //   ...(item?.voucher_id && {
            //     parent_voucher_entry_id: item?.voucher_id,
            //   }),
            // })),
          },
          vatCheck && {
            amount: Number(calculationSale("tax_total")).toFixed(desimalrange),
            type: "debit",
            account_id: data?.vat_id?.value,
          },
          discountCheck && {
            amount: Number(calculationSale("discounted_amount_send")).toFixed(
              desimalrange
            ),
            type: "debit",
            account_id: 2,
          },
          // shippingCheck && {
          //   amount: data?.shipping_charge,
          //   type: "debit",
          //   account_id: 3,
          // },
          // othersCheck && {
          //   amount: data?.other_charge,
          //   type: "debit",
          //   account_id: 4,
          // },
          retentionCheck && {
            amount: Number(data?.retention).toFixed(desimalrange),
            type: "credit",
            account_id: data?.retention_id?.value,
          },
          advRetentionCheck && {
            amount: Number(data?.adv_retention).toFixed(2),
            type: "credit",
            account_id: data?.adv_retention_id?.value,
          },
        ]
      } else if (
        (data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13) &&
        rSelected == 4
      ) {
        valueArray = [
          {
            amount: Number(
              Number(calculation("sub_total") || 0) -
                Number(calculation("discounted_amount_send") || 0) +
                Number(calculation("tax_total") || 0)
            ).toFixed(desimalrange),
            account_id: data?.credit_id?.value,
            type:
              data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
                ? "debit"
                : "credit",
            partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
              amount: Number(item?.amount).toFixed(desimalrange),
              date: moment(item?.date).format("YYYY-MM-DD"),
              code: item?.code,
              ref_id: item?.ref_id?.value,
              credit_debit: item?.nature?.value,
              parent_ledger_id: data?.credit_id?.value,
              ...(item?.voucher_id && {
                parent_voucher_entry_id: item?.voucher_id,
              }),
            })),
          },
          {
            amount: (
              Number(calculation("total_amount") || 0) -
              Number(calculation("tax_total") || 0) -
              Number(data?.shipping_charge || 0) -
              Number(data?.other_charge || 0)
            ).toFixed(desimalrange),
            account_id: data?.debit_id?.value,
            cost_center_id: data?.cost_center_id?.value,
            type:
              data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
                ? "credit"
                : "debit",
            // partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
            //   amount: Number(item?.amount).toFixed(2),
            //   date: moment(data?.date).format("YYYY-MM-DD"),
            //   code: item?.code,
            //   ref_id: item?.ref_id?.value,
            //   credit_debit: item?.nature?.value,
            //   parent_ledger_id: data?.credit_id?.value,
            //   ...(item?.voucher_id && {
            //     parent_voucher_entry_id: item?.voucher_id,
            //   }),
            // })),
          },
          vatCheck && {
            amount: Number(calculation("tax_total")).toFixed(desimalrange),
            type: "credit",
            account_id: data?.vat_id?.value,
          },
          discountCheck && {
            amount: Number(calculation("discounted_amount_send")).toFixed(
              desimalrange
            ),
            type: "credit",
            account_id: 2,
          },
          {
            amount: Number(Number(calculation("sub_total") || 0)).toFixed(
              desimalrange
            ),
            account_id: 1,
            type: "credit",
          },
          // shippingCheck && {
          //   amount: data?.shipping_charge,
          //   type: "debit",
          //   account_id: 3,
          // },
          // othersCheck && {
          //   amount: data?.other_charge,
          //   type: "debit",
          //   account_id: 4,
          // },
          // retentionCheck && {
          //   amount: Number(data?.retention).toFixed(desimalrange),
          //   type: "debit",
          //   account_id: data?.retention_id?.value,
          // },
          // advRetentionCheck && {
          //   amount: Number(data?.adv_retention).toFixed(2),
          //   type: "debit",
          //   account_id: data?.adv_retention_id?.value,
          // },
        ]
        productArray = data?.voucher_materials?.map(e => ({
          product_id: editId ? e?.id : "",
          material_id: e?.product_id?.value,
          qnt: e?.qnt,
          requested_quantity: e?.requested_quantity,
          unit_price: e?.unit_price,
        }))
      } else if (
        (data?.voucher_id?.value == 18 || data?.voucher_id?.parent_id == 18) &&
        rSelected == 4
      ) {
        valueArray = [
          {
            amount: Number(
              Number(calculation("sub_total") || 0) -
                Number(calculation("discounted_amount_send") || 0) +
                Number(calculation("tax_total") || 0)
            ).toFixed(desimalrange),
            account_id: data?.credit_id?.value,
            type: "credit",
            partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
              amount: Number(item?.amount).toFixed(desimalrange),
              date: moment(item?.date).format("YYYY-MM-DD"),
              code: item?.code,
              ref_id: item?.ref_id?.value,
              credit_debit: item?.nature?.value,
              parent_ledger_id: data?.credit_id?.value,
              ...(item?.voucher_id && {
                parent_voucher_entry_id: item?.voucher_id,
              }),
            })),
          },
          {
            amount: (
              Number(calculation("total_amount") || 0) -
              Number(calculation("tax_total") || 0) -
              Number(data?.shipping_charge || 0) -
              Number(data?.other_charge || 0)
            ).toFixed(desimalrange),
            account_id: data?.debit_id?.value,
            cost_center_id: data?.cost_center_id?.value,
            type: "debit",
          },
          vatCheck && {
            amount: Number(calculation("tax_total")).toFixed(desimalrange),
            type: "debit",
            account_id: data?.vat_id?.value,
          },
          discountCheck && {
            amount: Number(calculation("discounted_amount_send")).toFixed(
              desimalrange
            ),
            type: "debit",
            account_id: 2,
          },
          // shippingCheck && {
          //   amount: data?.shipping_charge,
          //   type: "credit",
          //   account_id: 3,
          // },
          // othersCheck && {
          //   amount: data?.other_charge,
          //   type: "credit",
          //   account_id: 4,
          // },
          // retentionCheck && {
          //   amount: Number(data?.retention).toFixed(desimalrange),
          //   type: "credit",
          //   account_id: data?.retention_id?.value,
          // },
          // advRetentionCheck && {
          //   amount: Number(data?.adv_retention).toFixed(2),
          //   type: "credit",
          //   account_id: data?.adv_retention_id?.value,
          // },
        ]
        productArray = data?.voucher_materials?.map(e => ({
          product_id: editId ? e?.id : "",
          material_id: e?.product_id?.value,
          qnt: e?.qnt,
          requested_quantity: e?.requested_quantity,
          unit_price: e?.unit_price,
        }))
      } else if (
        ([13, 15].includes(data?.voucher_id?.value) ||
          [13, 15].includes(data?.voucher_id?.parent_id)) &&
        rSelected == 3
      ) {
        const valArr = data?.voucher_sales_acc
          ?.filter(e => Number(e?.amount) != 0)
          ?.map(e => ({
            account_id: e?.account_id?.value,
            amount: Math.abs(Number(e?.amount)),
            cost_center_id: e?.cost_center_id?.value,
            type:
              Number(e?.amount) >= 0 &&
              (data?.voucher_id?.value == 13 ||
                data?.voucher_id?.parent_id == 13)
                ? "credit"
                : Number(e?.amount) >= 0 &&
                  (data?.voucher_id?.value == 15 ||
                    data?.voucher_id?.parent_id == 15)
                ? "debit"
                : Number(e?.amount) < 0 &&
                  (data?.voucher_id?.value == 13 ||
                    data?.voucher_id?.parent_id == 13)
                ? "debit"
                : "credit",
          }))
        const reducedVal = data?.voucher_sales_acc.reduce(
          (sum, item) => sum + parseFloat(item.amount || 0),
          0
        )
        const concatedArr = [
          ...valArr,
          {
            account_id: data?.credit_id?.value,
            type:
              data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
                ? "debit"
                : "credit",
            amount: reducedVal,
            partial_payments: data?.voucher_contra_partial_pay?.map(item => ({
              amount: Number(item?.amount).toFixed(desimalrange),
              date: moment(item?.date).format("YYYY-MM-DD"),
              code: item?.code,
              ref_id: item?.ref_id?.value,
              credit_debit: item?.nature?.value,
              parent_ledger_id: data?.credit_id?.value,
              ...(item?.voucher_id && {
                parent_voucher_entry_id: item?.voucher_id,
              }),
            })),
          },
        ]
        valueArray = concatedArr
      } else if (
        data?.voucher_id?.value == 7 ||
        data?.voucher_id?.value == 5 ||
        data?.voucher_id?.value == 10 ||
        data?.voucher_id?.parent_id == 7 ||
        data?.voucher_id?.parent_id == 5 ||
        data?.voucher_id?.parent_id == 10
      ) {
        productArray = data?.voucher_receipt?.map(e => ({
          product_id: editId ? e?.id : "",
          material_id: e?.product_id?.value,
          qnt: e?.qnt,
          unit_price: e?.unit_price,
          requested_quantity: e?.requested_quantity,
          po_quantity: e?.po_quantity,
        }))
      } else if (
        data?.voucher_id?.value == 11 ||
        data?.voucher_id?.parent_id == 11
      ) {
        productArray = data?.voucher_materialout?.map(e => ({
          material_id: e?.product_id?.value,
          qnt: e?.qnt,
          id: e?.id,
        }))
      } else if (
        data?.voucher_id?.value == 12 ||
        data?.voucher_id?.parent_id == 12
      ) {
        productArray = data?.voucher_source?.map(e => ({
          material_id: e?.material_id?.value,
          qnt: e?.qnt,
          id: e?.id,
          rate: e?.rate,
          type: rSelected == 1 ? "central" : "site",
          activity: rSelected == 1 ? "remove" : "add",
          project_id: data?.project_code?.value,
        }))
      } else if (
        data?.voucher_id?.value == 16 ||
        data?.voucher_id?.parent_id == 16 ||
        ((data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13) &&
          rSelected == 4)
      ) {
        productArray = data?.voucher_materials?.map(e => ({
          product_id: editId ? e?.id : "",
          material_id: e?.product_id?.value,
          qnt: e?.qnt,
          requested_quantity: e?.requested_quantity,
          unit_price: e?.unit_price,
        }))
      }

      if (
        [1, 3, 6, 8, 9, 21].includes(Number(data?.voucher_id?.value)) ||
        [1, 3, 6, 8, 9, 21].includes(Number(data?.voucher_id?.parent_id)) ||
        ((data?.voucher_id?.value == 15 || data?.voucher_id?.parent_id == 15) &&
          rSelected == 2) ||
        ((data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13) &&
          rSelected == 2) ||
        ((data?.voucher_id?.value == 4 || data?.voucher_id?.parent_id == 4) &&
          rSelected == 2) ||
        ((data?.voucher_id?.value == 18 || data?.voucher_id?.parent_id == 18) &&
          rSelected == 2)
      ) {
        valueArray = data?.voucher_contra?.map(e => ({
          account_id: e?.account_id?.value,
          // debit: e?.debit,
          // credit: e?.credit,
          amount: e?.credit == 0 ? e?.debit : e?.credit,
          transaction_type: e?.transaction_type?.value,
          cost_center_id: e?.cost_center_id?.value,
          ...(e?.bank_amount && {
            bank_payment: {
              // date:(e?.date != undefined && e?.date != ""  && e?.date != "Invalid date" ) ?  moment(e?.date).format("YYYY-MM-DD") : null,
              // instrument_no: e?.instrument_no,
              // instrument_date:(e?.instrument_date != undefined && e?.instrument_date != ""  && e?.instrument_date != "Invalid date" ) ? moment(e?.instrument_date).format("YYYY-MM-DD") : null,
              date:
                e?.date &&
                moment(e?.date, ["DD-MM-YYYY", "YYYY-MM-DD"]).isValid()
                  ? moment(e?.date, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
                      "YYYY-MM-DD"
                    )
                  : null,
              instrument_no: e?.instrument_no,
              instrument_date:
                e?.instrument_date &&
                moment(e?.instrument_date, [
                  "DD-MM-YYYY",
                  "YYYY-MM-DD",
                ]).isValid()
                  ? moment(e?.instrument_date, [
                      "DD-MM-YYYY",
                      "YYYY-MM-DD",
                    ]).format("YYYY-MM-DD")
                  : null,
              currency: e?.currency?.value,
              amount: e?.bank_amount,
              remarks: e?.remarks,
              payment_type_id: e?.payment_type_id?.value,
              is_pdc: e?.is_pdc,
            },
          }),
          type: e?.nature?.value,
          partial_payments: e?.partial_payments?.map(item => ({
            amount: item?.amount,
            date: moment(item?.date).format("YYYY-MM-DD"),
            code: item?.code,
            ref_id: item?.ref_id?.value,
            credit_debit: item?.nature?.value,
            parent_ledger_id: e?.account_id?.value,
            ...(item?.voucher_id && {
              parent_voucher_entry_id: item?.voucher_id,
            }),
          })),
        }))

        partialPaymentArr = data?.voucher_contra?.map(e => ({
          // account_id: e?.account_id?.value,
          voucher_id: e?.voucher_id,
          amount: e?.debit == 0 ? e?.credit : e?.debit,
          date: moment(data?.po_date).format("YYYY-MM-DD"),
          // credit: e?.credit,
        }))

        const totalDebit = data?.voucher_contra.reduce(
          (sum, item) => sum + parseFloat(item.debit || 0),
          0
        )
        const totalCredit = data?.voucher_contra.reduce(
          (sum, item) => sum + parseFloat(item.credit || 0),
          0
        )

        console.log(`totalDebit`, totalDebit, totalCredit)

        // Check if totals match
        if (
          Number(totalDebit).toFixed(desimalrange || 2) !==
            Number(totalCredit).toFixed(desimalrange || 2) ||
          (totalDebit && totalCredit) == 0
        ) {
          toastError(
            "The sum of Debit and Credit must be equal. Please adjust the entries."
          )
          return // Stop further execution
        }
      }
      // if (data?.voucher_id?.value == 6) {
      //   valueArray = data?.voucher_contra_ref?.map(e => ({
      //     account_id: data?.account_id?.value,
      //     debit: e?.debit,
      //     credit: e?.credit,
      //     ref_id: e?.ref_id?.value,
      //     remarks: e?.remarks,
      //   }))
      //   // const othrAr = data?.voucher_contra?.map(e => ({
      //   //   account_id: e?.account_id?.value,
      //   //   debit: e?.debit,
      //   //   credit: e?.credit,
      //   //   ref_id: e?.ref_id?.value,
      //   //   remarks: e?.remarks,
      //   // }))

      //   // valueArray = [...refArr, ...othrAr]

      //   // const partialRefArr = data?.voucher_contra_ref?.map(e => ({
      //   //   amount: e?.debit == 0 ? e?.credit : e?.debit,
      //   //   date: moment(data?.po_date).format("YYYY-MM-DD"),
      //   // }))
      //   // const partialOthrAr = data?.voucher_contra?.map(e => ({
      //   //   amount: e?.debit == 0 ? e?.credit : e?.debit,
      //   //   date: moment(data?.po_date).format("YYYY-MM-DD"),
      //   // }))

      //   partialPaymentArr = data?.voucher_contra_ref?.map(e => ({
      //     // account_id: e?.account_id?.value,
      //     voucher_id: e?.voucher_id,
      //     amount: e?.debit == 0 ? e?.credit : e?.debit,
      //     date: moment(data?.po_date).format("YYYY-MM-DD"),
      //     remarks: e?.remarks,
      //     ref_id: e?.ref_id?.value,
      //     // credit: e?.credit,
      //   }))

      //   const totalDebit = valueArray.reduce(
      //     (sum, item) => sum + parseFloat(item.debit || 0),
      //     0
      //   )
      //   const totalCredit = valueArray.reduce(
      //     (sum, item) => sum + parseFloat(item.credit || 0),
      //     0
      //   )

      //   // Check if totals match
      //   if (totalDebit !== totalCredit) {
      //     toastError(
      //       "The sum of Debit and Credit must be equal. Please adjust the entries."
      //     )
      //     return // Stop further execution
      //   }
      // }

      const subTotal =
        ([13, 18].includes(data?.voucher_id?.value) ||
          [13, 18].includes(Number(data?.voucher_id?.parent_id))) &&
        rSelected == 1
          ? calculationSale("total_amount")
          : data?.voucher_id?.value == 15 || data?.voucher_id?.parent_id == 15
          ? calculation("total_amount")
          : (data?.voucher_id?.value == 13 ||
              data?.voucher_id?.parent_id == 13) &&
            rSelected == 4
          ? calculation("total_amount")
          : data?.sub_total

      try {
        setIsLoading(true)
        const update = await postFinanceVoucher(
          {
            ...(productArray?.length && { product_list: productArray }),
            ...(valueArray?.length && { entries: valueArray }),
            ...(data?.sub_total && {
              sub_total: subTotal,
            }),
            ...(data?.sub_total == "" &&
              data?.sale_total && { sub_total: data?.sale_total }),
            ...(([13, 18].includes(data?.voucher_id?.value) ||
              [13, 18].includes(Number(data?.voucher_id?.parent_id))) &&
              rSelected == 1 && { sale_total: data?.sale_total }),
            ...((data?.voucher_id?.value == 15 ||
              data?.voucher_id?.parent_id == 15) && {
              sub_total: calculation("total_amount"),
            }),
            inv_num: data?.inv_num?.value,
            ...(data?.inv_date && {
              inv_date: moment(data?.inv_date).format("YYYY-MM-DD"),
            }),
            ...(data?.ref_date && {
              ref_date: moment(data?.ref_date).format("YYYY-MM-DD"),
            }),
            ref_code: data?.ref_code,
            // ...((data?.voucher_id?.value == 15 ||
            //   data?.voucher_id?.value == 13) && {
            voucher_invoice:
              ([15, 4].includes(data?.voucher_id?.value) ||
                [15, 4].includes(Number(data?.voucher_id?.parent_id))) &&
              rSelected == 1
                ? "Purchase Invoice"
                : ([15, 4].includes(data?.voucher_id?.value) ||
                    [15, 4].includes(Number(data?.voucher_id?.parent_id))) &&
                  rSelected == 2
                ? "Purchase Voucher"
                : ([13, 18].includes(data?.voucher_id?.value) ||
                    [13, 18].includes(Number(data?.voucher_id?.parent_id))) &&
                  rSelected == 1
                ? "Sales Invoice"
                : ([13, 18].includes(data?.voucher_id?.value) ||
                    [13, 18].includes(Number(data?.voucher_id?.parent_id))) &&
                  rSelected == 2
                ? "Sales Voucher"
                : ([13, 18].includes(data?.voucher_id?.value) ||
                    [13, 18].includes(Number(data?.voucher_id?.parent_id))) &&
                  rSelected == 3
                ? "Sales Account"
                : ([15, 4].includes(data?.voucher_id?.value) ||
                    [15, 4].includes(Number(data?.voucher_id?.parent_id))) &&
                  rSelected == 3
                ? "Purchase Account"
                : ([13, 18].includes(data?.voucher_id?.value) ||
                    [13, 18].includes(Number(data?.voucher_id?.parent_id))) &&
                  rSelected == 4
                ? "Sales Product Invoice"
                : "",
            // }),
            ...(partialPaymentArr?.length && {
              partial_payments: partialPaymentArr,
            }),
            code: data?.code,
            vouchertype_name: `Voucher - ${
              watch(`voucher_id`)?.label
                ? ucfirst(watch(`voucher_id`)?.label)
                : "Contra"
            }`,
            material_requisition_id: data?.material_requisition_id?.value,
            material_request_id: data?.material_request_id?.id
              ? data?.material_request_id?.id
              : data?.material_request_id?.value
              ? data?.material_request_id?.value
              : data?.material_request_id,
            rfq_id: data?.rfq_id?.value,
            purchase_order_id: data?.purchase_order_id?.value
              ? data?.purchase_order_id?.value
              : data?.purchase_order_id,
            // project_id: data?.project_code?.value,
            address: data?.address,
            date: moment(data?.po_date).format("YYYY-MM-DD"),
            exp_Delivery_date: moment(data?.exp_Delivery_date).format(
              "YYYY-MM-DD"
            ),
            project_id: projectId
              ? projectId
              : data?.credit_id?.project_id
              ? data?.credit_id?.project_id
              : data?.debit_id?.project_id
              ? data?.debit_id?.project_id
              : data?.project_code?.value
              ? data?.project_code?.value
              : data?.project_id,
            voucher_id: data?.voucher_id?.value,
            // credit_id:data?.credit_id?.value,
            // debit_id: data?.debit_id?.value,
            credit_id:
              data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
                ? data?.debit_id?.value
                : data?.credit_id?.value,
            debit_id:
              data?.voucher_id?.value == 13 || data?.voucher_id?.parent_id == 13
                ? data?.credit_id?.value
                : data?.debit_id?.value,
            voucher_type: data?.voucher_id?.voucher_type,
            date: moment(data?.po_date).format("YYYY-MM-DD"),
            narration: data?.narration,
            discount: !discountCheck ? 0 : data?.discount ? data?.discount : 0,
            vat_charge:
              vatCheck && watch("vat_id")?.vat_per
                ? watch("vat_id")?.vat_per
                : vatCheck && watch("vat_id")?.vat_per == null
                ? loggedUser?.settings?.tax
                : 0,
            shipping_charge: shippingCheck ? data?.shipping_charge : 0,
            other_charge: othersCheck ? data?.other_charge : 0,
            retention: retentionCheck ? data?.retention : 0,
            ...(data?.project_id && { project_id: data?.project_id }),
            // ...(data?.project_ids && { project_id: data?.project_ids?.value }),
            manufacturing_journal_id: data?.manufacturing_journal_id?.value,
            ...(editId && { id: editId }),
            general_terms: generalTerms,
            delivery_terms: deliveryTerms,
          },
          progressEvent => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            // setProgress(percentCompleted);
            console.log(`percentCompleted`, percentCompleted)
          }
        )
        if (fromDashboard) {
          toastSuccess(update?.message)
          toggle()
        } else {
          toastSuccess(update?.message)
          // navigate("/finance-voucher")
          navigate(
            location?.state?.type === "from_po"
              ? "/procurement-purchaseorder"
              : editId
              ? "/finance-voucher"
              : "/finance-voucher/add"
          )
          getUniqueCode(
            "ref_number",
            "VoucherEntry",
            `Voucher - ${ucfirst(data?.voucher_id?.voucher_type)}`
          )
          setModal(false)
          setVatCheck(false)
          setRetentionCheck(false)
          setAdvRetentionCheck(false)
          setShippingCheck(false)
          setOthersCheck(false)
          setDiscountCheck(false)
          setPrintID(update?.voucher?.id)
          setConfirmModal(true)

          reset({
            // po_date: data?.po_date,
            po_date: moment(data?.po_date || now, "YYYY-MM-DD").toDate(),
            voucher_id: data?.voucher_id,
            manufacturing_journal_id: null,
            material_requisition_id: null,
            purchase_order_id_ref: null,
            project_ids: null,
            inv_num: null,
            voucher_contra: [
              {
                nature: { label: "Dr", value: "debit" },
                debit_amount: 0,
                credit_amount: 0,
                account_group_id: null,
              },
            ],
            voucher_materials: [
              {
                qnt: "",
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
              },
            ],
            voucher_purchase: [
              {
                qnt: "",
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
              },
            ],
            voucher_materialout: [
              {
                qnt: 0,
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
                amount: 0,
              },
            ],
            voucher_destination: [
              {
                qnt: 0,
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
                amount: 0,
              },
            ],
            voucher_source: [
              {
                qnt: 0,
                product_id: null,
                unit_price: "",
                sub_price: "",
                unit: null,
                id: "",
              },
            ],
            voucher_sales_acc: [
              {
                amount: 0,
                rate: "",
                account_id: null,
              },
            ],
            voucher_contra_partial_pay: [
              {
                nature: { label: "Cr", value: "credit" },
                account_id: null,
                amount: 0,
                date: moment(now, "DD-MM-MMMM").toDate(),
                // credit: 0,
                voucher_id: null,
                // partial_payments: [],
              },
            ],
            credit_id: null,
            debit_id: null,
          })
          console.log(`update`, update, data)
        }
        // dispatch(changeSidebarSize("lg"))
      } catch (err) {
        toastError(err?.message)
      } finally {
        setIsLoading(false)
      }
    }
  }
  const handlePoChange = () => {
    const { po_id } = getValues()
    fetchPotData(po_id?.value)
    setIdPO(po_id?.value)
  }

  const handleVoucherType = e => {
    console.log("handleVoucherType :", e)
    reset({
      voucher_id: {
        label: e?.label,
        value: e?.value,
        voucher_type: e?.voucher_type,
        ...e,
      },
    })
  }

  const handleDebitValue = (e, i) => {
    // if (
    //   watch(`voucher_contra.${i}.account_id`)?.account_group_id == 13 ||
    //   watch(`voucher_contra.${i}.account_id`)?.account_group_id == 22
    // ) {
    //   handleEditPartial(i)
    // } else {
    console.log(`handleDebitValue`, e, i)

    setValue(`voucher_contra.${i}.credit`, 0)
    // }
  }
  const handleCreditValue = (e, i) => {
    // if (
    //   watch(`voucher_contra.${i}.account_id`)?.account_group_id == 13 ||
    //   watch(`voucher_contra.${i}.account_id`)?.account_group_id == 22
    // ) {
    //   handleEditPartial(i)
    // } else {
    setValue(`voucher_contra.${i}.debit`, 0)
    // }
  }

  const handleSalesType = (e, i) => {
    console.log(`handleSalesType`, e, i)
    const dataVal = getValues()
    const mainVal = dataVal?.voucher_sales_acc?.[0]?.amount
    console.log(`dataVal chk`, dataVal)

    // const reducedVal = dataVal?.voucher_sales_acc.reduce((sum, item, index) => {
    //   if (index === i) return sum // Skip current index
    //   return sum + parseFloat(item.amount || 0)
    // }, 0)

    const reducedVal = dataVal?.voucher_sales_acc
      ?.filter(
        (item, index) =>
          index !== i && Number(item?.account_id?.is_vat_applicable) === 1
      )
      .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)

    console.log(`reducedVal`, reducedVal)

    // const calculatedVal = (Number(e?.vat_per || 0) / 100) * Number(mainVal)
    if (e?.account_group_id == 17) {
      const vatPer = reducedVal == 0 ? 0 : e?.vat_per || 0
      const vatCheckType = e?.vat_cal

      setValue(`voucher_sales_acc.${i}.rate`, vatPer)
      setValue(
        `voucher_sales_acc.${i}.amount`,
        (
          (Number(vatPer) / 100) *
          Number(vatCheckType == 2 ? Number(reducedVal) : Number(mainVal))
        ).toFixed(2)
      )
    } else if (
      ![13, 22]?.includes(Number(e?.account_group_id)) ||
      ![13, 22]?.some(item => e?.account_group?.parent_ids?.includes(item))
      // [24, 25, 27, 28]?.includes(Number(e?.account_group_id)) ||
      // [24, 25, 27, 28]?.some(item =>
      //   e?.account_group?.parent_ids?.includes(item)
      // )
    ) {
      setViewData({
        voucher_type: e?.account_group_id,
        ledger_id: e?.id,
        currIndex: i,
        taxChk: e?.is_vat_applicable,
        showCC: true,
      })
      setValue("cost_center_id", null)
      setCCModal(true)
    }
  }

  const handleRateChange = (e, i) => {
    const dataVal = getValues()
    const mainVal = dataVal?.voucher_sales_acc?.[0]?.amount
    console.log(`mainVal`, mainVal)
    const calculatedVal = (Number(e) / 100) * Number(mainVal)
    const chkDutiesGroup = watch(
      `voucher_sales_acc.${i}.account_id`
    )?.account_group_id

    console.log(`chkDutiesGroup`, dataVal)

    if (chkDutiesGroup == 17) {
      const vatPer = watch(`voucher_sales_acc.${i}.account_id`)?.vat_per || 0
      const vatCheckType = watch(`voucher_sales_acc.${i}.account_id`)?.vat_cal
      console.log(`vatCheckType`, vatCheckType)

      const reducedVal = dataVal?.voucher_sales_acc.reduce(
        (sum, item, index) => {
          if (index === i) return sum // Skip current index
          return sum + parseFloat(item.amount || 0)
        },
        0
      )

      console.log()

      setValue(
        `voucher_sales_acc.${i}.amount`,
        (
          (Number(e) / 100) *
          Number(vatCheckType == 2 ? Number(reducedVal) : Number(mainVal))
        ).toFixed(2) || 0
      )
    } else {
      setValue(
        `voucher_sales_acc.${i}.amount`,
        Number(calculatedVal || 0).toFixed(2)
      )
    }
    console.log(`calculatedVal`, calculatedVal, e)
  }

  const handleDebitValueRef = (e, i) => {
    setValue(`voucher_contra_ref.${i}.credit`, 0)
  }
  const handleCreditValueRef = (e, i) => {
    setValue(`voucher_contra_ref.${i}.debit`, 0)
  }

  const handleNature = (e, i, c) => {
    console.log(`handleNature`, c, watch("voucher_contra_partial_pay"))

    const paymentValues = getValues()

    setValue(`voucher_contra.${i}.account_id`, null)
    setValue(`voucher_contra.${i}.debit`, 0)
    setValue(`voucher_contra.${i}.credit`, 0)
    setValue(`voucher_contra.${i}.partial_payments`, [])

    const mappingData =
      c == "ref"
        ? paymentValues?.voucher_contra_ref
        : paymentValues?.voucher_contra
    const setData = c == "ref" ? "voucher_contra_ref" : "voucher_contra"

    const { totalDebit, totalCredit } = mappingData?.reduce(
      (totals, entry) => {
        const debit = parseFloat(entry.debit || 0)
        const credit = parseFloat(entry.credit || 0)
        return {
          totalDebit: totals.totalDebit + debit,
          totalCredit: totals.totalCredit + credit,
        }
      },
      { totalDebit: 0, totalCredit: 0 }
    )

    console.log(`totalDebit`, totalDebit, `totalCredit`, totalCredit)

    if (e == "credit") {
      setValue(`${setData}.${i}.debit`, 0)
      setValue(
        `${setData}.${i}.credit`,
        totalDebit - totalCredit <= 0 ? 0 : totalDebit - totalCredit
      )
    } else {
      setValue(`${setData}.${i}.credit`, 0)
      setValue(
        `${setData}.${i}.debit`,
        totalCredit - totalDebit <= 0 ? 0 : totalCredit - totalDebit
      )
    }
  }

  // const handleAppendContraRow = () => {
  //   const paymentValues = getValues()
  //   const lastIndex = paymentValues?.voucher_contra?.length - 1
  //   const mappingData = paymentValues?.voucher_contra
  //   const setData = "voucher_contra"

  //   const { totalDebit, totalCredit } = mappingData?.reduce(
  //     (totals, entry) => {
  //       const debit = parseFloat(entry.debit || 0)
  //       const credit = parseFloat(entry.credit || 0)
  //       return {
  //         totalDebit: totals.totalDebit + debit,
  //         totalCredit: totals.totalCredit + credit,
  //       }
  //     },
  //     { totalDebit: 0, totalCredit: 0 }
  //   )

  //   contraListAppend({
  //     nature:
  //       paymentValues?.voucher_contra?.[lastIndex]?.nature?.value == "debit"
  //         ? { label: "Cr", value: "credit" }
  //         : { label: "Dr", value: "debit" },
  //     account_id: null,
  //     debit:
  //       paymentValues?.voucher_contra?.[lastIndex]?.nature?.value == "debit"
  //         ? totalDebit
  //         : 0,
  //     credit:
  //       paymentValues?.voucher_contra?.[lastIndex]?.nature?.value == "credit"
  //         ? totalCredit
  //         : 0,
  //   })
  // }

  const handleAppendContraRow = () => {
    const paymentValues = getValues()
    const mappingData = paymentValues?.voucher_contra || []
    const lastIndex = mappingData.length - 1 // Fix: Get correct last item index

    const { totalDebit, totalCredit } = mappingData.reduce(
      (totals, entry) => {
        const debit = parseFloat(entry.debit || 0)
        const credit = parseFloat(entry.credit || 0)
        return {
          totalDebit: totals.totalDebit + debit,
          totalCredit: totals.totalCredit + credit,
        }
      },
      { totalDebit: 0, totalCredit: 0 }
    )

    if (
      totalDebit &&
      totalCredit &&
      Number(totalDebit).toFixed(desimalrange || 2) ===
        Number(totalCredit).toFixed(desimalrange || 2)
    ) {
      // handleSubmit(handleRegistration)()
      return
    }

    const newIndex = mappingData.length

    const lastNature = mappingData?.[lastIndex]?.nature?.value

    const newNature =
      lastNature == "debit"
        ? { label: "Cr", value: "credit" }
        : { label: "Dr", value: "debit" }

    console.log(`lastNature`, totalCredit, totalDebit)

    contraListAppend({
      nature:
        Number(totalCredit) > Number(totalDebit)
          ? { label: "Dr", value: "debit" }
          : { label: "Cr", value: "credit" },
      account_id: null,
      debit:
        Number(totalCredit) > Number(totalDebit)
          ? (Number(totalCredit) - Number(totalDebit)).toFixed(
              desimalrange || 2
            )
          : 0,
      credit:
        Number(totalDebit) > Number(totalCredit)
          ? (Number(totalDebit) - Number(totalCredit)).toFixed(
              desimalrange || 2
            )
          : 0,
    })
    setTimeout(() => {
      const newIndex = mappingData.length // newly added row
      natureRefs.current[newIndex]?.focus() // Focus react-select input
    }, 50)
  }

  const handleAppendSaleAccRow = () => {
    salesAccAppend({
      amount: 0,
      rate: "",
      account_id: null,
    })
  }

  const handleRefAgainst = (e, i) => {
    console.log(
      `voucher_contra_partial_pay`,
      watch("voucher_contra_partial_pay")
    )

    setSelectedAgainstRef(watch("voucher_contra_partial_pay"))

    setViewVouchersLi(e?.value == 2 ? true : false)
    setContraId(i)
  }

  const handleType = (e, i) => {
    console.log(`handleType`, e, i, watch("voucher_contra_partial_pay"))

    setValue(`voucher_contra_partial_pay`, [])
    setValue(`voucher_contra.${i}.partial_payments`, [])
    setValue(`voucher_contra.${i}.bank_amount`, 0)
    setValue(`voucher_contra.${i}.payment_type_id`, null)
    setValue(`voucher_contra.${i}.instrument_no`, "")

    // if (e?.account_group_id == 13 || e?.account_group_id == 22) {
    if (e?.is_bill_wise == 1) {
      const removeIds = watch("voucher_contra_partial_pay")?.map((item, i) => i)
      removeIds &&
        removeIds?.length > 1 &&
        removeIds?.map(i => contraPartialListRemove(i))
      const credtDays = Number(e?.period || 30)
      const givenDate = watch("ref_date") ? watch("ref_date") : watch("po_date")
      console.log(`givenDate`, givenDate)

      setViewData({
        voucher_type: e?.account_group_id == 13 ? 13 : 15,
        ledger_id: e?.id,
        currIndex: i,
        taxChk: e?.is_vat_applicable,
        showCC: true,
      })
      setValue(`voucher_contra_partial_pay.${0}.chk`, i)
      setValue(
        `voucher_contra_partial_pay.${0}.amount`,
        watch(`voucher_contra.${i}.debit`) != 0
          ? watch(`voucher_contra.${i}.debit`)
          : watch(`voucher_contra.${i}.credit`)
      )
      setValue(
        `voucher_contra_partial_pay.${0}.code`,
        watch("ref_code") ? watch("ref_code") : watch("code")
      )
      setValue(
        `voucher_contra_partial_pay.${0}.nature`,
        watch(`voucher_contra.${i}.nature`)
        //   {
        //   label: "Dr",
        //   value: "debit",
        // }
      )
      setValue(`voucher_contra_partial_pay.${0}.ref_id`, {
        label: "New Ref",
        value: 3,
      })
      setValue(
        `voucher_contra_partial_pay.${0}.date`,
        credtDays
          ? moment(givenDate).add(Number(credtDays), "days").toDate()
          : moment(now).toDate()
      )
      setValue(
        `voucher_contra_partial_pay.${0}.bill_date`,
        moment(givenDate).toDate()
      )

      setModal(true)
    } else if (e?.is_vat_applicable == 1) {
      console.log(`hi is_vat_applicable`, e)
      setViewData({
        voucher_type: e?.account_group_id == 13 ? 13 : 15,
        ledger_id: e?.id,
        currIndex: i,
        taxChk: e?.is_vat_applicable,
        showCC: true,
      })
      setValue(
        `transaction_type`,
        e?.nature_of_transaction?.id
          ? {
              value: e?.nature_of_transaction?.id,
              label: e?.nature_of_transaction?.label,
            }
          : null
      )
      // setTransactionModal(true)
      setValue("cost_center_id", null)
      setCCModal(true)
    } else if (
      ![13, 22]?.includes(Number(e?.account_group_id)) ||
      ![13, 22]?.some(item => e?.account_group?.parent_ids?.includes(item))
      // [24, 25, 27, 28]?.includes(Number(e?.account_group_id)) ||
      // [24, 25, 27, 28]?.some(item =>
      //   e?.account_group?.parent_ids?.includes(item)
      // )
    ) {
      setViewData({
        voucher_type: e?.account_group_id,
        ledger_id: e?.id,
        currIndex: i,
        taxChk: e?.is_vat_applicable,
        showCC: true,
      })
      setValue("cost_center_id", null)
      setCCModal(true)
    } else {
      // setValue(`voucher_contra.${i}.debit`, 0)
      // setValue(`voucher_contra.${i}.credit`, 0)
      setValue(`voucher_contra.${i}.partial_payments`, [])
    }

    if (e?.account_group_id == 17) {
      const paymentValues = getValues()
      const mappingData = paymentValues?.voucher_contra
      const setData = "voucher_contra"
      const vatPer =
        e?.vat_per != null ? e?.vat_per : loggedUser?.settings?.tax || 0
      const dataSide = watch(`voucher_contra.${i}.nature`)?.value

      console.log(`mappingData`, mappingData)

      const filteredData = mappingData?.filter(
        (entry, index) => Number(entry?.account_id?.is_vat_applicable) == 1
      )

      const { totalDebit, totalCredit } = filteredData?.reduce(
        (totals, entry, index) => {
          const vatApplicableChk = Number(entry?.account_id?.is_vat_applicable)
          const groupId = entry?.account_id?.account_group_id
          console.log(
            `vatApppp`,
            index == i,
            ![13, 22].includes(Number(groupId)),
            vatApplicableChk !== 1
          )

          if (
            index == i
            //  ||
            // (![13, 22].includes(Number(groupId)) && vatApplicableChk !== 1)
          )
            return totals

          // Skip if index matches i
          // if (index === i) return totals

          // // Skip if not VAT applicable
          // if (vatApplicableChk !== 1) return totals

          // // Skip if VAT applicable but group is not 13 or 22
          // if (vatApplicableChk === 1 && ![13, 22].includes(groupId))
          //   return totals

          console.log(`entry chk`, entry, totals, index)

          const debit = parseFloat(entry.debit || 0)
          const credit = parseFloat(entry.credit || 0)
          return {
            totalDebit: totals.totalDebit + debit,
            totalCredit: totals.totalCredit + credit,
          }
        },
        { totalDebit: 0, totalCredit: 0 }
      )

      const vatCalMethod = e?.vat_cal

      console.log(`totalDebit`, totalDebit, `totalCredit`, totalCredit != 0)

      const valueCal =
        dataSide === "debit" && vatCalMethod == 2
          ? totalDebit != 0
            ? totalDebit - totalCredit
            : totalDebit
          : dataSide === "credit" && vatCalMethod == 2
          ? totalCredit != 0
            ? totalCredit - totalDebit
            : totalCredit
          : dataSide === "debit" && vatCalMethod == 1
          ? totalDebit
          : dataSide === "credit" && vatCalMethod == 1
          ? totalCredit
          : 0

      const currPerVal = (Number(vatPer) / 100) * Math.abs(Number(valueCal))
      console.log(
        `vatCalMethod`,
        vatCalMethod,
        totalDebit,
        totalCredit,
        currPerVal,
        valueCal
      )

      setValue(
        `voucher_contra.${i}.${dataSide}`,
        Number(currPerVal).toFixed(desimalrange)
      )
    }

    if (e?.account_group_id == 5) {
      setViewData({
        voucher_type: e?.account_group_id,
        ledger_id: e?.id,
        currIndex: i,
        ...(e?.is_vat_applicable == 1 && { taxChk: e?.is_vat_applicable }),
        showCC: true,
      })
      setValue(`bank_date`, watch("po_date"))
      setValue(
        `bank_amount`,
        watch(`voucher_contra.${i}.credit`)
          ? Number(watch(`voucher_contra.${i}.credit`)).toFixed(
              desimalrange || 2
            )
          : watch(`voucher_contra.${i}.debit`)
          ? Number(watch(`voucher_contra.${i}.debit`)).toFixed(
              desimalrange || 2
            )
          : 0
      )
      setBankModal(true)
    }
  }
  const handleTypeAgainst = (e, i) => {
    setValue(`voucher_contra_ref.${i}.code`, "")
    setValue(`voucher_contra_ref.${i}.debit`, 0)
    setValue(`voucher_contra_ref.${i}.credit`, 0)
    if (
      e?.value == 2 &&
      (watch("voucher_contra_account_id")?.value == 13 || 15)
    ) {
      setViewData({
        voucher_type: watch("voucher_contra_account_id")?.value == 13 ? 13 : 15,
        ledger_id: watch("voucher_contra_account_id")?.id,
        currIndex: i,
        type: "ref",
        showCC: true,
      })
      setModal(true)
    }
  }

  const fetchRfqData = async id => {
    const response = await fetchRfqReference(id)
    const materialsArr = response?.items?.map((dt, i) => ({
      product_id: {
        label: dt?.product?.product_code,
        value: dt?.product?.id,
      },
      description: dt?.product?.description,
      qnt: dt?.quantity,
      unit_price: dt?.price ? dt?.price : 0,
      sub_price: Number(dt?.quantity || 0) * Number(dt?.price || 0),
      unit: {
        label: dt?.product?.unit?.unit_code,
        value: dt?.product?.unit_code?.id,
      },
    }))
    const data = getValues()
    reset({
      ...data,
      rfq_ref_code: response?.ref_code,
      material_request_id: response?.material_request_ids,
      rfq_id: {
        label: response?.code,
        value: response?.id,
      },
      credit_id: {
        label: response?.vendor?.name
          ? response?.vendor?.name
          : response?.vendor?.ledger?.name,
        value: response?.vendor?.ledger_id
          ? response?.vendor?.ledger_id
          : response?.vendor?.ledger_id,
      },
      request_date: response?.created_at,
      voucher_materials: materialsArr,
    })
  }

  const fetchMaterialRequstiotion = async id => {
    const responce = await fetchMRRequesting(id)
    const materialArr = responce?.data?.items?.map((dt, i) => ({
      material_id: {
        label: dt?.material?.product_code,
        value: dt?.material?.id,
        ...dt?.material,
      },
      description: dt?.material?.description,
      store: dt?.storeCount,
      qnt: dt?.quantity,
      rate: dt?.material?.price_aed,
      amount: Number(dt?.quantity || 0) * Number(dt?.material?.price_aed || 0),
      // bal_qnt: dt?.storeCount - dt?.quantity,
      id: dt?.id,
    }))
    setProjectID(responce?.data?.project?.id)
    const oldValue = getValues()
    reset({
      ...oldValue,
      voucher_source: materialArr,
      project_code: {
        label: location?.state?.project?.project_code,
        value: location?.state?.project?.id,
      },
    })
  }
  const fetchPotData = async idData => {
    const response = await fetchPurchase(idData)
    setResponseData(response?.data)
    if (idData == response.data?.id) {
      const arrayData = response.data?.purchaseorder_lists?.map(dt => {
        const TotalReceivedQty = dt.grnlist.reduce(
          (total, grnqty) => total + parseFloat(grnqty.received_quantity),
          0
        )

        const alreadyReceived = dt.grnlist.length
          ? dt.quantity - TotalReceivedQty
          : 0
        const Received = dt.grnlist.length ? alreadyReceived : dt.quantity

        return {
          product_code: dt?.product_code && {
            label: dt?.product_code.product_code,
            value: dt?.product_code.id,
          },
          description: dt.description,
          ordered_quantity: dt?.quantity,
          received_quantity: dt?.quantity - Received,
          pending_quantity: Received,
          unit: {
            value: dt?.unit?.id,
            label: dt?.unit?.unit_code,
          },
        }
      })

      const previousDatas = getValues()
      reset({
        ...previousDatas,
        project_id: response.data?.project_id,
        // material_request_id: response?.data?.material_request_id,
        // po_date: moment(response.data?.created_at).format("DD-MM-YYYY"),
        // mr_no: response.data?.material_request_id?.material_requests_code,
        // mr_date: moment(response.data?.material_request_id?.created_at).format(
        //   "DD-MM-YYYY"
        // ),
        // supplier_code: response.data?.supplier?.suppliers_code,
        // supplier_name: response.data?.supplier?.name,
        grnproductlist: arrayData,
        // pay_terms: response.data?.pay_terms,
        // recieved_date: moment().format("YYYY-MM-DD"),
      })
    }
  }

  const handleCompanyProduct = (e, index) => {
    setValue(`voucher_materials.${index}.description`, e?.description)
    setValue(`voucher_materials.${index}.unit`, {
      label: e?.unit?.unit_code,
      value: e?.unit?.id,
    })
    setValue(`voucher_materials.${index}.unit_price`, e?.price_aed)
  }

  const handleWithoutRefProduct = (e, index) => {
    console.log(`handleWithoutRefProduct`, e)
    setValue(`voucher_purchase.${index}.description`, e?.description)
    setValue(`voucher_purchase.${index}.unit`, {
      label: e?.unit?.unit_code,
      value: e?.unit?.id,
    })
    setValue(`voucher_purchase.${index}.ordered_quantity`, 0)
    setValue(`voucher_purchase.${index}.qnt`, 1)
    setValue(`voucher_purchase.${index}.unit_price`, e?.price_aed)
    setValue(`voucher_purchase.${index}.sub_price`, e?.price_aed)
  }

  const handleSubPrice = (e, i) => {
    const singlePrice = watch(`voucher_materials.${i}.unit_price`)
    const subPrice =
      Number(watch(`voucher_materials.${i}.qnt`)) * Number(singlePrice)
    setValue(`voucher_materials.${i}.sub_price`, subPrice)
  }

  const handleSubPricePurchase = (e, i) => {
    const singlePrice = watch(`voucher_purchase.${i}.unit_price`)
    const subPrice =
      Number(watch(`voucher_purchase.${i}.qnt`)) * Number(singlePrice)
    setValue(`voucher_purchase.${i}.sub_price`, subPrice)
  }

  const handleSourceQnt = (e, i) => {
    const singlePrice = watch(`voucher_source.${i}.rate`)
    const subPrice =
      Number(watch(`voucher_source.${i}.qnt`)) * Number(singlePrice)
    setValue(`voucher_source.${i}.amount`, subPrice)
  }
  const handleSourcePrice = (e, i) => {
    const singlePrice = watch(`voucher_source.${i}.qnt`)
    const subPrice =
      Number(watch(`voucher_source.${i}.rate`)) * Number(singlePrice)
    setValue(`voucher_source.${i}.amount`, subPrice)
  }

  const handleVatCheck = dt => {
    console.log(`handleVatCheck`, dt)
    // setValue(
    //   "vat_amount",
    //   !dt && watch("vat_id")?.vat_per != null
    //     ? watch("vat_id")?.vat_per
    //     : !dt && watch("vat_id")?.vat_per == null
    //     ? loggedUser?.settings?.tax
    //     : 0
    // )
    // vat_amount
    const data = getValues()
    reset({ ...data, vat_id: null, vat_amount: "" })
    // setValue("vat_id", null)
    // setValue("vat_amount", "")
    setVatCheck(!dt)
  }
  const handleDiscountCheck = dt => {
    setDiscountCheck(!dt)
    setValue("discount")
  }
  const handleDiscountAfterCheck = dt => {
    setDiscountAfterCheck(!dt)
  }
  const handleShippingCheck = dt => {
    setShippingCheck(!dt)
    setValue("shipping_charge", 0)
  }
  const handleOtherCheck = dt => {
    setOthersCheck(!dt)
    setValue("other_charge", 0)
  }
  const handlePDCCheck = dt => {
    setPdcCheck(!dt)
  }
  const handleCCCheck = dt => {
    setCostCenterCheck(!dt)
  }
  const handleBankModalClose = () => {
    setBankModal(false)
    setPdcCheck(false)
    setViewData({ ...viewData, showCC: true })
  }
  const handleRetentionCheck = dt => {
    setRetentionCheck(!dt)
    const retentionPercent = 0
    setValue("retention_id", null)
    // !dt
    //   ? Number(watch("project_ids")?.retention || 0)
    //   : 0
    const projectTotal = watch("sale_total") || 0
    const retentionAmount =
      (Number(projectTotal) * Number(retentionPercent)) / 100
    console.log(`retentionAmount`, retentionAmount, projectTotal)

    setValue("retention_amount", Number(retentionPercent))

    setValue("retention", Number(retentionAmount).toFixed(desimalrange))
  }
  const handleRetentionType = e => {
    const retentionPercent = Number(watch("project_ids")?.retention || 0)
    const projectTotal = watch("sale_total") || 0
    const retentionAmount =
      (Number(projectTotal) * Number(retentionPercent)) / 100
    console.log(`retentionAmount`, retentionAmount, projectTotal)

    setValue("retention_amount", Number(retentionPercent))

    setValue("retention", Number(retentionAmount).toFixed(desimalrange))
  }

  const handleRetentionPer = e => {
    const retentionPercent = retentionCheck ? watch("retention_amount") : 0
    const projectTotal = watch("sale_total")
    const retentionAmount =
      (Number(projectTotal) * Number(retentionPercent)) / 100
    // setValue("retention_amount", Number(retentionPercent).toFixed(desimalrange))
    console.log(`retentionAmount`, retentionAmount, e)

    setValue("retention", Number(retentionAmount).toFixed(desimalrange))
  }
  const handleAdvRetentionCheck = dt => {
    setAdvRetentionCheck(!dt)
    setValue("adv_retention_id", null)
    const retentionPercent = 0
    // !dt
    //   ? Number(watch("project_ids")?.advance_ad || 0)
    //   : 0
    const projectTotal = watch("sale_total")
    const retentionAmount =
      (Number(projectTotal) * Number(retentionPercent)) / 100
    setValue("adv_retention_amount", retentionPercent)
    setValue("adv_retention", Number(retentionAmount).toFixed(desimalrange))
  }
  const handleAdvRetentionType = e => {
    const retentionPercent = Number(watch("project_ids")?.advance_ad || 0)

    const projectTotal = watch("sale_total")
    const retentionAmount =
      (Number(projectTotal) * Number(retentionPercent)) / 100
    setValue("adv_retention_amount", retentionPercent)
    setValue("adv_retention", Number(retentionAmount).toFixed(desimalrange))
  }

  const handleAdvRetentionPer = e => {
    const retentionPercent = advRetentionCheck
      ? watch("adv_retention_amount")
      : 0
    const projectTotal = watch("sale_total")
    const retentionAmount =
      (Number(projectTotal) * Number(retentionPercent)) / 100
    // setValue("retention_amount", Number(retentionPercent).toFixed(desimalrange))
    console.log(`retentionAmount`, retentionAmount, e)

    setValue("adv_retention", Number(retentionAmount).toFixed(desimalrange))
  }

  useEffect(() => {
    if (retentionCheck) {
      const retentionPercent = watch("retention_amount") || 0
      const projectTotal = watch("sale_total") || 0
      const retentionAmount =
        (Number(projectTotal) * Number(retentionPercent)) / 100
      setValue("retention", Number(retentionAmount).toFixed(desimalrange))
    }
    if (advRetentionCheck) {
      const advretentionPercent = watch("adv_retention_amount") || 0
      const projectTotal = watch("sale_total") || 0
      const advretentionAmount =
        (Number(projectTotal) * Number(advretentionPercent)) / 100
      setValue(
        "adv_retention",
        Number(advretentionAmount).toFixed(desimalrange)
      )
    }
  }, [watch("sale_total")])

  const calculation = type => {
    const productWatch =
      watch(
        [15, 4].includes(watch(`voucher_id`)?.value)
          ? "voucher_purchase"
          : "voucher_materials"
      ) || []

    // const taxWatch =
    //   vatCheck && watch("vat_id")?.vat_per == null
    //     ? Number(loggedUser?.settings?.tax)
    //     : vatCheck && watch("vat_id")?.vat_per != null
    //     ? Number(watch("vat_id")?.vat_per)
    //     : 0

    const taxWatch =
      vatCheck && watch("vat_amount")
        ? Number(watch("vat_amount"))
        : vatCheck &&
          watch("vat_id")?.vat_per != null &&
          watch("debit_id")?.is_vat_applicable == 1
        ? Number(watch("vat_id")?.vat_per)
        : 0

    const discountWatch = Number(watch("discount")) || 0
    const otherChargeWatch = Number(watch("other_charge")) || 0
    const shippingChargeWatch = Number(watch("shipping_charge")) || 0

    switch (type) {
      case "price": {
        const price =
          productWatch?.reduce((a, b) => Number(b.unit_price) + a, 0) || 0
        return Number(price)?.toFixed(desimalrange)
      }
      case "quantity": {
        return productWatch?.reduce((a, b) => Number(b.qnt) + a, 0)
      }
      case "sub_total": {
        const products = productWatch || [] // Ensure productWatch is an array
        const subTotal = products.reduce((acc, product) => {
          const price = Number(product.unit_price)
          const quantity = Number(product.qnt)
          const rowTotal = price * quantity
          return acc + rowTotal
        }, 0)
        setValue(`sub_total`, Number(subTotal)?.toFixed(desimalrange))
        return Number(subTotal)?.toFixed(desimalrange)
      }
      case "discounted_amount": {
        const subTotal = calculation("sub_total")
        const discountedAmount = subTotal - (subTotal * discountWatch) / 100
        return Number(discountedAmount)?.toFixed(desimalrange)
      }
      case "discounted_amount_send": {
        const subTotal = calculation("sub_total")
        const discountedAmount = (subTotal * discountWatch) / 100
        return Number(discountedAmount)?.toFixed(desimalrange)
      }
      case "tax_total": {
        const baseAmount = discountCheck
          ? calculation("discounted_amount")
          : calculation("sub_total")

        const totalBeforeTax =
          Number(baseAmount) +
          Number(otherChargeWatch) +
          Number(shippingChargeWatch)
        const taxAmount = (totalBeforeTax * taxWatch) / 100
        return Number(taxAmount)?.toFixed(desimalrange)
      }
      case "total_amount": {
        const baseAmount = discountCheck
          ? calculation("discounted_amount")
          : calculation("sub_total")

        const totalBeforeTax =
          Number(baseAmount) +
          Number(otherChargeWatch) +
          Number(shippingChargeWatch)

        const taxAmount = (totalBeforeTax * taxWatch) / 100
        const totalAmount = Number(totalBeforeTax) + Number(taxAmount)
        setValue(`net_total`, Number(totalAmount)?.toFixed(desimalrange))
        return Number(totalAmount)?.toFixed(desimalrange || 2)
      }

      default:
        return 0
    }
  }

  useEffect(() => {
    const subValues = getValues()

    if (
      (subValues?.voucher_id?.value == 13 ||
        subValues?.voucher_id?.parent_id == 13) &&
      watch("manufacturing_journal_id")?.value &&
      !id
    ) {
      const subTotal = subValues?.sale_total
      const projectProfit =
        Number(
          subValues?.project_ids?.estimation_revision?.estimation
            ?.margin_percentage
        ) != 0
          ? Number(
              subValues?.project_ids?.estimation_revision?.estimation
                ?.margin_percentage
            )
          : Number(
              subValues?.project_ids?.estimation_revision?.estimation
                ?.margin_value
            ) != 0
          ? Number(
              (Number(
                subValues?.project_ids?.estimation_revision?.estimation
                  ?.margin_value
              ) /
                Number(
                  subValues?.project_ids?.estimation_revision?.estimation
                    ?.amount
                ) -
                Number(
                  subValues?.project_ids?.estimation_revision?.estimation
                    ?.margin_value
                )) *
                100
            ).toFixed(desimalrange)
          : 0

      const totalSumAmt =
        Number(subTotal) + (Number(subTotal) * projectProfit) / 100

      setValue(
        "sub_total",
        subValues?.voucher_id?.value == 13 ||
          subValues?.voucher_id?.parent_id == 13
          ? subTotal
          : totalSumAmt
      )
    }
  }, [watch("sale_total"), watch("manufacturing_journal_id")?.value])

  const calculationSale = type => {
    const productWatch =
      watch(
        watch(`voucher_id`)?.value == 15
          ? "voucher_purchase"
          : "voucher_materials"
      ) || []

    const salePriceWatch = watch("sale_total")
    console.log(`salePriceWatch`, salePriceWatch)

    const taxWatch =
      vatCheck && watch("vat_amount")
        ? Number(watch("vat_amount"))
        : vatCheck &&
          watch("vat_id")?.vat_per != null &&
          watch("debit_id")?.is_vat_applicable == 1
        ? Number(watch("vat_id")?.vat_per)
        : // : vatCheck && watch("vat_id")?.vat_per == null
          // ? Number(loggedUser?.settings?.tax)
          0

    // const taxWatch = vatCheck ? Number(watch("vat_amount")) : 0
    // && watch("vat_id")?.vat_per == null
    //   ? Number(loggedUser?.settings?.tax)
    //   : vatCheck && watch("vat_id")?.vat_per != null
    //   ? watch("vat_id")?.vat_per
    const retentionWatch = retentionCheck
      ? Number(watch("project_ids")?.retention || 0)
      : 0
    const advRetentionWatch = advRetentionCheck
      ? Number(watch("project_ids")?.advance_ad || 0)
      : 0
    const discountWatch = Number(watch("discount")) || 0
    const otherChargeWatch = Number(watch("other_charge")) || 0
    const shippingChargeWatch = Number(watch("shipping_charge")) || 0

    // setValue("sub_total", salePriceWatch)

    switch (type) {
      case "sub_total": {
        setValue(
          `sub_total`,
          Number(salePriceWatch || 0)?.toFixed(desimalrange)
        )
        return Number(salePriceWatch || 0)?.toFixed(desimalrange)
      }
      case "discounted_amount": {
        const subTotal = calculationSale("sub_total")
        const discountedAmount = subTotal - (subTotal * discountWatch) / 100
        return Number(discountedAmount)?.toFixed(desimalrange)
      }
      case "discounted_amount_send": {
        const subTotal = calculationSale("sub_total")
        const discountedAmount = (subTotal * discountWatch) / 100
        return Number(discountedAmount)?.toFixed(desimalrange)
      }

      case "tax_total": {
        const baseAmount = discountCheck
          ? calculationSale("discounted_amount")
          : calculationSale("sub_total")

        const calcuMethod = watch("vat_id")?.vat_cal

        console.log(`calcuMethodcalcuMethod`, watch("vat_id"))

        const taxWatch =
          vatCheck && watch("vat_amount")
            ? Number(watch("vat_amount"))
            : vatCheck &&
              watch("vat_id")?.vat_per != null &&
              watch("debit_id")?.is_vat_applicable == 1
            ? Number(watch("vat_id")?.vat_per)
            : 0

        const retentionValue = retentionCheck ? watch("retention") : 0
        const advRetentionValue = advRetentionCheck ? watch("adv_retention") : 0

        const totalBeforeTax =
          calcuMethod == 1
            ? Number(baseAmount) -
              Number(retentionValue) -
              Number(advRetentionValue)
            : Number(baseAmount)
        console.log(
          `totalBeforeTax`,
          totalBeforeTax,
          taxWatch,
          calcuMethod,
          retentionValue,
          advRetentionValue,
          baseAmount
        )

        const taxAmount = (totalBeforeTax * Number(taxWatch)) / 100
        return Number(taxAmount)?.toFixed(desimalrange)
      }
      case "total_amount": {
        const baseAmount = discountCheck
          ? calculationSale("discounted_amount")
          : calculationSale("sub_total")

        const calcuMethod = watch("vat_id")?.vat_cal

        const retentionValue = retentionCheck ? watch("retention") : 0
        const advRetentionValue = advRetentionCheck ? watch("adv_retention") : 0

        const totalBeforeTax =
          calcuMethod == 1
            ? Number(baseAmount) -
              Number(retentionValue) -
              Number(advRetentionValue)
            : !vatCheck
            ? Number(baseAmount) -
              Number(retentionValue) -
              Number(advRetentionValue)
            : Number(baseAmount)

        // const retentionAdded =
        //   (Number(salePriceWatch) * Number(retentionWatch)) / 100
        // const advRetentionAdded =
        //   (Number(salePriceWatch) * Number(advRetentionWatch)) / 100
        // const totalBeforeTax = Number(baseAmount)

        const taxAmount = (totalBeforeTax * taxWatch) / 100
        const totalAmount = Number(totalBeforeTax) + Number(taxAmount)
        setValue(`net_total`, Number(totalAmount)?.toFixed(2))
        return Number(totalAmount)?.toFixed(2)
      }

      default:
        return 0
    }
  }
  const voucherSource = useWatch({
    control,
    name: "voucher_source",
  })

  const calculateStockTotal = useMemo(() => {
    const price = voucherSource?.reduce((a, b) => Number(b.amount) + a, 0) || 0
    return Number(price)?.toFixed(desimalrange)
  }, [voucherSource])

  const handleVatType = e => {
    setValue(
      "vat_amount",
      watch("debit_id")?.is_vat_applicable == 1 ? Number(e?.vat_per || 0) : 0
    )
    console.log(`handleVatType`, e, watch("debit_id"))
  }

  const handleMatrial = async e => {
    const previousDatas = getValues()

    const response = await fetchRequestPOvoucher(e)
    setMaterialData(response)
    setProjectID(response?.data?.project?.id)
    // const projectVar = response?.data?.project?.var_value

    const Requestarray = response.data?.materials?.map(dt => ({
      id: dt?.id,
      product_id: {
        value: dt?.product?.id,
        label: dt?.product?.product_code,
      },
      description: dt?.product?.description,
      qnt: dt?.requested_quantity,
      unit_price: dt?.product?.price_aed,
      requested_quantity: dt?.requested_quantity,
      unit: {
        value: dt?.unit?.id,
        label: dt?.unit?.unit_code,
      },
      // short_supplier: supplierMap,
      sub_price:
        Number(dt?.requested_quantity) * Number(dt?.product?.price_aed),
    }))
    reset({
      ...previousDatas,
      request_date: response?.data?.request_date,
      exp_Delivery_date: response?.data?.exp_Delivery_date,
      voucher_materials: response?.data?.materials?.length
        ? Requestarray
        : [
            {
              product_code: null,
              description: "",
              quantity: "",
              discount: "",
              price: "",
              unit: null,
            },
          ],
    })
  }

  const handlePoReference = async e => {
    const previousDatas = getValues()

    const response = await fetchFinanceVoucherSingle(e)
    const materialDataArr = response?.data?.purchaseorder?.materials?.map(
      dt => ({
        id: dt?.id,
        product_id: {
          label: dt?.product?.product_code,
          value: dt?.product?.id,
        },
        unit: {
          label: dt?.product?.unit?.unit_code,
          value: dt?.product?.unit?.id,
        },
        description: dt?.product?.description,
        requested_quantity: dt?.requested_quantity,
        po_quantity: dt?.po_quantity,
        qnt: dt?.po_quantity,
        unit_price: dt?.unit_price,
      })
    )
    reset({
      ...previousDatas,
      // material_request_id: response?.data?.purchaseorder?.material_request_id,
      credit_id: response?.data?.credit?.id
        ? {
            label: response?.data?.credit?.name,
            value: response?.data?.credit?.id,
          }
        : null,
      purchase_order_id: response?.data?.purchaseorder?.id
        ? response?.data?.purchaseorder?.id
        : response?.data?.purchasevoucher?.purchase_order?.voucher_entry?.id,
      project_id: response?.data?.project_id,
      voucher_receipt: response?.data?.purchaseorder?.materials?.length
        ? materialDataArr
        : [
            {
              product_code: null,
              description: "",
              quantity: "",
              discount: "",
              price: "",
              unit: null,
            },
          ],
    })
  }

  const handleView = item => {
    setViewData(item)
    toggleSelect()
  }

  const handlePOSelect = async item => {
    console.log(`itemsss`, item)

    setPoData(item)

    const previousDatas = getValues()

    if (
      (([15].includes(previousDatas?.voucher_id?.value) ||
        [15].includes(Number(previousDatas?.voucher_id?.parent_id))) &&
        !modal) ||
      (([4].includes(previousDatas?.voucher_id?.value) ||
        [4].includes(previousDatas?.voucher_id?.parent_id)) &&
        !modal &&
        rSelected == 1) ||
      ((previousDatas?.voucher_id?.value == 18 ||
        previousDatas?.voucher_id?.parent_id == 18) &&
        rSelected == 4)
    ) {
      const response = await fetchFinanceVoucherSingle(item)
      let dataMap =
        response?.data?.purchaseorder != null
          ? response?.data?.purchaseorder
          : response?.data?.purchasevoucher != null
          ? response?.data?.purchasevoucher
          : response?.data?.salesvoucher != null
          ? response?.data?.salesvoucher
          : response?.data?.recipt_note

      let voucherFrom = response?.data?.purchaseorder != null ? 0 : 1

      const materialDataArr = dataMap?.materials?.map(dt => {
        const voucherId = response?.data?.voucher_id
        const poQty = Number(dt?.po_quantity) || 0

        let qnt = 0
        let totalVoucherQty = 0

        if (voucherId === 15) {
          qnt = poQty.toFixed(desimalrange)
        } else if (voucherId === 16) {
          totalVoucherQty = (dt?.purchase_voucher_details || []).reduce(
            (sum, item) => sum + (Number(item?.voucher_quantity) || 0),
            0
          )
          qnt = (poQty - totalVoucherQty).toFixed(desimalrange) // ✅ Fixed as per your request
        } else if (voucherId === 13) {
          qnt = Number(dt?.so_quantity).toFixed(desimalrange)
        } else {
          qnt = Number(dt?.grn_quantity).toFixed(desimalrange)
        }

        const orderedQty = [15, 16].includes(voucherId)
          ? dt?.po_quantity
          : voucherId === 13
          ? dt?.so_quantity
          : dt?.grn_quantity

        const subPrice = [15, 16, 13].includes(voucherId)
          ? Number(
              Number(voucherId === 13 ? dt?.so_quantity : dt?.po_quantity) *
                Number(dt?.unit_price || 0)
            ).toFixed(desimalrange)
          : Number(
              Number(dt?.grn_quantity) * Number(dt?.unit_price || 0)
            ).toFixed(desimalrange)

        return {
          id: dt?.id,
          product_id: {
            label: dt?.product?.product_code,
            value: dt?.product?.id,
          },
          voucher_from: voucherFrom,
          unit: {
            label: dt?.product?.unit?.unit_code,
            value: dt?.product?.unit?.id,
          },
          description: dt?.product?.description,
          requested_quantity: dt?.requested_quantity,
          grn_quantity: dt?.grn_quantity,
          po_quantity: dt?.po_quantity,
          qnt,
          already_created: totalVoucherQty || 0,
          unit_price: Number(dt?.unit_price).toFixed(desimalrange),
          ordered_quantity: orderedQty,
          sub_price: subPrice,
        }
      })

      console.log(`materialDataArr`, materialDataArr)

      reset({
        ...previousDatas,
        material_request_id: response?.data?.purchaseorder?.material_request_id,
        purchase_order_id: response?.data?.purchaseorder?.id
          ? response?.data?.purchaseorder?.id
          : response?.data?.purchase_order_id,
        project_id: response?.data?.project_id,
        inv_date: response?.data?.date,
        voucher_purchase: dataMap?.materials?.length
          ? materialDataArr
          : [
              {
                product_code: null,
                description: "",
                quantity: "",
                discount: "",
                price: "",
                unit: null,
              },
            ],
        ...(rSelected == 4 && {
          voucher_materials: dataMap?.materials?.length
            ? materialDataArr
            : [
                {
                  product_code: null,
                  description: "",
                  qnt: "",
                  discount: "",
                  price: "",
                  unit: null,
                },
              ],
        }),
      })
    } else if (
      (previousDatas?.voucher_id?.value == 18 ||
        previousDatas?.voucher_id?.parent_id == 18) &&
      rSelected == 1 &&
      !modal
    ) {
      const response = await fetchFinanceVoucherSingle(item)
      setProjectID(response?.data?.project?.id)
      reset({
        ...previousDatas,
        inv_date: response?.data?.date,
        sale_total: Number(response?.data?.sale_total).toFixed(desimalrange),
        project_ids: response?.data?.project?.id
          ? {
              value: response?.data?.project?.id,
              label: response?.data?.project?.project_code,
            }
          : null,
        manufacturing_journal_id: response?.data?.manufacturing_journal?.id
          ? {
              value: response?.data?.manufacturing_journal?.id,
              label: response?.data?.manufacturing_journal?.code,
            }
          : null,
        sale_unit: 1,
        sale_qty: "Lsm",
      })
    } else if (
      ([4, 18].includes(previousDatas?.voucher_id?.value) ||
        [4, 18].includes(previousDatas?.voucher_id?.parent_id)) &&
      rSelected == 2 &&
      !modal
    ) {
      return
      // const response = await fetchFinanceVoucherSingle(item)
      // const journalEntriesArr =
      //   response?.data?.journalEntry?.journal_entry_details?.map(dt => ({
      //     id: dt?.id,
      //     nature: dt?.debit_amount
      //       ? { label: "Cr", value: "credit" }
      //       : { label: "Dr", value: "debit" },
      //     account_id: {
      //       label: dt?.ledger?.name,
      //       value: dt?.ledger?.id,
      //     },
      //     debit: dt?.credit_amount
      //       ? Number(dt?.credit_amount).toFixed(desimalrange)
      //       : 0,
      //     credit: dt?.debit_amount
      //       ? Number(dt?.debit_amount).toFixed(desimalrange)
      //       : 0,
      //   }))

      // console.log(`journalEntriesArr`, journalEntriesArr)

      // reset({
      //   ...previousDatas,
      //   inv_date: response?.data?.date,
      //   voucher_contra: journalEntriesArr?.length
      //     ? journalEntriesArr
      //     : [
      //         {
      //           nature: null,
      //           account_id: "",
      //           debit: 0,
      //           credit: 0,
      //         },
      //       ],
      // })
    } else if (
      ([4, 18].includes(previousDatas?.voucher_id?.value) ||
        [4, 18].includes(previousDatas?.voucher_id?.parent_id)) &&
      rSelected == 3 &&
      !modal
    ) {
      const response = await fetchFinanceVoucherSingle(item)
      let saleAccArrRe =
        response?.data?.journalEntry?.journal_entry_details?.slice(0, -1)

      let saleAccArr = saleAccArrRe?.map((dt, index) => ({
        account_id: {
          label: dt?.ledger_name,
          value: dt?.ledger_id,
          ...dt,
        },
        amount:
          Number(dt?.credit_amount) &&
          response?.data?.voucher_invoice == "Sales Account"
            ? Number(dt?.credit_amount)
            : Number(dt?.debit_amount) &&
              response?.data?.voucher_invoice == "Sales Account"
            ? -Number(dt?.debit_amount)
            : Number(dt?.debit_amount) &&
              response?.data?.voucher_invoice == "Purchase Account"
            ? Number(dt?.debit_amount)
            : -Number(dt?.credit_amount),

        rate:
          index === 0
            ? ""
            : `${
                Number(dt?.debit_amount) &&
                response?.data?.voucher_invoice == "Sales Account"
                  ? "-"
                  : Number(dt?.credit_amount) &&
                    response?.data?.voucher_invoice == "Purchase Account"
                  ? "-"
                  : ""
              }${(
                (Number(dt?.credit_amount || dt?.debit_amount) /
                  Number(
                    saleAccArrRe[0]?.credit_amount ||
                      saleAccArrRe[0]?.debit_amount
                  )) *
                100
              ).toFixed(2)}`,
      }))

      reset({
        ...previousDatas,
        inv_date: response?.data?.date,
        voucher_sales_acc: saleAccArr?.length
          ? saleAccArr
          : [
              {
                amount: 0,
                rate: "",
                account_id: null,
              },
            ],
      })
    } else {
      // const partialPayment =
      console.log(`chk data new `, item)

      setValue(
        viewData?.type == "ref"
          ? `voucher_contra_ref.${contraId}.credit`
          : `voucher_contra_partial_pay.${contraId}.amount`,
        Number(item?.amount || 0).toFixed(desimalrange || 2)
      )
      setValue(
        viewData?.type == "ref"
          ? `voucher_contra_ref.${contraId}.voucher_id`
          : `voucher_contra_partial_pay.${contraId}.voucher_id`,
        item?.id
      )
      setValue(
        viewData?.type == "ref"
          ? `voucher_contra_ref.${contraId}.code`
          : `voucher_contra_partial_pay.${contraId}.code`,
        item?.code
      )
    }

    // toggleSelect()
    // setModal(false)
    setContraId(null)
    setViewVouchersLi(false)
  }

  const handleGrn = async e => {
    setPoData(e)

    const previousDatas = getValues()

    const response = await fetchFinanceVoucherSingle(e)
    let dataMap = response?.data?.grns

    let voucherFrom = response?.data?.purchaseorder != null ? 0 : 1

    const materialDataArr = dataMap?.materials?.map(dt => ({
      id: dt?.id,
      product_id: {
        label: dt?.product?.product_code,
        value: dt?.product?.id,
      },
      voucher_from: voucherFrom,
      unit: {
        label: dt?.product?.unit?.unit_code,
        value: dt?.product?.unit?.id,
      },
      description: dt?.product?.description,
      requested_quantity: dt?.requested_quantity,
      grn_quantity: dt?.grn_quantity,
      po_quantity: dt?.po_quantity,
      qnt: Number(dt?.grn_quantity).toFixed(desimalrange),
      unit_price: Number(dt?.unit_price).toFixed(desimalrange),
      ordered_quantity: dt?.po_quantity,
      sub_price: Number(
        Number(dt?.grn_quantity) * Number(dt?.unit_price || 0)
      ).toFixed(desimalrange),
    }))
    console.log(`materialDataArr`, materialDataArr)

    reset({
      ...previousDatas,
      material_request_id: response?.data?.purchaseorder?.material_request_id,
      purchase_order_id: response?.data?.purchaseorder?.id
        ? response?.data?.purchaseorder?.id
        : response?.data?.purchase_order_id,
      project_id: response?.data?.project_id,
      inv_date: response?.data?.date,
      voucher_purchase: dataMap?.materials?.length
        ? materialDataArr
        : [
            {
              product_code: null,
              description: "",
              quantity: "",
              discount: "",
              price: "",
              unit: null,
            },
          ],
      ...(rSelected == 4 && {
        voucher_materials: dataMap?.materials?.length
          ? materialDataArr
          : [
              {
                product_code: null,
                description: "",
                qnt: "",
                discount: "",
                price: "",
                unit: null,
              },
            ],
      }),
    })
  }

  const handleProjectNum = e => {
    // setProjectID(e?.id)
    setValue(
      `sale_total`,
      (
        Number(e?.grand_with_total || 0) -
        Number(e?.partialsale_sum_amount || 0)
      ).toFixed(desimalrange)
    )

    setValue(
      `sub_total`,
      (
        Number(e?.grand_with_total || 0) -
        Number(e?.partialsale_sum_amount || 0)
      ).toFixed(desimalrange)
      // parseFloat(e?.grand_with_total || 0).toFixed(desimalrange)
    )
    setValue(`sale_unit`, "Lsm")
    setValue(`sale_qty`, "1")
  }

  const handleProjectNumReset = e => {
    setProjectID(e?.id)
    const oldVal = getValues()
    reset({
      ...oldVal,
      sale_total: 0,
      manufacture_id: null,
    })
    // setValue(`sub_total`, 0)
    // setValue(`manufacture_id`, null)
  }

  function ucfirst(str) {
    var firstLetter = str.substr(0, 1)
    return firstLetter.toUpperCase() + str.substr(1)
  }

  const [financeVoucherli, setFinanceVoucherLi] = useState()
  const RemoveItem = [
    "Payroll",
    // "Debit Note",
    "Rejection Out",
    // "Receipt Note",
    "Reversing Journal",
    "Material In",
    "Material Out",
    "Sales Order",
    "Memorandum",
    "Rejection In",
    "Delivery Note",
    "Goods Receipt Note",
    "Stock Journal",
    "Purchase Order",
    "Opening Balance",
  ]
  const [isCardOpen, setCardOpen] = useState(!editId ? true : false)

  const financeVoucherLi = async () => {
    setIsVoucherLoading(true)
    const voucherIdChk = getValues("voucher_id")
    console.log(`chkchk`, voucherIdChk)

    try {
      const responce = await getFinanceVoucherLi()
      setFinanceVoucherLi(responce?.data)
      if (!editId) {
        setValue(
          "voucher_id",
          voucherIdChk != undefined
            ? voucherIdChk
            : {
                label: responce?.data[0]?.voucher_type,
                value: responce?.data[0]?.id,
                ...responce?.data[0],
              }
        )
      }
    } finally {
      setIsVoucherLoading(false)
      setActiveItemId(voucherIdChk != undefined ? voucherIdChk?.value : 1)
      // activeItemId != null ? setActiveItemId(activeItemId) : setActiveItemId(1)
    }
  }

  useEffect(() => {
    financeVoucherLi()
  }, [])

  const handilFinaceChnage = e => {
    setActiveItemId(e.id)
    const resetValues = getValues()
    const removeIds = watch("voucher_contra")?.map((item, i) => i)
    removeIds && removeIds?.length && removeIds?.map(i => contraListRemove(i))

    // const currVoucherType = toSnakeCase(e?.voucher_type)

    const currVoucherType = ucfirst(e?.voucher_type)

    getUniqueCode("ref_number", "VoucherEntry", `Voucher - ${currVoucherType}`)
    setRSelected(2)
    setVatCheck(false)
    setDiscountCheck(false)
    setShippingCheck(false)
    setOthersCheck(false)
    setRetentionCheck(false)
    setAdvRetentionCheck(false)
    setDiscountAfterCheck(false)

    reset({
      voucher_id: {
        label: e?.voucher_type,
        value: e?.id || e?.value,
        voucher_type: e?.voucher_type,
        ...e,
      },
      code: resetValues?.code,
      // po_date: resetValues?.po_date,
      po_date: moment(now, "YYYY-MM-DD").toDate(),
      credit_id: null,
      debit_id: null,
      address:
        e?.id == 16 && loggedUser?.settings?.companyaddress
          ? loggedUser?.settings?.companyaddress
          : "",
    })
    if (
      [1, 3, 6, 8].includes(watch("voucher_id")?.value) ||
      [1, 3, 6, 8].includes(watch("voucher_id")?.parent_id) ||
      ([13, 18].includes(watch("voucher_id")?.value) && rSelected == 2) ||
      ([13, 18].includes(watch("voucher_id")?.parent_id) && rSelected == 2) ||
      [15, 4].includes(watch("voucher_id")?.value) ||
      [15, 4].includes(watch("voucher_id")?.parent_id) ||
      rSelected == 2
    ) {
      contraListAppend({
        nature:
          [1, 6, 13].includes(watch("voucher_id")?.value) ||
          [1, 6, 13].includes(watch("voucher_id")?.parent_id)
            ? { label: "Cr", value: "credit" }
            : { label: "Dr", value: "debit" },
        account_id: null,
        debit: "",
        credit: "",
      })
    }
  }

  const handilUpdate = () => {
    setEditPartial(false)
  }

  const handleRequestdate = e => {
    console.log(`handleRequestdate`, moment(e[0]).format("YYYY-MM-DD"))

    const voucherLabel = watch("voucher_id")?.label
      ? ucfirst(watch("voucher_id").label)
      : "Contra"

    if (watch("monthly_reset") == 1) {
      getUniqueCode(
        "ref_number",
        "VoucherEntry",
        `Voucher - ${voucherLabel}`,
        moment(e[0]).format("YYYY-MM-DD")
      )
    }
  }

  const handlePartyName = () => {
    const datas = getValues()
    // Reset the fields when Party Name is selected
    setValue("project_ids", null)
    setValue("manufacturing_journal_id", null)
    setValue("sale_unit", "")
    setValue("sale_qty", "")
    setValue("sale_total", 0)
    setValue("chk_sale_total", 0)
  }

  return (
    <React.Fragment>
      <div
        className={`${
          fromDashboard ? "pt-0 dashboard-page-content" : "page-content"
        }`}
      >
        <div className="container-fluid">
          <FormProvider>
            <Form
              id={`request-form`}
              onSubmit={handleSubmit(handleRegistration)}
            >
              <div className="sticky-top w-100">
                <div className="d-flex justify-content-between pe-3">
                  {fromDashboard ? (
                    <div></div>
                  ) : (
                    <Breadcrumbs
                      title="Finance"
                      breadcrumbObject={[
                        { title: "Finance", link: "/finance" },
                        {
                          title: crumb ? crumb : "Transaction",
                          link: "/finance",
                        },
                        { title: "Voucher Entries", link: "/finance-voucher" },
                        {
                          title: id
                            ? `${
                                watch("voucher_id")
                                  ? `Edit ${watch("voucher_id")?.label} Voucher`
                                  : "Edit Voucher"
                              }`
                            : `${
                                watch("voucher_id")
                                  ? `${watch("voucher_id")?.label} Voucher`
                                  : "Add Voucher"
                              }`,
                          link: "",
                        },
                      ]}
                    />
                  )}
                  <div className="d-flex">
                    {([13, 15, 4, 18].includes(watch("voucher_id")?.value) ||
                      [13, 15, 4, 18].includes(
                        watch("voucher_id")?.parent_id
                      )) &&
                    !editId ? (
                      <div className="me-2">
                        <ButtonGroup>
                          {[13, 18].includes(watch("voucher_id")?.value) ||
                          [13, 18].includes(watch("voucher_id")?.parent_id) ? (
                            <Button
                              color="primary px-2 m-0"
                              outline
                              onClick={() => setRSelected(4)}
                              active={rSelected === 4}
                            >
                              Sale Product
                            </Button>
                          ) : (
                            <></>
                          )}
                          {/* {watch("voucher_id")?.value == 13 ? ( */}
                          <Button
                            color="primary px-2 m-0"
                            outline
                            onClick={() => setRSelected(3)}
                            active={rSelected === 3}
                          >
                            Account Invoice
                          </Button>
                          <Button
                            color="primary px-2 m-0"
                            outline
                            onClick={() => setRSelected(1)}
                            active={rSelected === 1}
                          >
                            Item Invoice
                            {/* {watch("voucher_id")?.value == 13
                              ? "Item Invoice"
                              : "As Invoice"} */}
                          </Button>
                          <Button
                            color="primary px-2 m-0"
                            outline
                            onClick={() => setRSelected(2)}
                            active={rSelected === 2}
                          >
                            As Voucher
                          </Button>
                        </ButtonGroup>
                      </div>
                    ) : (
                      <></>
                    )}
                    {watch("voucher_id")?.value ? (
                      <LoadingButton
                        form={`request-form`}
                        color={"primary"}
                        loading={isLoading}
                        className={"px-2 mb-3 btn btn-primary"}
                        type="submit"
                      >
                        {id
                          ? "Update"
                          : watch(`voucher_id`)?.value == 16 ||
                            watch(`voucher_id`)?.parent_id == 16
                          ? "Send for Approval"
                          : "Save"}
                      </LoadingButton>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
              {console.log(`watch("voucher_id")`, watch("voucher_id"))}
              <Container fluid className="ps-lg-0">
                <Col lg="12">
                  <Row
                    className={isCardOpen === false && !editId ? "me-3" : ""}
                  >
                    <Col
                      lg={
                        location?.state?.type === "from_po"
                          ? "12"
                          : isCardOpen
                          ? "10"
                          : "12"
                      }
                    >
                      <Card className="invoice-main-card p-3 pt-4">
                        {watch("voucher_id")?.value == 15 ||
                        watch("voucher_id")?.parent_id == 15 ? (
                          <Row>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>
                                  {watch("voucher_id")?.label
                                    ? watch("voucher_id")?.label
                                    : "-"}{" "}
                                  No
                                </Label>
                                <UFInput
                                  control={control}
                                  placeholder="Code"
                                  name={`code`}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Supplier Inv Ref</Label>
                                <UFInput
                                  control={control}
                                  placeholder="Code"
                                  name={`ref_code`}
                                />
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Supplier Inv Date</Label>
                                <UFDate
                                  control={control}
                                  placeholder="Enter the Date "
                                  name={"ref_date"}
                                  disabled={true}
                                />
                                <FormFeedback invalid>
                                  {errors.ref_date?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Date</Label>
                                <UFDate
                                  control={control}
                                  placeholder="Enter the Date "
                                  name={"po_date"}
                                  disabled={true}
                                  onDateChange={e => handleRequestdate(e)}
                                />
                                <FormFeedback invalid>
                                  {errors.po_date?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                        ) : (
                          <Row>
                            <Col sm={9}>
                              {watch("voucher_id")?.label ? (
                                <div className="d-flex">
                                  <div className="voucher-label me-2">
                                    {watch("voucher_id")?.label
                                      ? watch("voucher_id")?.label
                                      : "-"}{" "}
                                    No :
                                  </div>
                                  <UFInput
                                    control={control}
                                    placeholder="Code"
                                    name={`code`}
                                    disabled={
                                      watch("code_edit") == 0 ||
                                      watch("code_edit") == "undefined"
                                        ? true
                                        : false
                                    }
                                    // lockFirstNChars={3}
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                            </Col>
                            {/* <Col sm={3}><div>Date</div></Col> */}
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                {/* <Label>Date</Label> */}
                                <UFDate
                                  control={control}
                                  placeholder="Enter the Date "
                                  name={"po_date"}
                                  disabled={true}
                                  onDateChange={e => handleRequestdate(e)}
                                />
                                <FormFeedback invalid>
                                  {errors.po_date?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          </Row>
                        )}
                        <Row className="mt-2">
                          <Col sm={6} lg={4} xl={3} className="d-none">
                            <FormGroup className="mb-4">
                              <Label>
                                Voucher Type{" "}
                                <span className="mandatory">*</span>
                              </Label>
                              <VoucherTypes
                                control={control}
                                placeholder="Select Voucher Type"
                                name={"voucher_id"}
                                target={fromDashboard ? ".modal" : "body"}
                                onSelectChange={e => handleVoucherType(e)}
                                invalid={!!errors.voucher_id}
                                disabled={
                                  editId
                                    ? true
                                    : location?.state?.id
                                    ? true
                                    : false
                                }
                                forInvoice={true}
                              />
                              <FormFeedback invalid>
                                {errors.voucher_id?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col>

                          {/* <Col sm={6} lg={4} xl={3}>
                            <FormGroup className="mb-4">
                              <Label>Date</Label>
                              <UFDate
                                control={control}
                                placeholder="Enter the Date "
                                name={"po_date"}
                                disabled={true}
                              />
                              <FormFeedback invalid>
                                {errors.po_date?.message}
                              </FormFeedback>
                            </FormGroup>
                          </Col> */}

                          {(watch("voucher_id")?.value == 11 ||
                            watch("voucher_id")?.parent_id == 11) && (
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>Reference</Label>
                                <MRRequstingLi
                                  control={control}
                                  name={"material_requisition_id"}
                                  placeholder={"Reference No"}
                                  target={fromDashboard ? ".modal" : "body"}
                                  onSelectChange={e =>
                                    fetchMaterialRequstiotion(e?.id)
                                  }
                                  // clearable={true}
                                  // approvedStatus={true}
                                  disabled={
                                    location?.state?.id
                                      ? true
                                      : editId
                                      ? true
                                      : false
                                  }
                                />
                                <FormFeedback invalid>
                                  {errors.material_requisition_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}
                          {/* {watch("voucher_id")?.value == 12 && (
                      <Col sm={3}>
                        <FormGroup className="mb-4">
                          <Label>Project</Label>
                          <ProjectNo
                            control={control}
                            name={"project_code"}
                            placeholder={"Project No"}
                            target={"body"}
                            // ledgerId={watch("credit_id")?.value}
                            disabled={
                              location?.state?.id ? true : editId ? true : false
                            }
                          />
                          <FormFeedback invalid>
                            {errors.project_code?.message}
                          </FormFeedback>
                        </FormGroup>
                      </Col>
                    )} */}
                          {(watch("voucher_id")?.value == 12 ||
                            watch("voucher_id")?.parent_id == 12) && (
                            <Col sm={6} lg={4} xl={3}>
                              <FormGroup>
                                <Label>
                                  From
                                  <span className="mandatory">*</span>
                                </Label>
                                <FinanceLedgersLi
                                  control={control}
                                  placeholder="Select"
                                  name={"credit_id"}
                                  invalid={!!errors.credit_id}
                                  target={"body"}
                                  showCreateOption={true}
                                  refreshTrigger={refreshDropdown}
                                  onSuccess={handleLedgerCreationSuccess}
                                  disabled={
                                    editId
                                      ? true
                                      : location?.state?.id
                                      ? true
                                      : false
                                  }
                                  groupId="12"
                                  selectedLedgers={watch("debit_id")}
                                  setValue={setValue}
                                />
                                <FormFeedback invalid>
                                  {errors.credit_id?.message}
                                </FormFeedback>
                              </FormGroup>
                              {/* </Col> */}
                              {/* <Col sm={3}> */}
                              {/* <FormGroup className="mb-4">
                          <Label>Project</Label>
                          <ProjectNo
                            control={control}
                            name={"project_id"}
                            placeholder={"Project No"}
                            target={"body"}
                            // ledgerId={watch("credit_id")?.value}
                            disabled={
                              location?.state?.id ? true : editId ? true : false
                            }
                          />
                          <FormFeedback invalid>
                            {errors.project_id?.message}
                          </FormFeedback>
                        </FormGroup> */}

                              {/* <div>
                          <div className="mb-2">Transfer Type</div>
                          <ButtonGroup>
                            <Button
                              color="primary transfer-type-btn"
                              outline
                              onClick={() => setRSelected(1)}
                              active={rSelected === 1}
                            >
                              Inward
                            </Button>
                            <Button
                              color="primary transfer-type-btn"
                              outline
                              onClick={() => setRSelected(2)}
                              active={rSelected === 2}
                            >
                              Outward
                            </Button>
                          </ButtonGroup>
                        </div> */}
                            </Col>
                          )}
                          {(watch("voucher_id")?.value == 12 ||
                            watch("voucher_id")?.parent_id == 12) && (
                            <Col sm={6} lg={4} xl={3}>
                              <FormGroup>
                                <Label>
                                  To
                                  <span className="mandatory">*</span>
                                </Label>
                                <FinanceLedgersLi
                                  control={control}
                                  placeholder="Select"
                                  name={"debit_id"}
                                  invalid={!!errors.debit_id}
                                  target={"body"}
                                  showCreateOption={true}
                                  refreshTrigger={refreshDropdown}
                                  onSuccess={handleLedgerCreationSuccess}
                                  disabled={
                                    editId
                                      ? true
                                      : location?.state?.id
                                      ? true
                                      : false
                                  }
                                  groupId="12"
                                  selectedLedgers={watch("credit_id")}
                                />
                                <FormFeedback invalid>
                                  {errors.debit_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}
                          {(watch("voucher_id")?.value == 16 ||
                            watch("voucher_id")?.parent_id == 16) && (
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>RFQ Reference</Label>
                                <RFQList
                                  control={control}
                                  name={"rfq_id"}
                                  placeholder={"Select the RFQ No"}
                                  target={fromDashboard ? ".modal" : "body"}
                                  onSelectChange={e => fetchRfqData(e?.id)}
                                  // clearable={true}
                                  approvedStatus={true}
                                  disabled={
                                    location?.state?.type === "from_po"
                                      ? false
                                      : location?.state?.id
                                      ? true
                                      : editId
                                      ? true
                                      : false
                                  }
                                />
                                <FormFeedback invalid>
                                  {errors.rfq_id?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}

                          {watch("rfq_id")?.value ? (
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>RFQ Reference</Label>
                                <UFInput
                                  control={control}
                                  name={"rfq_ref_code"}
                                  placeholder={"Reference Code"}
                                />
                              </FormGroup>
                            </Col>
                          ) : (
                            <></>
                          )}

                          {(watch("voucher_id")?.value == 7 ||
                            watch("voucher_id")?.parent_id == 7) && (
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>PO Reference</Label>
                                <VoucherEntryLi
                                  control={control}
                                  name={"purchase_order_id_ref"}
                                  placeholder={"Select the PO Reference"}
                                  target={fromDashboard ? ".modal" : "body"}
                                  voucherType={
                                    watch("voucher_id")?.value == 7 ||
                                    watch("voucher_id")?.parent_id == 7
                                      ? [16]
                                      : ""
                                  }
                                  onSelectChange={e => handlePoReference(e?.id)}
                                  statusApproved={true}
                                  clearable={true}
                                />
                                <FormFeedback invalid>
                                  {errors.purchase_order_id_ref?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}

                          {
                            // (watch("voucher_id")?.value == 15 &&
                            // rSelected == 1) ||
                            // (watch("voucher_id")?.value == 4 &&
                            //   rSelected == 1) ||
                            // watch("voucher_id")?.value == 16 ||
                            // ([13, 18].includes(watch("voucher_id")?.value) &&
                            //   rSelected == 1) ||
                            // rSelected == 3 ||
                            // rSelected == 4 ||
                            // ([4, 18].includes(watch(`voucher_id`)?.value) &&
                            //   rSelected == 2) ||
                            // watch(`voucher_id`)?.value == 7) && (
                            // vouchers needing rSelected == 1
                            (([15, 4, 13, 18].includes(
                              watch("voucher_id")?.value
                            ) &&
                              rSelected === 1) ||
                              ([15, 4, 13, 18].includes(
                                watch("voucher_id")?.parent_id
                              ) &&
                                rSelected === 1) ||
                              // voucher 16 or 7 always
                              [16, 7].includes(watch("voucher_id")?.value) ||
                              [16, 7].includes(
                                watch("voucher_id")?.parent_id
                              ) ||
                              // rSelected == 3 or 4 always
                              [3, 4].includes(rSelected) ||
                              // vouchers 4 or 18 need rSelected == 2
                              ([4, 18].includes(watch("voucher_id")?.value) &&
                                rSelected === 2) ||
                              ([4, 18].includes(
                                watch("voucher_id")?.parent_id
                              ) &&
                                rSelected === 2)) && (
                              <Col sm={6} lg={4} xl={3}>
                                <FormGroup>
                                  <Label>
                                    Party Name
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <FinanceLedgersLi
                                    control={control}
                                    placeholder="Select the Party Name"
                                    name={"credit_id"}
                                    invalid={!!errors.credit_id}
                                    target={"body"}
                                    groupId={
                                      [4, 15, 16].includes(
                                        watch("voucher_id")?.value
                                      ) ||
                                      [4, 15, 16].includes(
                                        watch("voucher_id")?.parent_id
                                      )
                                        ? 22
                                        : 13
                                    }
                                    showCreateOption={true}
                                    refreshTrigger={refreshDropdown}
                                    onSuccess={handleLedgerCreationSuccess}
                                    disabled={
                                      location?.state?.type === "from_po"
                                        ? false
                                        : editId
                                        ? true
                                        : location?.state?.id
                                        ? true
                                        : false
                                    }
                                    onSelectChange={e => handlePartyName()}
                                  />
                                  <FormFeedback invalid>
                                    {errors.credit_id?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            )
                          }
                          {([15].includes(watch("voucher_id")?.value) ||
                            [15].includes(watch("voucher_id")?.parent_id)) &&
                            rSelected == 1 && (
                              <Col sm={6} lg={4} xl={3}>
                                <FormGroup>
                                  <Label>GRN Reference</Label>

                                  <VoucherEntryLi
                                    control={control}
                                    name={"grn_id_ref"}
                                    placeholder={"GRN No"}
                                    target={fromDashboard ? ".modal" : "body"}
                                    voucherType={[7]}
                                    // purchaseVoucherId={watch("credit_id")?.value}
                                    grnVoucher={watch("credit_id")?.value}
                                    onSelectChange={e => handleGrn(e?.id)}
                                    disabled={
                                      watch("credit_id")?.value ? false : true
                                    }
                                    // clearable={true}
                                  />
                                  <FormFeedback invalid>
                                    {errors.reference?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            )}
                          {([15].includes(watch("voucher_id")?.value) ||
                            [15].includes(watch("voucher_id")?.parent_id)) &&
                            rSelected == 1 && (
                              <Col sm={6} lg={4} xl={3}>
                                <FormGroup>
                                  <Label>PO Reference</Label>

                                  <VoucherEntryLi
                                    control={control}
                                    name={"purchase_order_id_ref"}
                                    placeholder={"PO No"}
                                    target={fromDashboard ? ".modal" : "body"}
                                    voucherType={[16, 7]}
                                    partyName={watch("credit_id")?.value}
                                    onSelectChange={e => handlePOSelect(e?.id)}
                                    disabled={
                                      watch("credit_id")?.value ? false : true
                                    }
                                    statusApproved={true}
                                    // clearable={true}
                                  />
                                  <FormFeedback invalid>
                                    {errors.reference?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            )}
                          {([4].includes(watch("voucher_id")?.value) ||
                            [4].includes(watch("voucher_id")?.parent_id)) &&
                            [1, 2, 3, 4].includes(rSelected) && (
                              <Col sm={6} lg={4} xl={3}>
                                <FormGroup>
                                  <Label>Original INV No.</Label>

                                  <VoucherEntryLi
                                    control={control}
                                    name={"inv_num"}
                                    placeholder={"Select the Original INV No."}
                                    target={fromDashboard ? ".modal" : "body"}
                                    voucherType={[15]}
                                    // purchaseVoucherId={
                                    //   watch("credit_id")?.value
                                    // }
                                    supplierId={watch("credit_id")?.value}
                                    voucherInvoice={
                                      ([15, 4].includes(
                                        watch("voucher_id")?.value
                                      ) ||
                                        [15, 4].includes(
                                          watch("voucher_id")?.parent_id
                                        )) &&
                                      rSelected == 1
                                        ? "Purchase Invoice"
                                        : ([13, 18].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                            [13, 18].includes(
                                              watch("voucher_id")?.parent_id
                                            )) &&
                                          rSelected == 1
                                        ? "Sales Invoice"
                                        : ([13, 18].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                            [13, 18].includes(
                                              watch("voucher_id")?.parent_id
                                            )) &&
                                          rSelected == 3
                                        ? "Sales Account"
                                        : ([15, 4].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                            [15, 4].includes(
                                              watch("voucher_id")?.parent_id
                                            )) &&
                                          rSelected == 3
                                        ? "Purchase Account"
                                        : ([13, 18].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                            [13, 18].includes(
                                              watch("voucher_id")?.parent_id
                                            )) &&
                                          rSelected == 4
                                        ? "Sales Product Invoice"
                                        : ""
                                    }
                                    onSelectChange={e => handlePOSelect(e?.id)}
                                    disabled={
                                      id
                                        ? true
                                        : watch("credit_id")?.value ||
                                          rSelected == 2
                                        ? false
                                        : true
                                    }
                                    // clearable={true}
                                  />
                                  <FormFeedback invalid>
                                    {errors.inv_num?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            )}
                          {([18].includes(watch("voucher_id")?.value) ||
                            [18].includes(watch("voucher_id")?.parent_id)) &&
                            [1, 2, 3, 4].includes(rSelected) && (
                              <Col sm={6} lg={4} xl={3}>
                                <FormGroup>
                                  <Label>Original INV No.</Label>

                                  <VoucherEntryLi
                                    control={control}
                                    name={"inv_num"}
                                    placeholder={"Original INV No."}
                                    target={fromDashboard ? ".modal" : "body"}
                                    voucherType={[13]}
                                    salesVoucherId={watch("credit_id")?.value}
                                    voucherInvoice={
                                      ([15, 4].includes(
                                        watch("voucher_id")?.value
                                      ) ||
                                        [15, 4].includes(
                                          watch("voucher_id")?.parent_id
                                        )) &&
                                      rSelected == 1
                                        ? "Purchase Invoice"
                                        : ([13, 18].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                            [13, 18].includes(
                                              watch("voucher_id")?.parent_id
                                            )) &&
                                          rSelected == 1
                                        ? "Sales Invoice"
                                        : ([13, 18].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                            [13, 18].includes(
                                              watch("voucher_id")?.parent_id
                                            )) &&
                                          rSelected == 3
                                        ? "Sales Account"
                                        : ([15, 4].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                            [15, 4].includes(
                                              watch("voucher_id")?.parent_id
                                            )) &&
                                          rSelected == 3
                                        ? "Purchase Account"
                                        : ([13, 18].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                            [13, 18].includes(
                                              watch("voucher_id")?.parent_id
                                            )) &&
                                          rSelected == 4
                                        ? "Sales Product Invoice"
                                        : ""
                                    }
                                    onSelectChange={e => handlePOSelect(e?.id)}
                                    disabled={
                                      id
                                        ? true
                                        : watch("credit_id")?.value ||
                                          rSelected == 2
                                        ? false
                                        : true
                                    }
                                  />
                                  <FormFeedback invalid>
                                    {errors.inv_num?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            )}
                          {(watch("voucher_id")?.value == 15 ||
                            watch("voucher_id")?.value == 13 ||
                            watch("voucher_id")?.value == 18 ||
                            watch("voucher_id")?.value == 4 ||
                            [15, 13, 18, 4].includes(
                              watch("voucher_id")?.parent_id
                            )) &&
                            [1, 4].includes(rSelected) && (
                              <Col sm={6} lg={4} xl={3}>
                                <FormGroup>
                                  <Label>
                                    {[13, 18].includes(
                                      watch("voucher_id")?.value
                                    ) ||
                                    [13, 18].includes(
                                      watch("voucher_id")?.parent_id
                                    )
                                      ? "Sales Account"
                                      : "Purchase Ledger"}
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <FinanceLedgersLi
                                    control={control}
                                    placeholder="Select"
                                    name={"debit_id"}
                                    invalid={!!errors.debit_id}
                                    target={"body"}
                                    disabled={editId ? true : false}
                                    groupId={
                                      [13, 18].includes(
                                        watch("voucher_id")?.value
                                      ) ||
                                      [13, 18].includes(
                                        watch("voucher_id")?.parent_id
                                      )
                                        ? 26
                                        : 29
                                    }
                                    showCreateOption={true}
                                    refreshTrigger={refreshDropdown}
                                    onSuccess={handleLedgerCreationSuccess}
                                    setValue={setValue}
                                    // ledgerTypes={"asset&expence"}
                                  />
                                  <FormFeedback invalid>
                                    {errors.debit_id?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            )}
                          {(watch("voucher_id")?.value == 15 ||
                            watch("voucher_id")?.value == 13 ||
                            watch("voucher_id")?.value == 18 ||
                            watch("voucher_id")?.value == 4 ||
                            [15, 13, 18, 4].includes(
                              watch("voucher_id")?.parent_id
                            )) &&
                            [1, 4].includes(rSelected) && (
                              <Col sm={6} lg={4} xl={3}>
                                <FormGroup>
                                  <Label>
                                    Cost Center
                                    {/* <span className="mandatory">*</span> */}
                                  </Label>
                                  <FinCostCenterLi
                                    control={control}
                                    placeholder="Select"
                                    name={`cost_center_id`}
                                    invalid={!!errors?.cost_center_id}
                                  />
                                  <FormFeedback invalid>
                                    {errors?.cost_center_id?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            )}
                          {([4, 18].includes(watch("voucher_id")?.value) ||
                            [4, 18].includes(
                              watch("voucher_id")?.parent_id
                            )) && (
                            <Col sm={3}>
                              <FormGroup className="mb-4">
                                <Label>INV Date</Label>
                                <UFDate
                                  control={control}
                                  name={"inv_date"}
                                  invalid={!!errors.inv_date}
                                />
                                <FormFeedback invalid>
                                  {errors.inv_date?.message}
                                </FormFeedback>
                              </FormGroup>
                            </Col>
                          )}
                          {(watch("voucher_id")?.value == 16 ||
                            watch("voucher_id")?.parent_id == 16) && (
                            <>
                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>Request Date</Label>
                                  <UFDate
                                    control={control}
                                    name={"request_date"}
                                    invalid={!!errors.request_date}
                                  />
                                  <FormFeedback invalid>
                                    {errors.request_date?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>

                              <Col sm={3}>
                                <FormGroup className="mb-4">
                                  <Label>Exp Delivery Date</Label>
                                  <UFDate
                                    control={control}
                                    name={"exp_Delivery_date"}
                                    invalid={!!errors.exp_Delivery_date}
                                  />
                                  <FormFeedback invalid>
                                    {errors.exp_Delivery_date?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                              <Col lg={3}>
                                <FormGroup className="mb-4">
                                  <Label>
                                    Shipping Address
                                    <span className="mandatory">*</span>
                                  </Label>
                                  <UFEditor
                                    control={control}
                                    placeholder="Enter the Shipping Address"
                                    rows="5"
                                    name={"address"}
                                    invalid={!!errors.address}
                                    className={"pb-0"}
                                  />
                                  <FormFeedback invalid>
                                    {errors.address?.message}
                                  </FormFeedback>
                                </FormGroup>
                              </Col>
                            </>
                          )}
                        </Row>

                        <hr className="m-0" />

                        {/* <Row className="py-2">
                          <div className="d-flex">
                            <h5 className="pe-2 edittheamtitle">
                              {watch("voucher_id")?.value == 15 ||
                                watch("voucher_id")?.value == 16
                                ? "Material Details"
                                : watch("voucher_id")?.value == 13
                                  ? "Project"
                                  : watch("voucher_id")?.value == 1
                                    ? "Contra"
                                    : watch("voucher_id")?.value == 8
                                      ? "Journal"
                                      : watch("voucher_id")?.value == 3
                                        ? "Payment"
                                        : watch("voucher_id")?.value == 6
                                          ? "Receipt"
                                          : watch("voucher_id")?.value == 12
                                            ? "Stock Journal"
                                            : ""}
                            </h5>
                          </div>
                        </Row> */}
                        {([15, 4].includes(watch("voucher_id")?.value) ||
                          [15, 4].includes(watch("voucher_id")?.parent_id)) &&
                        rSelected == 1 ? (
                          <>
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th className="w-25">Product</th>
                                      {/* <th>Description</th> */}
                                      <th>Unit</th>
                                      <th>Ordered Quantity</th>
                                      <th>Created Quantity</th>
                                      <th>Purchase Quantity</th>
                                      <th>Unit Price (AED)</th>
                                      <th>Price (AED)</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {purchaseFields?.map((item, index) => (
                                      <tr key={`purchase${item.id || index}`}>
                                        <td className="ps-1">
                                          <ProductList
                                            control={control}
                                            placeholder="Select Product"
                                            selectedProduct={watch(
                                              `voucher_purchase`
                                            )}
                                            index={index}
                                            name={`voucher_purchase.${index}.product_id`}
                                            invalid={
                                              !!errors?.voucher_purchase?.[
                                                index
                                              ]?.product_id
                                            }
                                            onSelectChange={e =>
                                              handleWithoutRefProduct(e, index)
                                            }
                                          />
                                        </td>
                                        {/* <td className="ps-1">
                                          <div className="d-flex justify-content-between">
                                            <UFInput
                                              control={control}
                                              placeholder="Description"
                                              name={`voucher_purchase.${index}.description`}
                                            />
                                          </div>
                                        </td> */}
                                        <td className="ps-1">
                                          <Unit
                                            control={control}
                                            placeholder="Unit"
                                            name={`voucher_purchase.${index}.unit`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Quantity"
                                            name={`voucher_purchase.${index}.ordered_quantity`}
                                            invalid={
                                              !!errors?.voucher_purchase?.[
                                                index
                                              ]?.ordered_quantity
                                            }
                                            disabled={true}
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_purchase?.[index]
                                                ?.ordered_quantity?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Quantity"
                                            name={`voucher_purchase.${index}.already_created`}
                                            invalid={
                                              !!errors?.voucher_purchase?.[
                                                index
                                              ]?.already_created
                                            }
                                            disabled={true}
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_purchase?.[index]
                                                ?.already_created?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInputNumber
                                            control={control}
                                            placeholder="Quantity"
                                            name={`voucher_purchase.${index}.qnt`}
                                            invalid={
                                              !!errors?.voucher_purchase?.[
                                                index
                                              ]?.qnt
                                            }
                                            isDecimal={true}
                                            // maxNum={watch(Number(`voucher_purchase.${index}.ordered_quantity`)) - watch(Number(`voucher_purchase.${index}.already_created`))}
                                            onChange={e =>
                                              handleSubPricePurchase(e, index)
                                            }
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_purchase?.[index]
                                                ?.qnt?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInputNumber
                                            control={control}
                                            placeholder="Price"
                                            name={`voucher_purchase.${index}.unit_price`}
                                            isDecimal={true}
                                            onChange={e =>
                                              handleSubPricePurchase(e, index)
                                            }
                                          />
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Price"
                                            name={`voucher_purchase.${index}.sub_price`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td>
                                          <div className="pb-1 px-2 d-flex justify-content-center">
                                            <div
                                              className="trash-img pointer"
                                              onClick={() =>
                                                purchaseListRemove(index)
                                              }
                                            >
                                              <TrashIcon />
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <Col
                                  lg="12"
                                  xs={12}
                                  md={2}
                                  sm={12}
                                  className="d-flex justify-content-end"
                                >
                                  {!fromDashboard && (
                                    <Button
                                      color="primary"
                                      className="addButton mt-2"
                                      onClick={() =>
                                        purchaseListAppend({
                                          product_id: "",
                                          description: "",
                                          qnt: "",
                                          discount: "",
                                          unit_price: "",
                                          sub_price: "",
                                        })
                                      }
                                    >
                                      + Row
                                    </Button>
                                  )}
                                </Col>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={7}>
                                {(watch("voucher_id")?.value != 16 ||
                                  watch("voucher_id")?.parent_id != 16) && (
                                  <Row className="mb-0">
                                    {/* <Col
                                      lg={"auto"}
                                      onClick={() =>
                                        handleDiscountCheck(discountCheck)
                                      }
                                    >
                                      <FormGroup>
                                        <input
                                          type="checkbox"
                                          className="ever-rise-checkbox"
                                          name={"is_discount"}
                                          checked={discountCheck}
                                        />
                                        <Label className="ms-2">Discount</Label>
                                      </FormGroup>
                                    </Col> */}
                                    {/* {watch("voucher_id")?.value != 13 && (
                                      <Col
                                        lg={"auto"}
                                        onClick={() =>
                                          handleShippingCheck(shippingCheck)
                                        }
                                      >
                                        <FormGroup>
                                          <input
                                            type="checkbox"
                                            className="ever-rise-checkbox"
                                            name={"is_shipping"}
                                            checked={shippingCheck}
                                          />
                                          <Label className="ms-2">
                                            Shipping Charge
                                          </Label>
                                        </FormGroup>
                                      </Col>
                                    )}
                                    {watch("voucher_id")?.value != 13 && (
                                      <Col
                                        lg={"auto"}
                                        onClick={() =>
                                          handleOtherCheck(othersCheck)
                                        }
                                      >
                                        <FormGroup>
                                          <input
                                            type="checkbox"
                                            className="ever-rise-checkbox"
                                            name={"is_others"}
                                            checked={othersCheck}
                                          />
                                          <Label className="ms-2">
                                            Other Charges
                                          </Label>
                                        </FormGroup>
                                      </Col>
                                    )} */}
                                    <Col
                                      lg={"auto"}
                                      onClick={() => handleVatCheck(vatCheck)}
                                    >
                                      <FormGroup>
                                        <input
                                          type="checkbox"
                                          className="ever-rise-checkbox"
                                          name={"is_vat"}
                                          checked={vatCheck}
                                        />
                                        <Label className="ms-2">
                                          VAT Applicable
                                        </Label>
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}
                                <Row>
                                  {vatCheck && (
                                    <Col sm={4}>
                                      <FormGroup>
                                        <Label>
                                          VAT
                                          <span className="mandatory">*</span>
                                        </Label>
                                        <FinanceLedgersLi
                                          control={control}
                                          placeholder="Select"
                                          name={"vat_id"}
                                          invalid={!!errors.vat_id}
                                          groupId={17}
                                          target={"body"}
                                          // groupId={
                                          //   watch("voucher_id")?.value == 15 ||
                                          //   watch("voucher_id")?.value == 16
                                          //     ? 22
                                          //     : 13
                                          // }
                                          showCreateOption={true}
                                          refreshTrigger={refreshDropdown}
                                          onSuccess={
                                            handleLedgerCreationSuccess
                                          }
                                          onSelectChange={e => handleVatType(e)}
                                          disabled={editId ? true : false}
                                        />
                                        <FormFeedback invalid>
                                          {errors.vat_id?.message}
                                        </FormFeedback>
                                      </FormGroup>
                                    </Col>
                                  )}
                                </Row>
                                <Row>
                                  <Col sm={6}>
                                    <Row>
                                      <Col sm={12}>
                                        <FormGroup className="mb-4">
                                          <Label>Narration</Label>
                                          <UFEditor
                                            control={control}
                                            placeholder="Enter the Narrations"
                                            rows="5"
                                            name={"narration"}
                                            invalid={!!errors.narration}
                                            className={"pb-0"}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                              <Col sm={5}>
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Sub Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={calculation("sub_total")}
                                        name={"sub_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                {discountCheck && (
                                  <>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discount %
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder="Enter Discount"
                                            name={"discount"}
                                          />
                                        </FormGroup>
                                        <FormFeedback></FormFeedback>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discounted Sub Total
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder={calculation(
                                              "discounted_amount"
                                            )}
                                            name={"discounted_subTotal"}
                                            disabled={true}
                                            className={"form-disabled-place"}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                {/* {shippingCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Shipping Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Shipping charge"
                                          name={"shipping_charge"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}
                                {othersCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Other Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Other charge"
                                          name={"other_charge"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )} */}
                                {vatCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="text-end d-flex align-items-center justify-content-end">
                                        {/* VAT ( */}
                                        {/* {watch("vat_id")?.vat_per
                                          ? watch("vat_id")?.vat_per
                                          : loggedUser?.settings?.tax}
                                        )% */}
                                        VAT{" "}
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Percent"
                                          isDecimal={false}
                                          maxNum={100}
                                          name={`vat_amount`}
                                          invalid={!!errors?.vat_amount}
                                          voucherTypes={true}
                                          className="vat-input"
                                        />
                                        %
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder={calculation("tax_total")}
                                          name={"tax"}
                                          disabled={true}
                                          className={"form-disabled-place"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Net Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={calculation(
                                          "total_amount"
                                        )}
                                        name={"net_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : watch("voucher_id")?.value == 16 ||
                          watch("voucher_id")?.parent_id == 16 ? (
                          <>
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th className="w-25">Product</th>
                                      {/* <th>Description</th> */}
                                      <th>Unit</th>
                                      <th>Quantity</th>
                                      <th>Unit Price (AED)</th>
                                      <th>Price (AED)</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {materialFields?.map((item, index) => (
                                      <tr key={`purchase${item.id || index}`}>
                                        <td className="ps-1">
                                          <ProductList
                                            control={control}
                                            placeholder="Select Product"
                                            // projectid={projectID}
                                            selectedProduct={watch(
                                              `voucher_materials`
                                            )}
                                            index={index}
                                            name={`voucher_materials.${index}.product_id`}
                                            invalid={
                                              !!errors?.voucher_materials?.[
                                                index
                                              ]?.product_id
                                            }
                                            onSelectChange={e =>
                                              handleCompanyProduct(e, index)
                                            }
                                          />
                                        </td>
                                        {/* <td className="ps-1">
                                          <div className="d-flex justify-content-between">
                                            <UFInput
                                              control={control}
                                              placeholder="Description"
                                              name={`voucher_materials.${index}.description`}
                                            />
                                            <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    className="svg-font pe-1 pointer"
                                    id={`PopoverLegacy-${index}`}
                                  >
                                    <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                                  </svg>
                                  <UncontrolledPopover
                                    placement="bottom"
                                    target={`PopoverLegacy-${index}`}
                                    trigger="hover"
                                    container={
                                      fromDashboard ? ".modal" : "body"
                                    }
                                  >
                                    <PopoverBody>
                                      <div className="table-popup-content">
                                        <div className="pb-2">
                                          Recent Suppliers
                                        </div>
                                        {watch(
                                          `purchase.${index}.short_supplier`
                                        )?.map(dt => (
                                          <div className="py-1">
                                            <span>{dt?.suppliers_code}</span>{" "}
                                            <span className="ps-2">
                                              {dt?.name}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    </PopoverBody>
                                  </UncontrolledPopover>
                                          </div>
                                        </td> */}
                                        <td className="ps-1">
                                          <Unit
                                            control={control}
                                            placeholder="Unit"
                                            name={`voucher_materials.${index}.unit`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Quantity"
                                            name={`voucher_materials.${index}.qnt`}
                                            invalid={
                                              !!errors?.voucher_materials?.[
                                                index
                                              ]?.qnt
                                            }
                                            onChange={e =>
                                              handleSubPrice(e, index)
                                            }
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_materials?.[index]
                                                ?.qnt?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Price"
                                            name={`voucher_materials.${index}.unit_price`}
                                            onChange={e =>
                                              handleSubPrice(e, index)
                                            }
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_materials?.[index]
                                                ?.unit_price?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Price"
                                            name={`voucher_materials.${index}.sub_price`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td>
                                          <div className="pb-1 px-2 d-flex justify-content-center">
                                            <img
                                              src={lightTrash}
                                              alt="light-trash"
                                              className="trash-img pointer"
                                              onClick={() =>
                                                materialListRemove(index)
                                              }
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                                {watch("material_request_id")?.value == null ? (
                                  <Col
                                    lg="12"
                                    xs={12}
                                    md={2}
                                    sm={12}
                                    className="d-flex justify-content-end"
                                  >
                                    {!fromDashboard && (
                                      <Button
                                        color="primary"
                                        className="addButton mt-2"
                                        onClick={() =>
                                          materialListAppend({
                                            product_id: "",
                                            description: "",
                                            qnt: "",
                                            discount: "",
                                            unit_price: "",
                                            sub_price: "",
                                          })
                                        }
                                      >
                                        + Row
                                      </Button>
                                    )}
                                  </Col>
                                ) : (
                                  <></>
                                )}
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={7}>
                                {/* {watch("voucher_id")?.value != 16 && ( */}
                                <Row className="mb-0">
                                  {/* <Col
                                    lg={"auto"}
                                    onClick={() =>
                                      handleDiscountCheck(discountCheck)
                                    }
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_discount"}
                                        checked={discountCheck}
                                      />
                                      <Label className="ms-2">Discount</Label>
                                    </FormGroup>
                                  </Col> */}
                                  {/* <Col
                                    lg={"auto"}
                                    onClick={() =>
                                      handleShippingCheck(shippingCheck)
                                    }
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_shipping"}
                                        checked={shippingCheck}
                                      />
                                      <Label className="ms-2">
                                        Shipping Charge
                                      </Label>
                                    </FormGroup>
                                  </Col>
                                  <Col
                                    lg={"auto"}
                                    onClick={() =>
                                      handleOtherCheck(othersCheck)
                                    }
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_others"}
                                        checked={othersCheck}
                                      />
                                      <Label className="ms-2">
                                        Other Charges
                                      </Label>
                                    </FormGroup>
                                  </Col> */}
                                  {/* <Col
                                    lg={"auto"}
                                    onClick={() => handleVatCheck(vatCheck)}
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_vat"}
                                        checked={vatCheck}
                                      />
                                      <Label className="ms-2">
                                        VAT Applicable
                                      </Label>
                                    </FormGroup>
                                  </Col> */}
                                </Row>
                                <Row>
                                  {vatCheck && (
                                    <Col sm={4}>
                                      <FormGroup>
                                        <Label>
                                          VAT
                                          <span className="mandatory">*</span>
                                        </Label>
                                        <FinanceLedgersLi
                                          control={control}
                                          placeholder="Select"
                                          name={"vat_id"}
                                          invalid={!!errors.vat_id}
                                          groupId={17}
                                          target={"body"}
                                          // groupId={
                                          //   watch("voucher_id")?.value == 15 ||
                                          //   watch("voucher_id")?.value == 16
                                          //     ? 22
                                          //     : 13
                                          // }
                                          showCreateOption={true}
                                          refreshTrigger={refreshDropdown}
                                          onSuccess={
                                            handleLedgerCreationSuccess
                                          }
                                          onSelectChange={e => handleVatType(e)}
                                          disabled={editId ? true : false}
                                        />
                                        <FormFeedback invalid>
                                          {errors.vat_id?.message}
                                        </FormFeedback>
                                      </FormGroup>
                                    </Col>
                                  )}
                                </Row>
                                {/* )} */}
                                <Row>
                                  <Col sm={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Narration</Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Narrations"
                                        rows="5"
                                        name={"narration"}
                                        invalid={!!errors.narration}
                                        className={"pb-0"}
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>General Terms</Label>
                                      <RichTextEditor
                                        control={control}
                                        name={"general_terms"}
                                        invalid={!!errors.general_terms}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                      />
                                      <FormFeedback invalid>
                                        {errors.general_terms?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                  <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>Delivery Terms</Label>
                                      <RichTextEditor
                                        control={control}
                                        name={"delivery_terms"}
                                        invalid={!!errors.delivery_terms}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                      />
                                      <FormFeedback invalid>
                                        {errors.delivery_terms?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                              <Col sm={5}>
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Sub Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={calculation("sub_total")}
                                        name={"sub_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                {discountCheck && (
                                  <>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discount %
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder="Enter Discount"
                                            name={"discount"}
                                            invalid={!!errors.discount}
                                          />
                                        </FormGroup>
                                        <FormFeedback invalid>
                                          {errors.discount?.message}
                                        </FormFeedback>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discounted Sub Total
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder={calculation(
                                              "discounted_amount"
                                            )}
                                            name={"discounted_subTotal"}
                                            disabled={true}
                                            className={"form-disabled-place"}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                {/* {shippingCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Shipping Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Shipping charge"
                                          name={"shipping_charge"}
                                          invalid={!!errors.shipping_charge}
                                        />
                                      </FormGroup>
                                      <FormFeedback invalid>
                                        {errors.shipping_charge?.message}
                                      </FormFeedback>
                                    </Col>
                                  </Row>
                                )}
                                {othersCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Other Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Other charge"
                                          name={"other_charge"}
                                          invalid={!!errors.other_charge}
                                        />
                                      </FormGroup>
                                      <FormFeedback invalid>
                                        {errors.other_charge?.message}
                                      </FormFeedback>
                                    </Col>
                                  </Row>
                                )} */}
                                {vatCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="text-end d-flex align-items-center justify-content-end">
                                        {/* VAT (
                                        {watch("vat_id")?.vat_per
                                          ? watch("vat_id")?.vat_per
                                          : loggedUser?.settings?.tax}
                                        )% */}
                                        VAT{" "}
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Percent"
                                          isDecimal={false}
                                          maxNum={100}
                                          name={`vat_amount`}
                                          invalid={!!errors?.vat_amount}
                                          voucherTypes={true}
                                          className="vat-input"
                                        />
                                        %
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder={calculation("tax_total")}
                                          name={"tax"}
                                          disabled={true}
                                          className={"form-disabled-place"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Net Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={calculation(
                                          "total_amount"
                                        )}
                                        name={"net_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : ([13, 18].includes(watch("voucher_id")?.value) ||
                            [13, 18].includes(
                              watch("voucher_id")?.parent_id
                            )) &&
                          rSelected == 1 ? (
                          <>
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th>Project</th>
                                      <th className="wdt-33">Reference</th>
                                      <th>Unit</th>
                                      <th>Qty</th>
                                      <th>Price (AED)</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td className="ps-1">
                                        <ProjectNo
                                          control={control}
                                          name={"project_ids"}
                                          placeholder={"Project No"}
                                          target={"body"}
                                          ledgerId={watch("credit_id")?.value}
                                          disabled={
                                            watch("credit_id")?.value && id
                                              ? true
                                              : watch("credit_id")?.value && !id
                                              ? false
                                              : true
                                          }
                                          onSelectChange={e =>
                                            handleProjectNumReset(e)
                                          }
                                        />
                                      </td>
                                      <td className="ps-1">
                                        <ManufactureLi
                                          control={control}
                                          name={"manufacturing_journal_id"}
                                          placeholder={"Reference"}
                                          target={"body"}
                                          ledgerId={watch("credit_id")?.value}
                                          disabled={
                                            watch("credit_id")?.value && id
                                              ? true
                                              : watch("credit_id")?.value &&
                                                !id &&
                                                watch("project_ids")?.value
                                              ? false
                                              : true
                                          }
                                          projectId={
                                            watch("project_ids")?.value
                                              ? watch("project_ids")?.value
                                              : ""
                                          }
                                          statusChk={1}
                                          grandTotal={true}
                                          onSelectChange={e =>
                                            handleProjectNum(e)
                                          }
                                        />
                                      </td>
                                      <td className="ps-1">
                                        <UFInput
                                          control={control}
                                          placeholder="Unit"
                                          name={`sale_unit`}
                                          // disabled={true}
                                          className="input-disabled-bg"
                                        />
                                      </td>
                                      <td className="ps-1">
                                        <UFInput
                                          control={control}
                                          placeholder="Unit"
                                          name={`sale_qty`}
                                          disabled={true}
                                          className="input-disabled-bg"
                                        />
                                      </td>
                                      <td className="ps-1">
                                        {console.log(
                                          `watch()`,
                                          watch(`chk_sale_total`)
                                        )}
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Price"
                                          name={`sale_total`}
                                          isDecimal={true}
                                          decimalLength={desimalrange || 2}
                                          maxNum={
                                            editId
                                              ? Number(
                                                  watch(`chk_sale_total`)
                                                ).toFixed(desimalrange)
                                              : (
                                                  Number(
                                                    watch(
                                                      `manufacturing_journal_id`
                                                    )?.grand_with_total || 0
                                                  ) -
                                                  Number(
                                                    watch(
                                                      `manufacturing_journal_id`
                                                    )?.partialsale_sum_amount ||
                                                      0
                                                  )
                                                ).toFixed(desimalrange)
                                          }
                                          className="input-disabled-bg"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={7}>
                                <Row className="mb-0">
                                  {/* <Col
                                    lg={"auto"}
                                    onClick={() =>
                                      handleDiscountCheck(discountCheck)
                                    }
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_discount"}
                                        checked={discountCheck}
                                      />
                                      <Label className="ms-2">Discount</Label>
                                    </FormGroup>
                                  </Col>
                                  {watch("voucher_id")?.value != 13 && (
                                    <Col
                                      lg={"auto"}
                                      onClick={() =>
                                        handleShippingCheck(shippingCheck)
                                      }
                                    >
                                      <FormGroup>
                                        <input
                                          type="checkbox"
                                          className="ever-rise-checkbox"
                                          name={"is_shipping"}
                                          checked={shippingCheck}
                                        />
                                        <Label className="ms-2">
                                          Shipping Charge
                                        </Label>
                                      </FormGroup>
                                    </Col>
                                  )}
                                 
                                    <Col
                                      lg={"auto"}
                                      onClick={() =>
                                        handleOtherCheck(othersCheck)
                                      }
                                    >
                                      <FormGroup>
                                        <input
                                          type="checkbox"
                                          className="ever-rise-checkbox"
                                          name={"is_others"}
                                          checked={othersCheck}
                                        />
                                        <Label className="ms-2">
                                          Other Charges
                                        </Label>
                                      </FormGroup>
                                    </Col> */}

                                  {(watch("voucher_id")?.value === 13 ||
                                    watch("voucher_id")?.parent_id == 13) && (
                                    <Col
                                      lg={"auto"}
                                      onClick={() =>
                                        handleRetentionCheck(retentionCheck)
                                      }
                                    >
                                      <FormGroup>
                                        <input
                                          type="checkbox"
                                          className="ever-rise-checkbox"
                                          name={"is_retention"}
                                          checked={retentionCheck}
                                        />
                                        <Label className="ms-2">
                                          Retention
                                        </Label>
                                      </FormGroup>
                                    </Col>
                                  )}
                                  {(watch("voucher_id")?.value === 13 ||
                                    watch("voucher_id")?.parent_id == 13) && (
                                    <Col
                                      lg={"auto"}
                                      onClick={() =>
                                        handleAdvRetentionCheck(
                                          advRetentionCheck
                                        )
                                      }
                                    >
                                      <FormGroup>
                                        <input
                                          type="checkbox"
                                          className="ever-rise-checkbox"
                                          name={"is_adv_retention"}
                                          checked={advRetentionCheck}
                                        />
                                        <Label className="ms-2">
                                          Advance Retention
                                        </Label>
                                      </FormGroup>
                                    </Col>
                                  )}
                                  <Col
                                    lg={"auto"}
                                    onClick={() => handleVatCheck(vatCheck)}
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_vat"}
                                        checked={vatCheck}
                                      />
                                      <Label className="ms-2">
                                        VAT Applicable
                                      </Label>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  {retentionCheck && (
                                    <Col sm={4}>
                                      <FormGroup>
                                        <Label>
                                          Retention
                                          <span className="mandatory">*</span>
                                        </Label>
                                        <FinanceLedgersLi
                                          control={control}
                                          placeholder="Select"
                                          name={"retention_id"}
                                          invalid={!!errors.retention_id}
                                          groupId={2}
                                          target={"body"}
                                          // groupId={
                                          //   watch("voucher_id")?.value == 15 ||
                                          //   watch("voucher_id")?.value == 16
                                          //     ? 22
                                          //     : 13
                                          // }
                                          showCreateOption={true}
                                          refreshTrigger={refreshDropdown}
                                          onSuccess={
                                            handleLedgerCreationSuccess
                                          }
                                          onSelectChange={e =>
                                            handleRetentionType(e)
                                          }
                                          // disabled={
                                          //   editId
                                          //     ? true
                                          //     : location?.state?.id
                                          //     ? true
                                          //     : false
                                          // }
                                        />
                                        <FormFeedback invalid>
                                          {errors.retention_id?.message}
                                        </FormFeedback>
                                      </FormGroup>
                                    </Col>
                                  )}
                                  {advRetentionCheck && (
                                    <Col sm={4}>
                                      <FormGroup>
                                        <Label>
                                          Advance Retention
                                          <span className="mandatory">*</span>
                                        </Label>
                                        <FinanceLedgersLi
                                          control={control}
                                          placeholder="Select"
                                          name={"adv_retention_id"}
                                          invalid={!!errors.adv_retention_id}
                                          groupId={4}
                                          target={"body"}
                                          onSelectChange={e =>
                                            handleAdvRetentionType(e)
                                          }
                                          // groupId={
                                          //   watch("voucher_id")?.value == 15 ||
                                          //   watch("voucher_id")?.value == 16
                                          //     ? 22
                                          //     : 13
                                          // }
                                          showCreateOption={true}
                                          refreshTrigger={refreshDropdown}
                                          onSuccess={
                                            handleLedgerCreationSuccess
                                          }
                                          // disabled={
                                          //   editId
                                          //     ? true
                                          //     : location?.state?.id
                                          //     ? true
                                          //     : false
                                          // }
                                        />
                                        <FormFeedback invalid>
                                          {errors.adv_retention_id?.message}
                                        </FormFeedback>
                                      </FormGroup>
                                    </Col>
                                  )}
                                  {vatCheck && (
                                    <Col sm={4}>
                                      <FormGroup>
                                        <Label>
                                          VAT
                                          <span className="mandatory">*</span>
                                        </Label>
                                        <FinanceLedgersLi
                                          control={control}
                                          placeholder="Select"
                                          name={"vat_id"}
                                          invalid={!!errors.vat_id}
                                          groupId={17}
                                          target={"body"}
                                          // groupId={
                                          //   watch("voucher_id")?.value == 15 ||
                                          //   watch("voucher_id")?.value == 16
                                          //     ? 22
                                          //     : 13
                                          // }
                                          showCreateOption={true}
                                          refreshTrigger={refreshDropdown}
                                          onSuccess={
                                            handleLedgerCreationSuccess
                                          }
                                          onSelectChange={e => handleVatType(e)}
                                          // disabled={editId ? true : false}
                                        />
                                        <FormFeedback invalid>
                                          {errors.vat_id?.message}
                                        </FormFeedback>
                                      </FormGroup>
                                    </Col>
                                  )}
                                </Row>
                                <Row>
                                  <Col sm={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Narration</Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Narrations"
                                        rows="5"
                                        name={"narration"}
                                        invalid={!!errors.narration}
                                        className={"pb-0"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                              <Col sm={5}>
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-0 text-end">
                                      <div className="pt-2 text-end">
                                        Sub Total
                                      </div>
                                      {/* <div className="text-end inc-txt">
                                  Include Margin
                                </div> */}
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={
                                          [13, 18].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                          [13, 18].includes(
                                            watch("voucher_id")?.parent_id
                                          )
                                            ? calculationSale("sub_total")
                                            : calculation("sub_total")
                                        }
                                        name={"sub_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                {/* <Row className="mb-3">
                            <Col sm={6}>
                              <div className="pt-2 text-end">Sub Total</div>
                            </Col>
                            <Col sm={6}>
                              <FormGroup>
                                <UFInput
                                  control={control}
                                  placeholder={
                                    watch("voucher_id")?.value == 13
                                      ? calculationSale("sub_total")
                                      : calculation("sub_total")
                                  }
                                  name={"sub_total"}
                                  disabled={true}
                                />
                              </FormGroup>
                            </Col>
                          </Row> */}
                                {/* {discountCheck && (
                                  <>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discount %
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInputNumber
                                            isDecimal={true}
                                            maxNum={100}
                                            control={control}
                                            placeholder="Enter Discount"
                                            name={"discount"}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discounted Sub Total
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder={
                                              watch("voucher_id")?.value == 13
                                                ? calculationSale(
                                                    "discounted_amount"
                                                  )
                                                : calculation(
                                                    "discounted_amount"
                                                  )
                                            }
                                            name={"discounted_subTotal"}
                                            disabled={true}
                                            className={"form-disabled-place"}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                {shippingCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Shipping Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Shipping charge"
                                          name={"shipping_charge"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}
                                {othersCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Other Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Other charge"
                                          name={"other_charge"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )} */}
                                {retentionCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="text-end d-flex align-items-center justify-content-end">
                                        Retention{"  "}
                                        {/* ( */}
                                        {/* {watch("project_ids")?.retention || 0})% */}
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Percent"
                                          isDecimal={true}
                                          decimalLength={2}
                                          maxNum={100}
                                          name={`retention_amount`}
                                          invalid={!!errors?.retention_amount}
                                          voucherTypes={true}
                                          onChange={e => handleRetentionPer(e)}
                                          className="vat-input"
                                        />
                                        %
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Retention Amount"
                                          // {
                                          //   watch("voucher_id")?.value == 13
                                          //     ? calculationSale("tax_total")
                                          //     : calculation("tax_total")
                                          // }
                                          name={"retention"}
                                          disabled={true}
                                          className={"form-disabled-place"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}

                                {advRetentionCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="text-end d-flex align-items-center justify-content-end">
                                        Advance Retention{" "}
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Percent"
                                          isDecimal={true}
                                          decimalLength={2}
                                          maxNum={100}
                                          name={`adv_retention_amount`}
                                          invalid={
                                            !!errors?.adv_retention_amount
                                          }
                                          voucherTypes={true}
                                          onChange={e =>
                                            handleAdvRetentionPer(e)
                                          }
                                          className="vat-input"
                                        />
                                        %
                                        {/* (
                                        {Number(
                                          watch("project_ids")?.advance_ad || 0
                                        )}
                                        )% */}
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Retention Amount"
                                          // {
                                          //   watch("voucher_id")?.value == 13
                                          //     ? calculationSale("tax_total")
                                          //     : calculation("tax_total")
                                          // }
                                          name={"adv_retention"}
                                          disabled={true}
                                          className={"form-disabled-place"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}

                                {vatCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="text-end d-flex align-items-center justify-content-end">
                                        {/* VAT (
                                        {watch("vat_id")?.vat_per
                                          ? watch("vat_id")?.vat_per
                                          : loggedUser?.settings?.tax}
                                        )% */}
                                        VAT{"  "}
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Percent"
                                          isDecimal={false}
                                          maxNum={100}
                                          name={`vat_amount`}
                                          invalid={!!errors?.vat_amount}
                                          voucherTypes={true}
                                          className="vat-input"
                                        />{" "}
                                        %
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder={
                                            [13, 18].includes(
                                              watch("voucher_id")?.value
                                            ) ||
                                            [13, 18].includes(
                                              watch("voucher_id")?.parent_id
                                            )
                                              ? calculationSale("tax_total")
                                              : calculation("tax_total")
                                          }
                                          name={"tax"}
                                          disabled={true}
                                          className={"form-disabled-place"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}

                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Net Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={
                                          [13, 18].includes(
                                            watch("voucher_id")?.value
                                          ) ||
                                          [13, 18].includes(
                                            watch("voucher_id")?.parent_id
                                          )
                                            ? calculationSale("total_amount")
                                            : calculation("total_amount")
                                        }
                                        name={"net_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : ([13, 18].includes(watch("voucher_id")?.value) ||
                            [13, 18].includes(
                              watch("voucher_id")?.parent_id
                            )) &&
                          rSelected == 4 ? (
                          <>
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th className="w-25">Product</th>
                                      {/* <th>Description</th> */}
                                      <th>Unit</th>
                                      <th>Quantity</th>
                                      <th>Unit Price (AED)</th>
                                      <th>Price (AED)</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {materialFields?.map((item, index) => (
                                      <tr key={`purchase${item.id || index}`}>
                                        <td className="ps-1">
                                          <ProductList
                                            control={control}
                                            placeholder="Select Product"
                                            // projectid={projectID}
                                            selectedProduct={watch(
                                              `voucher_materials`
                                            )}
                                            index={index}
                                            name={`voucher_materials.${index}.product_id`}
                                            invalid={
                                              !!errors?.voucher_materials?.[
                                                index
                                              ]?.product_id
                                            }
                                            onSelectChange={e =>
                                              handleCompanyProduct(e, index)
                                            }
                                          />
                                        </td>

                                        <td className="ps-1">
                                          <Unit
                                            control={control}
                                            placeholder="Unit"
                                            name={`voucher_materials.${index}.unit`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td className="ps-1">
                                          <UFInputNumber
                                            control={control}
                                            placeholder="Quantity"
                                            name={`voucher_materials.${index}.qnt`}
                                            invalid={
                                              !!errors?.voucher_materials?.[
                                                index
                                              ]?.qnt
                                            }
                                            onChange={e =>
                                              handleSubPrice(e, index)
                                            }
                                            isDecimal={true}
                                            decimalLength={desimalrange || 2}
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_materials?.[index]
                                                ?.qnt?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInputNumber
                                            control={control}
                                            placeholder="Price"
                                            name={`voucher_materials.${index}.unit_price`}
                                            onChange={e =>
                                              handleSubPrice(e, index)
                                            }
                                            isDecimal={true}
                                            decimalLength={desimalrange || 2}
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_materials?.[index]
                                                ?.unit_price?.message
                                            }
                                          </FormFeedback>
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Price"
                                            name={`voucher_materials.${index}.sub_price`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td>
                                          <div className="pb-1 px-2 d-flex justify-content-center">
                                            <img
                                              src={lightTrash}
                                              alt="light-trash"
                                              className="trash-img pointer"
                                              onClick={() =>
                                                materialListRemove(index)
                                              }
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <Col
                                  lg="12"
                                  xs={12}
                                  md={2}
                                  sm={12}
                                  className="d-flex justify-content-end"
                                >
                                  {!fromDashboard && (
                                    <Button
                                      color="primary"
                                      className="addButton mt-2"
                                      onClick={() =>
                                        materialListAppend({
                                          product_id: "",
                                          description: "",
                                          qnt: "",
                                          discount: "",
                                          unit_price: "",
                                          sub_price: "",
                                        })
                                      }
                                    >
                                      + Row
                                    </Button>
                                  )}
                                </Col>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={7}>
                                {/* {watch("voucher_id")?.value != 16 && ( */}
                                <Row className="mb-0">
                                  <Col
                                    lg={"auto"}
                                    onClick={() => handleVatCheck(vatCheck)}
                                  >
                                    <FormGroup>
                                      <input
                                        type="checkbox"
                                        className="ever-rise-checkbox"
                                        name={"is_vat"}
                                        checked={vatCheck}
                                      />
                                      <Label className="ms-2">
                                        VAT Applicable
                                      </Label>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  {vatCheck && (
                                    <Col sm={4}>
                                      <FormGroup>
                                        <Label>
                                          VAT
                                          <span className="mandatory">*</span>
                                        </Label>
                                        <FinanceLedgersLi
                                          control={control}
                                          placeholder="Select"
                                          name={"vat_id"}
                                          invalid={!!errors.vat_id}
                                          groupId={17}
                                          target={"body"}
                                          showCreateOption={true}
                                          refreshTrigger={refreshDropdown}
                                          onSuccess={
                                            handleLedgerCreationSuccess
                                          }
                                          onSelectChange={e => handleVatType(e)}
                                          // disabled={editId ? true : false}
                                        />
                                        <FormFeedback invalid>
                                          {errors.vat_id?.message}
                                        </FormFeedback>
                                      </FormGroup>
                                    </Col>
                                  )}
                                </Row>
                                <Row>
                                  <Col sm={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Narration</Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Narrations"
                                        rows="5"
                                        name={"narration"}
                                        invalid={!!errors.narration}
                                        className={"pb-0"}
                                      />
                                    </FormGroup>
                                  </Col>
                                  {/* <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>General Terms</Label>
                                      <RichTextEditor
                                        control={control}
                                        name={"general_terms"}
                                        invalid={!!errors.general_terms}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                      />
                                      <FormFeedback invalid>
                                        {errors.general_terms?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col> */}
                                  {/* <Col sm={12}>
                                    <FormGroup className="mb-4">
                                      <Label>Delivery Terms</Label>
                                      <RichTextEditor
                                        control={control}
                                        name={"delivery_terms"}
                                        invalid={!!errors.delivery_terms}
                                        toolbarClassName="toolbarClassName"
                                        wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName"
                                      />
                                      <FormFeedback invalid>
                                        {errors.delivery_terms?.message}
                                      </FormFeedback>
                                    </FormGroup>
                                  </Col> */}
                                </Row>
                              </Col>
                              <Col sm={5}>
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Sub Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={calculation("sub_total")}
                                        name={"sub_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                {discountCheck && (
                                  <>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discount %
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder="Enter Discount"
                                            name={"discount"}
                                            invalid={!!errors.discount}
                                          />
                                        </FormGroup>
                                        <FormFeedback invalid>
                                          {errors.discount?.message}
                                        </FormFeedback>
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col sm={6}>
                                        <div className="pt-2 text-end">
                                          Discounted Sub Total
                                        </div>
                                      </Col>
                                      <Col sm={6}>
                                        <FormGroup>
                                          <UFInput
                                            control={control}
                                            placeholder={calculation(
                                              "discounted_amount"
                                            )}
                                            name={"discounted_subTotal"}
                                            disabled={true}
                                            className={"form-disabled-place"}
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </>
                                )}
                                {/* {shippingCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Shipping Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Shipping charge"
                                          name={"shipping_charge"}
                                          invalid={!!errors.shipping_charge}
                                        />
                                      </FormGroup>
                                      <FormFeedback invalid>
                                        {errors.shipping_charge?.message}
                                      </FormFeedback>
                                    </Col>
                                  </Row>
                                )}
                                {othersCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="pt-2 text-end">
                                        Other Charge
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder="Enter Other charge"
                                          name={"other_charge"}
                                          invalid={!!errors.other_charge}
                                        />
                                      </FormGroup>
                                      <FormFeedback invalid>
                                        {errors.other_charge?.message}
                                      </FormFeedback>
                                    </Col>
                                  </Row>
                                )} */}
                                {vatCheck && (
                                  <Row className="mb-3">
                                    <Col sm={6}>
                                      <div className="text-end d-flex align-items-center justify-content-end">
                                        {/* VAT (
                                      {watch("vat_id")?.vat_per
                                        ? watch("vat_id")?.vat_per
                                        : loggedUser?.settings?.tax}
                                      )% */}
                                        VAT{" "}
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Percent"
                                          isDecimal={false}
                                          maxNum={100}
                                          name={`vat_amount`}
                                          invalid={!!errors?.vat_amount}
                                          voucherTypes={true}
                                          className="vat-input"
                                        />
                                        %
                                      </div>
                                    </Col>
                                    <Col sm={6}>
                                      <FormGroup>
                                        <UFInput
                                          control={control}
                                          placeholder={calculation("tax_total")}
                                          name={"tax"}
                                          disabled={true}
                                          className={"form-disabled-place"}
                                        />
                                      </FormGroup>
                                    </Col>
                                  </Row>
                                )}
                                <Row className="mb-3">
                                  <Col sm={6}>
                                    <div className="pt-2 text-end">
                                      Net Total
                                    </div>
                                  </Col>
                                  <Col sm={6}>
                                    <FormGroup>
                                      <UFInput
                                        control={control}
                                        placeholder={calculation(
                                          "total_amount"
                                        )}
                                        name={"net_total"}
                                        disabled={true}
                                        className={"form-disabled-place"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : watch("voucher_id")?.value == 1 ||
                          watch("voucher_id")?.value == 3 ||
                          watch("voucher_id")?.value == 8 ||
                          watch("voucher_id")?.value == 9 ||
                          watch("voucher_id")?.value == 6 ||
                          watch("voucher_id")?.value == 21 ||
                          [1, 3, 8, 9, 6, 21].includes(
                            watch("voucher_id")?.parent_id
                          ) ||
                          (([13, 18].includes(watch("voucher_id")?.value) ||
                            [13, 18].includes(
                              watch("voucher_id")?.parent_id
                            )) &&
                            rSelected == 2) ||
                          (([15, 4].includes(watch("voucher_id")?.value) ||
                            [15, 4].includes(watch("voucher_id")?.parent_id)) &&
                            rSelected == 2) ? (
                          <>
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th className="wdt-10">Type</th>
                                      <th className="w-25">Account Head</th>
                                      <th>Debit (AED)</th>
                                      <th>Credit (AED)</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {contraFields?.map((item, index) => (
                                      <>
                                        <tr key={`purchase${item.id || index}`}>
                                          <td className="ps-1">
                                            <DebitCreditDrops
                                              control={control}
                                              placeholder="Select"
                                              name={`voucher_contra.${index}.nature`}
                                              onSelectChange={e =>
                                                handleNature(e?.value, index)
                                              }
                                              ref={el =>
                                                (natureRefs.current[index] = el)
                                              }
                                            />
                                            <FormFeedback invalid>
                                              {
                                                errors?.voucher_contra?.[index]
                                                  ?.nature?.message
                                              }
                                            </FormFeedback>
                                          </td>
                                          <td className="ps-1">
                                            <FinanceLedgersLi
                                              control={control}
                                              placeholder="Select"
                                              name={`voucher_contra.${index}.account_id`}
                                              invalid={
                                                !!errors.voucher_contra?.[index]
                                                  ?.account_id
                                              }
                                              showCreateOption={true}
                                              refreshTrigger={refreshDropdown}
                                              onSuccess={
                                                handleLedgerCreationSuccess
                                              }
                                              onSelectChange={e =>
                                                handleType(e, index)
                                              }
                                              groupId={
                                                watch("voucher_id")?.value ==
                                                  1 ||
                                                watch("voucher_id")
                                                  ?.parent_id == 1
                                                  ? [5, 6]
                                                  : // : watch("voucher_id")
                                                    //     ?.value == 8 ||
                                                    //   watch("voucher_id")
                                                    //     ?.parent_id == 8
                                                    // ? [
                                                    //     1, 3, 4, 7, 8, 9, 10, 11,
                                                    //     12, 13, 14, 15, 16, 17,
                                                    //     18, 19, 20, 21, 22, 23,
                                                    //     24, 25, 26, 27, 28, 29,
                                                    //   ]
                                                    ""
                                              }
                                              notAccId={
                                                [4, 15].includes(
                                                  Number(
                                                    watch("voucher_id")?.value
                                                  )
                                                ) ||
                                                [4, 15].includes(
                                                  Number(
                                                    watch("voucher_id")
                                                      ?.parent_id
                                                  )
                                                )
                                                  ? [13, 12]
                                                  : [13, 18].includes(
                                                      Number(
                                                        watch("voucher_id")
                                                          ?.value
                                                      )
                                                    ) ||
                                                    [13, 18].includes(
                                                      Number(
                                                        watch("voucher_id")
                                                          ?.parent_id
                                                      )
                                                    )
                                                  ? [22, 12]
                                                  : watch("voucher_id")
                                                      ?.value == 3 ||
                                                    watch("voucher_id")
                                                      ?.parent_id == 3
                                                  ? [5, 15]
                                                  : watch("voucher_id")
                                                      ?.value == 21 ||
                                                    watch("voucher_id")
                                                      ?.parent_id == 21
                                                  ? [6]
                                                  : ""
                                              }
                                              target={"body"}
                                              // ledgerTypes={"asset&expence"}
                                            />
                                            <FormFeedback invalid>
                                              {
                                                errors?.voucher_contra?.[index]
                                                  ?.account_id?.message
                                              }
                                            </FormFeedback>
                                          </td>
                                          <td className="">
                                            <UFInputNumber
                                              control={control}
                                              placeholder="Amount"
                                              name={`voucher_contra.${index}.debit`}
                                              disabled={
                                                watch(
                                                  `voucher_contra.${index}.nature`
                                                )?.value == "credit"
                                                  ? true
                                                  : false
                                              }
                                              className="ps-1"
                                              isDecimal={true}
                                              decimalLength={desimalrange || 2}
                                              // onChange={e =>
                                              //   handleDebitValue(e, index)
                                              // }
                                              // onKeyDown={e => {
                                              //   const accountGroupId = watch(
                                              //     `voucher_contra.${index}.account_id`
                                              //   )?.is_bill_wise
                                              //   if (
                                              //     accountGroupId == 1
                                              //     // accountGroupId === 13 ||
                                              //     // accountGroupId === 22
                                              //   ) {
                                              //     handleEditPartial(index) // fire only on typing
                                              //   } else {
                                              //     handleDebitValue(e, index) // fire only on typing
                                              //   }
                                              // }}
                                              onKeyDown={e => {
                                                const accountGroupId = watch(
                                                  `voucher_contra.${index}.account_id`
                                                )?.is_bill_wise

                                                const isTypingKey =
                                                  e.key.length === 1 ||
                                                  e.key === "Backspace" ||
                                                  e.key === "Delete"

                                                // Allow Tab to proceed, don't block it
                                                if (!isTypingKey) return

                                                if (accountGroupId == 1) {
                                                  handleEditPartial(index)
                                                } else {
                                                  handleDebitValue(e, index)
                                                }
                                              }}
                                            />
                                          </td>
                                          <td className="">
                                            <UFInputNumber
                                              control={control}
                                              placeholder="Amount"
                                              name={`voucher_contra.${index}.credit`}
                                              disabled={
                                                watch(
                                                  `voucher_contra.${index}.nature`
                                                )?.value == "debit"
                                                  ? true
                                                  : false
                                              }
                                              isDecimal={true}
                                              decimalLength={desimalrange || 2}
                                              // onChange={e =>
                                              //   handleCreditValue(e, index)
                                              // }
                                              // onKeyDown={e => {
                                              //   const accountGroupId = watch(
                                              //     `voucher_contra.${index}.account_id`
                                              //   )?.is_bill_wise
                                              //   if (
                                              //     accountGroupId == 1
                                              //     // accountGroupId === 13 ||
                                              //     // accountGroupId === 22
                                              //   ) {
                                              //     handleEditPartial(index) // fire only on typing
                                              //   } else {
                                              //     handleCreditValue(e, index) // fire only on typing
                                              //   }
                                              // }}
                                              onKeyDown={e => {
                                                const accountGroupId = watch(
                                                  `voucher_contra.${index}.account_id`
                                                )?.is_bill_wise

                                                const isTypingKey =
                                                  e.key.length === 1 ||
                                                  e.key === "Backspace" ||
                                                  e.key === "Delete"

                                                // Allow Tab to proceed, don't block it
                                                if (!isTypingKey) return

                                                if (accountGroupId == 1) {
                                                  handleEditPartial(index)
                                                } else {
                                                  handleCreditValue(e, index)
                                                }
                                              }}
                                              className="ps-1"
                                            />
                                          </td>
                                          <td>
                                            {index != 0 && (
                                              <div className="pb-1 px-2 d-flex justify-content-center">
                                                <div
                                                  className="trash-img pointer"
                                                  onClick={() =>
                                                    contraListRemove(index)
                                                  }
                                                >
                                                  <TrashIcon />
                                                </div>
                                              </div>
                                            )}
                                          </td>
                                        </tr>
                                        {watch(
                                          `voucher_contra.${index}.partial_payments`
                                        )?.length > 0 && (
                                          <tr className="td-wt-no-border">
                                            <div className="ps-2">
                                              Detail{" "}
                                              <span
                                                className="update-text ms-2 pointer"
                                                onClick={() => {
                                                  handleEditPartial(index)
                                                  setEditPartial(true) // Added by Adithyan
                                                }}
                                              >
                                                Edit
                                              </span>
                                            </div>
                                          </tr>
                                        )}

                                        {console.log(
                                          `chjjjj`,
                                          watch(
                                            `voucher_contra.${index}.partial_payments`
                                          )
                                        )}
                                        {watch(
                                          `voucher_contra.${index}.partial_payments`
                                        )?.map((itm, index) => (
                                          <tr className="td-wt-no-border ps-4">
                                            {/* <div className="ps-4"> */}
                                            <td colSpan={4}>
                                              {itm?.ref_id?.label} {itm?.code}{" "}
                                              {itm?.amount} {itm?.nature?.label}
                                            </td>
                                            {/* <td>
                                              <button onClick={HandilEdit(itm?.ref_id?.label, itm?.amount, itm?.nature?.label)}>Edit</button>
                                            </td> */}
                                            {/* </div> */}
                                            {/* <td className="ps-2">
                                            {itm?.ref_id?.label}
                                          </td>
                                          <td className="ps-5">
                                            {itm?.remarks}
                                          </td>
                                          <td className="ps-5">
                                            {moment(itm?.date).format("DD-MM-YYYY")}
                                          </td>
                                          <td className="ps-5">
                                            {itm?.amount} {itm?.nature?.label}
                                          </td> */}
                                          </tr>
                                        ))}
                                        {Number(
                                          watch(
                                            `voucher_contra.${index}.bank_amount`
                                          )
                                        ) > 0 && (
                                          <tr className="td-wt-no-border">
                                            <div className="ps-2">
                                              Detail{" "}
                                              <span
                                                className="update-text ms-2 pointer"
                                                onClick={() => {
                                                  handleEditBankDetails(index)
                                                  setBankModal(true)
                                                }}
                                              >
                                                Edit
                                              </span>
                                            </div>
                                          </tr>
                                        )}
                                        {Number(
                                          watch(
                                            `voucher_contra.${index}.bank_amount`
                                          )
                                        ) > 0 && (
                                          <tr className="td-wt-no-border ps-4">
                                            <td colSpan={4}>
                                              {
                                                watch(
                                                  `voucher_contra.${index}.payment_type_id`
                                                )?.label
                                              }{" "}
                                              -{" "}
                                              {watch(
                                                `voucher_contra.${index}.instrument_no`
                                              )}
                                            </td>
                                          </tr>
                                        )}
                                        {(watch(
                                          `voucher_contra.${index}.cost_center_id`
                                        )?.value != null ||
                                          watch(
                                            `voucher_contra.${index}.transaction_type`
                                          )?.value != null) && (
                                          <tr className="td-wt-no-border">
                                            <div className="ps-2">
                                              Detail{" "}
                                              <span
                                                className="update-text ms-2 pointer"
                                                onClick={() => {
                                                  setViewData({
                                                    currIndex: index,
                                                    showCC: true,
                                                    taxChk: 1,
                                                  })
                                                  setCostCenterCheck(
                                                    watch(
                                                      `voucher_contra.${index}.cost_center_id`
                                                    )?.value
                                                      ? false
                                                      : true
                                                  )
                                                  setValue(
                                                    "cost_center_id",
                                                    watch(
                                                      `voucher_contra.${index}.cost_center_id`
                                                    )?.value
                                                      ? watch(
                                                          `voucher_contra.${index}.cost_center_id`
                                                        )
                                                      : null
                                                  )
                                                  setValue(
                                                    "transaction_type",
                                                    watch(
                                                      `voucher_contra.${index}.transaction_type`
                                                    )?.value
                                                      ? watch(
                                                          `voucher_contra.${index}.transaction_type`
                                                        )
                                                      : null
                                                  )
                                                  setCCModal(true)
                                                  // handleEditPartial(index)
                                                  // setEditPartial(true) // Added by Adithyan
                                                }}
                                              >
                                                Edit
                                              </span>
                                            </div>
                                          </tr>
                                        )}
                                        {(watch(
                                          `voucher_contra.${index}.cost_center_id`
                                        )?.value != null ||
                                          watch(
                                            `voucher_contra.${index}.transaction_type`
                                          )?.value != null) && (
                                          <>
                                            {watch(
                                              `voucher_contra.${index}.cost_center_id`
                                            )?.label ? (
                                              <tr className="td-wt-no-border ps-4">
                                                <td colSpan={4}>
                                                  Cost Center : {
                                                    watch(
                                                      `voucher_contra.${index}.cost_center_id`
                                                    )?.label
                                                  }
                                                </td>
                                              </tr>
                                            ) : (
                                              <></>
                                            )}
                                            {watch(
                                              `voucher_contra.${index}.transaction_type`
                                            )?.value ? (
                                              <tr className="td-wt-no-border ps-4">
                                                <td colSpan={4}>
                                                  Nature Of Transactions : {
                                                    watch(
                                                      `voucher_contra.${index}.transaction_type`
                                                    )?.label
                                                  }
                                                </td>
                                              </tr>
                                            ) : (
                                              <></>
                                            )}
                                          </>
                                        )}
                                      </>
                                    ))}
                                  </tbody>
                                </table>
                                <div className="text-end mt-2 note-txt">
                                  Press TAB to Add Row
                                </div>

                                {/* <Col
                                  lg="12"
                                  xs={12}
                                  md={2}
                                  sm={12}
                                  className="d-flex justify-content-end"
                                >
                                  {!fromDashboard && (
                                    <Button
                                      color="primary"
                                      className="addButton mt-2"
                                      onClick={
                                        () => handleAppendContraRow()
                                        // contraListAppend({
                                        //   nature: null,
                                        //   account_id: "",
                                        //   debit: 0,
                                        //   credit: 0,
                                        // })
                                      }
                                    >
                                      + Row
                                    </Button>
                                  )}
                                </Col> */}
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={4}>
                                <FormGroup className="mb-4">
                                  <Label>Narration</Label>
                                  <UFEditor
                                    control={control}
                                    placeholder="Enter the Narrations"
                                    rows="5"
                                    name={"narration"}
                                    invalid={!!errors.narration}
                                    className={"pb-0"}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </>
                        ) : // : watch("voucher_id")?.value == 6 ? (
                        //   <>
                        //     <Row className="mb-4">
                        //       {contraFields?.map((item, index) => (
                        //         <>
                        //           <Col sm={3} className="py-2">
                        //             <FinanceLedgersLi
                        //               control={control}
                        //               placeholder="Select"
                        //               // name={`voucher_contra.${index}.account_id`}
                        //               name={`voucher_contra_ref.${index}.account_id`}
                        //               invalid={!!errors.account_id}
                        //               // onSelectChange={e =>
                        //               //   handleType(e, index)
                        //               // }
                        //               showCreateOption={true}
                        //               refreshTrigger={refreshDropdown}
                        //               onSuccess={handleLedgerCreationSuccess}
                        //               target={"body"}
                        //             />
                        //           </Col>
                        //           <Col
                        //             sm={9}
                        //             className="d-flex justify-content-end align-items-center pe-2"
                        //           >
                        //             <div className="pb-1 px-2 d-flex justify-content-center">
                        //               <div
                        //                 className="trash-img pointer"
                        //                 onClick={() => contraListRemove(index)}
                        //               >
                        //                 <TrashIcon />
                        //               </div>
                        //             </div>
                        //           </Col>
                        //           <Col lg={12}>
                        //             <table className="estimation-table mb-4">
                        //               <thead>
                        //                 <tr>
                        //                   <th className="wdt-10">Type</th>
                        //                   <th>Ref Type</th>
                        //                   <th className="w-25">Reference</th>
                        //                   <th>Debit (AED)</th>
                        //                   <th>Credit (AED)</th>
                        //                   {/* <th></th> */}
                        //                 </tr>
                        //               </thead>
                        //               <tbody>
                        //                 <tr key={`purchase${item.id || index}`}>
                        //                   <td className="ps-1">
                        //                     <DebitCreditDrop
                        //                       control={control}
                        //                       placeholder="Select"
                        //                       name={`voucher_contra_ref.${index}.nature`}
                        //                       onSelectChange={e =>
                        //                         handleNature(
                        //                           e?.value,
                        //                           index,
                        //                           "ref"
                        //                         )
                        //                       }
                        //                     />
                        //                   </td>
                        //                   <td className="ps-1">
                        //                     {[13, 22].includes(
                        //                       watch(
                        //                         `voucher_contra_ref.${index}.account_id`
                        //                       )?.account_group_id
                        //                     ) ? (
                        //                       <ReferenceType
                        //                         control={control}
                        //                         placeholder="Select"
                        //                         name={`voucher_contra_ref.${index}.ref_id`}
                        //                         onSelectChange={e =>
                        //                           handleTypeAgainst(e, index)
                        //                         }
                        //                       />
                        //                     ) : (
                        //                       <>-</>
                        //                     )}
                        //                   </td>

                        //                   <td className="">
                        //                     {[13, 22].includes(
                        //                       watch(
                        //                         `voucher_contra_ref.${index}.account_id`
                        //                       )?.account_group_id
                        //                     ) ? (
                        //                       <UFInput
                        //                         control={control}
                        //                         placeholder="Code"
                        //                         name={`voucher_contra_ref.${index}.remarks`}
                        //                         className="ps-1"
                        //                       />
                        //                     ) : (
                        //                       <>-</>
                        //                     )}
                        //                   </td>
                        //                   {/* <td className="ps-1">
                        //                   <FinanceLedgersLi
                        //                     control={control}
                        //                     placeholder="Select"
                        //                     name={`voucher_contra.${index}.account_id`}
                        //                     invalid={
                        //                       !!errors.voucher_contra?.[index]
                        //                         ?.account_id
                        //                     }
                        //                     onSelectChange={e =>
                        //                       handleType(e, index)
                        //                     }
                        //                     target={"body"}
                        //                     // ledgerTypes={"asset&expence"}
                        //                   />
                        //                 </td> */}
                        //                   <td className="">
                        //                     <UFInput
                        //                       control={control}
                        //                       placeholder="Amount"
                        //                       name={`voucher_contra_ref.${index}.debit`}
                        //                       disabled={
                        //                         watch(
                        //                           `voucher_contra_ref.${index}.nature`
                        //                         )?.value == "credit"
                        //                           ? true
                        //                           : false
                        //                       }
                        //                       className="ps-1"
                        //                       onChange={e =>
                        //                         handleDebitValueRef(e, index)
                        //                       }
                        //                     />
                        //                   </td>
                        //                   <td className="">
                        //                     <UFInput
                        //                       control={control}
                        //                       placeholder="Amount"
                        //                       name={`voucher_contra_ref.${index}.credit`}
                        //                       disabled={
                        //                         watch(
                        //                           `voucher_contra_ref.${index}.nature`
                        //                         )?.value == "debit"
                        //                           ? true
                        //                           : false
                        //                       }
                        //                       onChange={e =>
                        //                         handleCreditValueRef(e, index)
                        //                       }
                        //                       className="ps-1"
                        //                     />
                        //                   </td>
                        //                   {/* <td>
                        //                     <div className="pb-1 px-2 d-flex justify-content-center">
                        //                       <div
                        //                         className="trash-img pointer"
                        //                         onClick={() =>
                        //                           contraListRemove(index)
                        //                         }
                        //                       >
                        //                         <TrashIcon />
                        //                       </div>
                        //                     </div>
                        //                   </td> */}
                        //                 </tr>
                        //               </tbody>
                        //             </table>
                        //           </Col>
                        //         </>
                        //       ))}

                        //       <Col lg={12}>
                        //         <Col
                        //           lg="12"
                        //           xs={12}
                        //           md={2}
                        //           sm={12}
                        //           className="d-flex justify-content-end"
                        //         >
                        //           {!fromDashboard && (
                        //             <Button
                        //               color="primary"
                        //               className="addButton mt-2"
                        //               onClick={() =>
                        //                 contraListAppend({
                        //                   account_id: "",
                        //                   debit: 0,
                        //                   credit: 0,
                        //                 })
                        //               }
                        //             >
                        //               + Row
                        //             </Button>
                        //           )}
                        //         </Col>
                        //       </Col>
                        //     </Row>

                        //     <Row>
                        //       <Col sm={4}>
                        //         <FormGroup className="mb-4">
                        //           <Label>Narration</Label>
                        //           <UFEditor
                        //             control={control}
                        //             placeholder="Enter the Narrations"
                        //             rows="5"
                        //             name={"narration"}
                        //             invalid={!!errors.narration}
                        //             className={"pb-0"}
                        //           />
                        //         </FormGroup>
                        //       </Col>
                        //     </Row>
                        //   </>
                        // )
                        //  : watch("voucher_id")?.value == 6 ? (
                        //   <>
                        //     <Row className="mb-4">
                        //       <Col sm={3} className="py-2">
                        //         <FinanceLedgersLi
                        //           control={control}
                        //           placeholder="Select"
                        //           // name={`voucher_contra.${index}.account_id`}
                        //           name={`voucher_contra_account_id`}
                        //           invalid={!!errors.voucher_contra_account_id}
                        //           // onSelectChange={e =>
                        //           //   handleType(e, index)
                        //           // }
                        //           showCreateOption={true}
                        //           refreshTrigger={refreshDropdown}
                        //           onSuccess={handleLedgerCreationSuccess}
                        //           target={"body"}
                        //         />
                        //       </Col>
                        //       <Col lg={12}>
                        //         <table className="estimation-table mb-4">
                        //           <thead>
                        //             <tr>
                        //               <th className="wdt-10">Type</th>
                        //               <th>Ref Type</th>
                        //               <th className="w-25">Reference</th>
                        //               <th>Debit (AED)</th>
                        //               <th>Credit (AED)</th>
                        //               <th></th>
                        //             </tr>
                        //           </thead>
                        //           <tbody>
                        //             {contraFields?.map((item, index) => (
                        //               <tr key={`purchase${item.id || index}`}>
                        //                 <td className="ps-1">
                        //                   <DebitCreditDrop
                        //                     control={control}
                        //                     placeholder="Select"
                        //                     name={`voucher_contra_ref.${index}.nature`}
                        //                     onSelectChange={e =>
                        //                       handleNature(e?.value, index)
                        //                     }
                        //                   />
                        //                 </td>
                        //                 <td className="ps-1">
                        //                   <ReferenceType
                        //                     control={control}
                        //                     placeholder="Select"
                        //                     name={`voucher_contra_ref.${index}.ref_id`}
                        //                     onSelectChange={e =>
                        //                       handleTypeAgainst(e, index)
                        //                     }
                        //                   />
                        //                 </td>
                        //                 <td className="">
                        //                   <UFInput
                        //                     control={control}
                        //                     placeholder="Code"
                        //                     name={`voucher_contra_ref.${index}.remarks`}
                        //                     className="ps-1"
                        //                   />
                        //                 </td>
                        //                 {/* <td className="ps-1">
                        //                   <FinanceLedgersLi
                        //                     control={control}
                        //                     placeholder="Select"
                        //                     name={`voucher_contra.${index}.account_id`}
                        //                     invalid={
                        //                       !!errors.voucher_contra?.[index]
                        //                         ?.account_id
                        //                     }
                        //                     onSelectChange={e =>
                        //                       handleType(e, index)
                        //                     }
                        //                     target={"body"}
                        //                     // ledgerTypes={"asset&expence"}
                        //                   />
                        //                 </td> */}
                        //                 <td className="">
                        //                   <UFInput
                        //                     control={control}
                        //                     placeholder="Amount"
                        //                     name={`voucher_contra_ref.${index}.debit`}
                        //                     disabled={
                        //                       watch(
                        //                         `voucher_contra_ref.${index}.nature`
                        //                       )?.value == "credit"
                        //                         ? true
                        //                         : false
                        //                     }
                        //                     className="ps-1"
                        //                     onChange={e =>
                        //                       handleDebitValueRef(e, index)
                        //                     }
                        //                   />
                        //                 </td>
                        //                 <td className="">
                        //                   <UFInput
                        //                     control={control}
                        //                     placeholder="Amount"
                        //                     name={`voucher_contra_ref.${index}.credit`}
                        //                     disabled={
                        //                       watch(
                        //                         `voucher_contra_ref.${index}.nature`
                        //                       )?.value == "debit"
                        //                         ? true
                        //                         : false
                        //                     }
                        //                     onChange={e =>
                        //                       handleCreditValueRef(e, index)
                        //                     }
                        //                     className="ps-1"
                        //                   />
                        //                 </td>
                        //                 <td>
                        //                   <div className="pb-1 px-2 d-flex justify-content-center">
                        //                     <div
                        //                       className="trash-img pointer"
                        //                       onClick={() =>
                        //                         contraListRemove(index)
                        //                       }
                        //                     >
                        //                       <TrashIcon />
                        //                     </div>
                        //                   </div>
                        //                 </td>
                        //               </tr>
                        //             ))}
                        //           </tbody>
                        //         </table>

                        //         <Col
                        //           lg="12"
                        //           xs={12}
                        //           md={2}
                        //           sm={12}
                        //           className="d-flex justify-content-end"
                        //         >
                        //           {!fromDashboard && (
                        //             <Button
                        //               color="primary"
                        //               className="addButton mt-2"
                        //               onClick={() =>
                        //                 contraListAppend({
                        //                   account_id: "",
                        //                   debit: 0,
                        //                   credit: 0,
                        //                 })
                        //               }
                        //             >
                        //               + Row
                        //             </Button>
                        //           )}
                        //         </Col>
                        //       </Col>
                        //     </Row>

                        //     <Row className="mb-4">
                        //       {/* <Col sm={3} className="py-2">
                        //         <FinanceLedgersLi
                        //           control={control}
                        //           placeholder="Select"
                        //           // name={`voucher_contra.${index}.account_id`}
                        //           name={`voucher_contra_account_id`}
                        //           invalid={!!errors.voucher_contra_account_id}
                        //           // onSelectChange={e =>
                        //           //   handleType(e, index)
                        //           // }
                        //           target={"body"}
                        //         />
                        //       </Col> */}
                        //       <Col lg={12}>
                        //         <table className="estimation-table mb-4">
                        //           <thead>
                        //             <tr>
                        //               <th className="wdt-10">Type</th>
                        //               <th className="w-25">Particulars</th>
                        //               <th>Debit (AED)</th>
                        //               <th>Credit (AED)</th>
                        //               <th></th>
                        //             </tr>
                        //           </thead>
                        //           <tbody>
                        //             {contraFields?.map((item, index) => (
                        //               <tr key={`purchase${item.id || index}`}>
                        //                 <td className="ps-1">
                        //                   <DebitCreditDrop
                        //                     control={control}
                        //                     placeholder="Select"
                        //                     name={`voucher_contra.${index}.nature`}
                        //                     onSelectChange={e =>
                        //                       handleNature(e?.value, index)
                        //                     }
                        //                   />
                        //                 </td>
                        //                 <td className="ps-1">
                        //                   <FinanceLedgersLi
                        //                     control={control}
                        //                     placeholder="Select"
                        //                     name={`voucher_contra.${index}.account_id`}
                        //                     invalid={
                        //                       !!errors.voucher_contra?.[index]
                        //                         ?.account_id
                        //                     }
                        //                     onSelectChange={e =>
                        //                       handleType(e, index)
                        //                     }
                        //                     showCreateOption={true}
                        //                     refreshTrigger={refreshDropdown}
                        //                     onSuccess={handleLedgerCreationSuccess}
                        //                     target={"body"}
                        //                     // ledgerTypes={"asset&expence"}
                        //                   />
                        //                 </td>
                        //                 <td className="">
                        //                   <UFInput
                        //                     control={control}
                        //                     placeholder="Amount"
                        //                     name={`voucher_contra.${index}.debit`}
                        //                     disabled={
                        //                       watch(
                        //                         `voucher_contra.${index}.nature`
                        //                       )?.value == "credit"
                        //                         ? true
                        //                         : false
                        //                     }
                        //                     className="ps-1"
                        //                     onChange={e =>
                        //                       handleDebitValue(e, index)
                        //                     }
                        //                   />
                        //                 </td>
                        //                 <td className="">
                        //                   <UFInput
                        //                     control={control}
                        //                     placeholder="Amount"
                        //                     name={`voucher_contra.${index}.credit`}
                        //                     disabled={
                        //                       watch(
                        //                         `voucher_contra.${index}.nature`
                        //                       )?.value == "debit"
                        //                         ? true
                        //                         : false
                        //                     }
                        //                     onChange={e =>
                        //                       handleCreditValue(e, index)
                        //                     }
                        //                     className="ps-1"
                        //                   />
                        //                 </td>
                        //                 <td>
                        //                   <div className="pb-1 px-2 d-flex justify-content-center">
                        //                     <div
                        //                       className="trash-img pointer"
                        //                       onClick={() =>
                        //                         contraListRemove(index)
                        //                       }
                        //                     >
                        //                       <TrashIcon />
                        //                     </div>
                        //                   </div>
                        //                 </td>
                        //               </tr>
                        //             ))}
                        //           </tbody>
                        //         </table>

                        //         <Col
                        //           lg="12"
                        //           xs={12}
                        //           md={2}
                        //           sm={12}
                        //           className="d-flex justify-content-end"
                        //         >
                        //           {!fromDashboard && (
                        //             <Button
                        //               color="primary"
                        //               className="addButton mt-2"
                        //               onClick={() =>
                        //                 contraListAppend({
                        //                   account_id: "",
                        //                   debit: 0,
                        //                   credit: 0,
                        //                 })
                        //               }
                        //             >
                        //               + Row
                        //             </Button>
                        //           )}
                        //         </Col>
                        //       </Col>
                        //     </Row>
                        //     <Row>
                        //       <Col sm={4}>
                        //         <FormGroup className="mb-4">
                        //           <Label>Narration</Label>
                        //           <UFEditor
                        //             control={control}
                        //             placeholder="Enter the Narrations"
                        //             rows="5"
                        //             name={"narration"}
                        //             invalid={!!errors.narration}
                        //             className={"pb-0"}
                        //           />
                        //         </FormGroup>
                        //       </Col>
                        //     </Row>
                        //   </>
                        // )
                        watch("voucher_id")?.value == 7 ||
                          watch("voucher_id")?.value == 5 ||
                          watch("voucher_id")?.value == 10 ||
                          [5, 7, 10].includes(
                            Number(watch("voucher_id")?.parent_id)
                          ) ? (
                          <>
                            {" "}
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th className="w-25">Product</th>
                                      {/* <th>Description</th> */}
                                      <th>Unit</th>
                                      <th>Ordered Quantity</th>
                                      <th>Received Quantity</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {receiptFields?.map((item, index) => (
                                      <tr key={`purchase${item.id || index}`}>
                                        <td className="ps-1">
                                          {/* {action == "company-req" ? ( */}
                                          <ProductList
                                            control={control}
                                            placeholder="Select Product"
                                            // projectid={projectID}
                                            selectedProduct={watch(
                                              `voucher_receipt`
                                            )}
                                            index={index}
                                            name={`voucher_receipt.${index}.product_id`}
                                            invalid={
                                              !!errors?.voucher_receipt?.[index]
                                                ?.product_id
                                            }
                                            onSelectChange={e =>
                                              handleCompanyProduct(e, index)
                                            }
                                          />
                                        </td>
                                        {/* <td className="ps-1">
                                          <div className="d-flex justify-content-between">
                                            <UFInput
                                              control={control}
                                              placeholder="Description"
                                              name={`voucher_receipt.${index}.description`}
                                            />
                                          </div>
                                        </td> */}
                                        <td className="ps-1">
                                          <Unit
                                            control={control}
                                            placeholder="Unit"
                                            name={`voucher_receipt.${index}.unit`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Ordered Quantity"
                                            name={`voucher_receipt.${index}.po_quantity`}
                                            disabled={true}
                                          />
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Quantity"
                                            name={`voucher_receipt.${index}.qnt`}
                                            invalid={
                                              !!errors?.voucher_receipt?.[index]
                                                ?.qnt
                                            }
                                            onChange={e =>
                                              handleSubPrice(e, index)
                                            }
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_receipt?.[index]
                                                ?.qnt?.message
                                            }
                                          </FormFeedback>
                                        </td>

                                        <td>
                                          <div className="pb-1 px-2 d-flex justify-content-center">
                                            <div
                                              className="trash-img pointer"
                                              onClick={() =>
                                                receiptListRemove(index)
                                              }
                                            >
                                              <TrashIcon />
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <Col
                                  lg="12"
                                  xs={12}
                                  md={2}
                                  sm={12}
                                  className="d-flex justify-content-end"
                                >
                                  {!fromDashboard && (
                                    <Button
                                      color="primary"
                                      className="addButton mt-2"
                                      onClick={() =>
                                        receiptListAppend({
                                          product_id: "",
                                          description: "",
                                          qnt: "",
                                          discount: "",
                                          unit_price: "",
                                          sub_price: "",
                                        })
                                      }
                                    >
                                      + Row
                                    </Button>
                                  )}
                                </Col>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={7}>
                                <Row>
                                  <Col sm={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Narration</Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Narrations"
                                        rows="5"
                                        name={"narration"}
                                        invalid={!!errors.narration}
                                        className={"pb-0"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : watch("voucher_id")?.value == 11 ||
                          watch("voucher_id")?.parent_id == 11 ? (
                          <>
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th>Product Code</th>
                                      <th>Description</th>
                                      {/* <th>Unit</th> */}
                                      {/* <th>Available Quantity</th> */}
                                      <th>Out Quantity</th>
                                      {/* <th>Balance Quantity</th> */}
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {materialOutFields?.map((item, index) => (
                                      <tr key={`purchase${item.id || index}`}>
                                        <td className="ps-1">
                                          {/* {action == "company-req" ? ( */}
                                          <StockProductList
                                            control={control}
                                            placeholder="Product Code"
                                            // projectid={projectID}
                                            selectedProduct={watch(
                                              `voucher_materialout`
                                            )}
                                            index={index}
                                            name={`voucher_materialout.${index}.product_id`}
                                            invalid={
                                              !!errors?.voucher_receipt?.[index]
                                                ?.product_id
                                            }
                                            onSelectChange={e =>
                                              handleCompanyProduct(e, index)
                                            }
                                          />
                                        </td>
                                        <td className="ps-1">
                                          <div className="d-flex justify-content-between">
                                            <UFInput
                                              control={control}
                                              placeholder="Description"
                                              name={`voucher_materialout.${index}.description`}
                                            />
                                          </div>
                                        </td>
                                        <td className="ps-1">
                                          <UFInput
                                            control={control}
                                            placeholder="Out Quantity"
                                            name={`voucher_materialout.${index}.qnt`}
                                            invalid={
                                              !!errors?.voucher_materialout?.[
                                                index
                                              ]?.qnt
                                            }
                                            onChange={e =>
                                              handleSubPrice(e, index)
                                            }
                                          />
                                          <FormFeedback invalid>
                                            {
                                              errors?.voucher_materialout?.[
                                                index
                                              ]?.qnt?.message
                                            }
                                          </FormFeedback>
                                        </td>

                                        <td>
                                          <div className="pb-1 px-2 d-flex justify-content-center">
                                            <div
                                              className="trash-img pointer"
                                              onClick={() =>
                                                materialOutListRemove(index)
                                              }
                                            >
                                              <TrashIcon />
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>

                                <Col
                                  lg="12"
                                  xs={12}
                                  md={2}
                                  sm={12}
                                  className="d-flex justify-content-end"
                                >
                                  {!fromDashboard && (
                                    <Button
                                      color="primary"
                                      className="addButton mt-2"
                                      onClick={() =>
                                        materialOutListAppend({
                                          product_id: "",
                                          description: "",
                                          qnt: "",
                                          discount: "",
                                          unit_price: "",
                                          sub_price: "",
                                        })
                                      }
                                    >
                                      + Row
                                    </Button>
                                  )}
                                </Col>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={7}>
                                <Row>
                                  <Col sm={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Narration</Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Narrations"
                                        rows="5"
                                        name={"narration"}
                                        invalid={!!errors.narration}
                                        className={"pb-0"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : watch("voucher_id")?.value == 12 ||
                          watch("voucher_id")?.parent_id == 12 ? (
                          <>
                            <Row className="mb-4 h-100">
                              <Col lg={12} className="h-100 d-flex flex-column">
                                {/* <div className="d-flex justify-content-center mb-2">
                            Source
                          </div> */}
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th className="w-25">Product</th>
                                      <th>Quantity</th>
                                      <th>Rate</th>
                                      <th>Amount</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {stockTransferSourceFields?.map(
                                      (item, index) => (
                                        <tr
                                          key={`stockSource_${
                                            item?.id || index
                                          }`}
                                        >
                                          <td className="ps-1">
                                            <ProductList
                                              control={control}
                                              placeholder="Select Product"
                                              selectedProduct={watch(
                                                `voucher_source`
                                              )}
                                              index={index}
                                              projectId={
                                                watch("credit_id")?.project_id
                                                  ? watch("credit_id")
                                                      ?.project_id
                                                  : ""
                                              }
                                              name={`voucher_source.${index}.material_id`}
                                              invalid={
                                                !!errors?.voucher_receipt?.[
                                                  index
                                                ]?.material_id
                                              }
                                            />
                                            {/* <StockProductList
                                      control={control}
                                      placeholder="Product Code"
                                      selectedProduct={watch(`voucher_source`)}
                                      index={index}
                                      name={`voucher_source.${index}.product_id`}
                                      invalid={
                                        !!errors?.voucher_receipt?.[index]
                                          ?.product_id
                                      }
                                      onSelectChange={e =>
                                        handleCompanyProduct(e, index)
                                      }
                                    /> */}
                                          </td>
                                          <td className="ps-1">
                                            <UFInputNumber
                                              control={control}
                                              isDecimal={true}
                                              decimalLength={2}
                                              placeholder="Quantity"
                                              name={`voucher_source.${index}.qnt`}
                                              invalid={
                                                !!errors?.voucher_source?.[
                                                  index
                                                ]?.qnt
                                              }
                                              onChange={e =>
                                                handleSourceQnt(e, index)
                                              }
                                            />
                                            <FormFeedback invalid>
                                              {
                                                errors?.voucher_source?.[index]
                                                  ?.qnt?.message
                                              }
                                            </FormFeedback>
                                          </td>
                                          <td className="ps-1">
                                            <UFInputNumber
                                              control={control}
                                              placeholder="Rate"
                                              isDecimal={true}
                                              name={`voucher_source.${index}.rate`}
                                              invalid={
                                                !!errors?.voucher_source?.[
                                                  index
                                                ]?.rate
                                              }
                                              onChange={e =>
                                                handleSourcePrice(e, index)
                                              }
                                            />
                                            <FormFeedback invalid>
                                              {
                                                errors?.voucher_source?.[index]
                                                  ?.rate?.message
                                              }
                                            </FormFeedback>
                                          </td>
                                          <td className="ps-1">
                                            <UFInputNumber
                                              control={control}
                                              isDecimal={true}
                                              placeholder="Amount"
                                              name={`voucher_source.${index}.amount`}
                                              invalid={
                                                !!errors?.voucher_source?.[
                                                  index
                                                ]?.amount
                                              }
                                              // onChange={e => handleSubPrice(e, index)}
                                            />
                                            <FormFeedback invalid>
                                              {
                                                errors?.voucher_source?.[index]
                                                  ?.amount?.message
                                              }
                                            </FormFeedback>
                                          </td>

                                          <td>
                                            <div className="pb-1 px-2 d-flex justify-content-center">
                                              <div
                                                className="trash-img pointer"
                                                onClick={() =>
                                                  stockTransferSourceRemove(
                                                    index
                                                  )
                                                }
                                              >
                                                <TrashIcon />
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                </table>

                                <Col
                                  lg="12"
                                  xs={12}
                                  md={2}
                                  sm={12}
                                  className="d-flex justify-content-end"
                                >
                                  {!fromDashboard && (
                                    <Button
                                      color="primary"
                                      className="addButton mt-2"
                                      onClick={() =>
                                        stockTransferSourceAppend({
                                          product_id: "",
                                          description: "",
                                          qnt: "",
                                          discount: "",
                                          unit_price: "",
                                          sub_price: "",
                                        })
                                      }
                                    >
                                      + Row
                                    </Button>
                                  )}
                                </Col>

                                <div className="text-end mt-auto">
                                  {calculateStockTotal}
                                </div>
                              </Col>
                              {/* <Col lg={6} className="h-100 d-flex flex-column">
                          <div className="d-flex justify-content-center mb-2">
                            Destination
                          </div>
                          <table className="estimation-table mb-4">
                            <thead>
                              <tr>
                                <th className="w-25">Product Code</th>
                                <th>Quantity</th>
                                <th>Rate</th>
                                <th>Amount</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {stockTransferDestinationFields?.map(
                                (item, index) => (
                                  <tr key={`stockDestination_${item?.id || index}`}>
                                    <td className="ps-1">
                                      <StockProductList
                                        control={control}
                                        placeholder="Product Code"
                                        selectedProduct={watch(
                                          `voucher_destination`
                                        )}
                                        index={index}
                                        name={`voucher_destination.${index}.product_id`}
                                        invalid={
                                          !!errors?.voucher_receipt?.[index]
                                            ?.product_id
                                        }
                                        onSelectChange={e =>
                                          handleCompanyProduct(e, index)
                                        }
                                      />
                                    </td>
                                    <td className="ps-1">
                                      <UFInputNumber
                                        control={control}
                                        isDecimal={true}
                                        decimalLength={2}
                                        placeholder="Quantity"
                                        name={`voucher_destination.${index}.qnt`}
                                        invalid={
                                          !!errors?.voucher_destination?.[index]
                                            ?.qnt
                                        }
                                        onChange={e => handleSubPrice(e, index)}
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors?.voucher_destination?.[index]
                                            ?.qnt?.message
                                        }
                                      </FormFeedback>
                                    </td>
                                    <td className="ps-1">
                                      <UFInputNumber
                                        control={control}
                                        placeholder="Rate"
                                        isDecimal={true}
                                        name={`voucher_destination.${index}.rate`}
                                        invalid={
                                          !!errors?.voucher_destination?.[index]
                                            ?.rate
                                        }
                                        onChange={e => handleSubPrice(e, index)}
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors?.voucher_destination?.[index]
                                            ?.rate?.message
                                        }
                                      </FormFeedback>
                                    </td>
                                    <td className="ps-1">
                                      <UFInputNumber
                                        control={control}
                                        placeholder="Amount"
                                        isDecimal={true}
                                        name={`voucher_destination.${index}.amount`}
                                        invalid={
                                          !!errors?.voucher_destination?.[index]
                                            ?.amount
                                        }
                                        onChange={e => handleSubPrice(e, index)}
                                      />
                                      <FormFeedback invalid>
                                        {
                                          errors?.voucher_destination?.[index]
                                            ?.amount?.message
                                        }
                                      </FormFeedback>
                                    </td>

                                    <td>
                                      <div className="pb-1 px-2 d-flex justify-content-center">
                                        <img
                                          src={lightTrash}
                                          alt="light-trash"
                                          className="trash-img pointer"
                                          onClick={() =>
                                            stockTransferDestinationRemove(
                                              index
                                            )
                                          }
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>

                          <Col
                            lg="12"
                            xs={12}
                            md={2}
                            sm={12}
                            className="d-flex justify-content-between"
                          >
                            {!fromDashboard && (
                              <Button
                                color="secondary"
                                className="addButton mt-2"
                                onClick={() =>
                                  stockTransferDestinationAppend({
                                    product_id: "",
                                    description: "",
                                    qnt: "",
                                    discount: "",
                                    unit_price: "",
                                    sub_price: "",
                                  })
                                }
                              >
                                Add Row
                              </Button>
                            )}
                          </Col>

                          <div className="text-end mt-auto">
                            {calculateStockTotal("voucher_destination")}
                          </div>
                        </Col> */}
                            </Row>
                          </>
                        ) : ([13, 15, 4, 18].includes(
                            watch("voucher_id")?.value
                          ) ||
                            [13, 14, 4, 18].includes(
                              watch("voucher_id")?.parent_id
                            )) &&
                          rSelected == 3 ? (
                          <>
                            <Row className="mb-4">
                              <Col lg={12}>
                                <table className="estimation-table mb-4">
                                  <thead>
                                    <tr>
                                      <th>Account Head</th>
                                      <th className="wdt-33">Rate</th>
                                      {/* <th>Unit</th> */}
                                      {/* <th>Qty</th> */}
                                      <th>Amount (AED)</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {salesAccFields?.map((item, index) => (
                                      <>
                                        <tr key={`purchase${item.id || index}`}>
                                          {/* <td className="ps-1">
                                            <DebitCreditDrop
                                              control={control}
                                              placeholder="Select"
                                              name={`voucher_contra.${index}.nature`}
                                              onSelectChange={e =>
                                                handleNature(e?.value, index)
                                              }
                                            />
                                          </td> */}
                                          <td className="ps-1">
                                            <FinanceLedgersLi
                                              control={control}
                                              placeholder="Select"
                                              name={`voucher_sales_acc.${index}.account_id`}
                                              invalid={
                                                !!errors.voucher_sales_acc?.[
                                                  index
                                                ]?.account_id
                                              }
                                              showCreateOption={true}
                                              refreshTrigger={refreshDropdown}
                                              onSuccess={
                                                handleLedgerCreationSuccess
                                              }
                                              onSelectChange={e =>
                                                handleSalesType(e, index)
                                              }
                                              notAccId={
                                                [4, 15].includes(
                                                  Number(
                                                    watch("voucher_id")?.value
                                                  )
                                                ) ||
                                                [4, 15].includes(
                                                  Number(
                                                    watch("voucher_id")
                                                      ?.parent_id
                                                  )
                                                )
                                                  ? [13, 12]
                                                  : [22, 12]
                                              }
                                              target={"body"}
                                              // ledgerTypes={"asset&expence"}
                                            />
                                          </td>
                                          <td className="">
                                            <UFInput
                                              control={control}
                                              placeholder="Percent"
                                              name={`voucher_sales_acc.${index}.rate`}
                                              disabled={
                                                index == 0 ? true : false
                                              }
                                              className="ps-1"
                                              onChange={e =>
                                                handleRateChange(e, index)
                                              }
                                              // onChange={e =>
                                              //   handleDebitValue(e, index)
                                              // }
                                              // onKeyDown={e => {
                                              //   const accountGroupId = watch(
                                              //     `voucher_contra.${index}.account_id`
                                              //   )?.is_bill_wise
                                              //   if (
                                              //     accountGroupId == 1
                                              //     // accountGroupId === 13 ||
                                              //     // accountGroupId === 22
                                              //   ) {
                                              //     handleEditPartial(index) // fire only on typing
                                              //   } else {
                                              //     handleDebitValue(e, index) // fire only on typing
                                              //   }
                                              // }}
                                            />
                                          </td>
                                          <td className="">
                                            <UFInput
                                              control={control}
                                              placeholder="Amount"
                                              name={`voucher_sales_acc.${index}.amount`}
                                              // disabled={
                                              //   watch(
                                              //     `voucher_contra.${index}.nature`
                                              //   )?.value == "debit"
                                              //     ? true
                                              //     : false
                                              // }
                                              // onChange={e =>
                                              //   handleCreditValue(e, index)
                                              // }
                                              // onKeyDown={e => {
                                              //   const accountGroupId = watch(
                                              //     `voucher_contra.${index}.account_id`
                                              //   )?.is_bill_wise
                                              //   if (
                                              //     accountGroupId == 1
                                              //     // accountGroupId === 13 ||
                                              //     // accountGroupId === 22
                                              //   ) {
                                              //     handleEditPartial(index) // fire only on typing
                                              //   } else {
                                              //     handleCreditValue(e, index) // fire only on typing
                                              //   }
                                              // }}
                                              className="ps-1"
                                            />
                                          </td>
                                          <td>
                                            <div className="pb-1 px-2 d-flex justify-content-center">
                                              <div
                                                className="trash-img pointer"
                                                onClick={() =>
                                                  salesAccRemove(index)
                                                }
                                              >
                                                <TrashIcon />
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                        {/* {watch(
                                          `voucher_contra.${index}.partial_payments`
                                        )?.length > 0 && (
                                          <tr className="td-wt-no-border">
                                            <div className="ps-2">
                                              Detail{" "}
                                              <span
                                                className="update-text ms-2 pointer"
                                                onClick={() =>
                                                  handleEditPartial(index)
                                                }
                                              >
                                                Edit
                                              </span>
                                            </div>
                                          </tr>
                                        )}
                                        {watch(
                                          `voucher_contra.${index}.partial_payments`
                                        )?.map((itm, index) => (
                                          <tr className="td-wt-no-border ps-4">
                                            <td colSpan={4}>
                                              {itm?.ref_id?.label} {itm?.code}{" "}
                                              {itm?.amount} {itm?.nature?.label}
                                            </td>
                                          
                                          </tr>
                                        ))} */}
                                      </>
                                    ))}

                                    {/* <tr>
                                      <td className="ps-1">
                                        <ProjectNo
                                          control={control}
                                          name={"project_ids"}
                                          placeholder={"Project No"}
                                          target={"body"}
                                          ledgerId={watch("credit_id")?.value}
                                          disabled={
                                            watch("credit_id")?.value && id
                                              ? true
                                              : watch("credit_id")?.value && !id
                                              ? false
                                              : true
                                          }
                                          onSelectChange={e =>
                                            handleProjectNumReset(e)
                                          }
                                        />
                                      </td>
                                      <td className="ps-1">
                                        <ManufactureLi
                                          control={control}
                                          name={"manufacturing_journal_id"}
                                          placeholder={"Reference"}
                                          target={"body"}
                                          ledgerId={watch("credit_id")?.value}
                                          disabled={
                                            watch("credit_id")?.value && id
                                              ? true
                                              : watch("credit_id")?.value && !id
                                              ? false
                                              : true
                                          }
                                          projectId={
                                            watch("project_ids")?.value
                                              ? watch("project_ids")?.value
                                              : ""
                                          }
                                          statusChk={1}
                                          grandTotal={true}
                                          onSelectChange={e =>
                                            handleProjectNum(e)
                                          }
                                        />
                                      </td>
                                      <td className="ps-1">
                                        <UFInput
                                          control={control}
                                          placeholder="Unit"
                                          name={`sale_unit`}
                                          // disabled={true}
                                          className="input-disabled-bg"
                                        />
                                      </td>
                                      <td className="ps-1">
                                        <UFInput
                                          control={control}
                                          placeholder="Unit"
                                          name={`sale_qty`}
                                          disabled={true}
                                          className="input-disabled-bg"
                                        />
                                      </td>
                                      <td className="ps-1">
                                        <UFInputNumber
                                          control={control}
                                          placeholder="Price"
                                          name={`sale_total`}
                                          isDecimal={true}
                                          maxNum={watch(`project_ids`)?.amount}
                                          // disabled={true}
                                          className="input-disabled-bg"
                                        />
                                      </td>
                                    </tr> */}
                                  </tbody>
                                </table>
                                <div className="text-end mt-2 note-txt">
                                  Press TAB to Add Row
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col sm={7}>
                                <Row>
                                  <Col sm={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Narration</Label>
                                      <UFEditor
                                        control={control}
                                        placeholder="Enter the Narrations"
                                        rows="5"
                                        name={"narration"}
                                        invalid={!!errors.narration}
                                        className={"pb-0"}
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <></>
                        )}
                        {responseData ? (
                          <Row className="py-2">
                            <Col sm={7}>
                              <FormGroup className="mb-4">
                                <Label>Payment Terms</Label>
                                <div className="fs-13 ps-2">
                                  {responseData?.pay_terms}
                                </div>
                                {/* <UFEditor
                          control={control}
                          placeholder="Enter the Payment Terms"
                          rows="5"
                          name={"pay_terms"}
                          invalid={!!errors.pay_terms}
                          className={"pb-0"}
                        /> */}
                                {/* <RichTextEditor
                          control={control}
                          name={"pay_terms"}
                          invalid={!!errors.terms}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                        /> */}
                              </FormGroup>
                            </Col>
                            <Col lg={4}>
                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Sub Total
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.sub_total
                                      ? NumberFormat(
                                          Number(responseData?.sub_total),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}{" "}
                                    AED
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Discount %
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.discount
                                      ? responseData?.discount
                                      : 0}{" "}
                                    %
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    VAT %
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.tax ? responseData?.tax : 0}{" "}
                                    %
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Shipping Charge
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.shipping_charge
                                      ? NumberFormat(
                                          Number(responseData?.shipping_charge),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}{" "}
                                    AED
                                  </div>
                                </Col>
                              </Row>
                              <Row className="mb-3">
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Other Charge
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.other_charge
                                      ? NumberFormat(
                                          Number(responseData?.other_charge),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}{" "}
                                    AED
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col sm={6}>
                                  <div className="text-end dark-text">
                                    Total Amount
                                  </div>
                                </Col>
                                <Col sm={6}>
                                  <div className="ps-5 dark-text">
                                    {responseData?.total_amount
                                      ? NumberFormat(
                                          Number(responseData?.total_amount),
                                          desimalrange,
                                          desimalrange
                                        )
                                      : NumberFormat(
                                          0,
                                          desimalrange,
                                          desimalrange
                                        )}{" "}
                                    AED
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        ) : (
                          <></>
                        )}
                      </Card>
                    </Col>
                    {!editId && isCardOpen == true ? (
                      <Col
                        lg="2"
                        className={`carf-of-quicklinks-scroll ${
                          isCardOpen ? "open" : ""
                        } ${body === "sm" ? "size-of-quicklinks" : ""} ${
                          location?.state?.type === "from_po" ? "d-none" : ""
                        }`}
                      >
                        <Card className="financeVoucher-card">
                          <CardHeader className="header-menu-avtive py-1 px-1">
                            <div className="d-flex justify-content-between">
                              <div className="quicklinks ps-2">Quick Links</div>
                              <div className="pe-2">
                                <img
                                  src={close}
                                  sizes="9"
                                  alt="close"
                                  className="cancel-of-financeV"
                                  onClick={() => setCardOpen(false)}
                                />
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="py-0 pe-0 scroll-of-finance">
                            {isVoucherLoading ? (
                              <SkeletonLoadingvoucher />
                            ) : (
                              <div className="mt-2">
                                {financeVoucherli?.map(
                                  (item, index) =>
                                    !RemoveItem.includes(item.voucher_type) && (
                                      <div
                                        className={`pb-2 list-of-finace ${
                                          activeItemId === item.id
                                            ? "active"
                                            : ""
                                        }`}
                                        key={index}
                                        onClick={() => handilFinaceChnage(item)}
                                      >
                                        {item?.voucher_type &&
                                          ucfirst(item.voucher_type)}
                                      </div>
                                    )
                                )}
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </Col>
                    ) : (
                      <></>
                    )}
                    {/* {isCardOpen && (
                      <Col lg="2" className="carf-of-quicklinks-scroll">
                        <Card className="financeVoucher-card">
                          <CardHeader className="header-menu-avtive py-1 px-1">
                            <div className="d-flex justify-content-between">
                              <div className="quicklinks ps-2">Quick Links</div>
                              <div className="pe-2">
                                <img
                                  src={close}
                                  sizes="9"
                                  alt="close"
                                  className="cancel-of-financeV"
                                  onClick={() => setCardOpen(false)}
                                />
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="py-0 pe-0">
                            {isVoucherLoading ? (
                              <SkeletonLoadingvoucher />
                            ) : (
                              <div className="scroll-of-finance mt-2">
                                {financeVoucherli?.map((item, index) => (
                                  <div
                                    className={`pb-2 list-of-finace ${
                                      activeItemId === item.id ? "active" : ""
                                    }`}
                                    key={index}
                                    onClick={() => handilFinaceChnage(item)}
                                  >
                                    {item?.voucher_type &&
                                      ucfirst(item.voucher_type)}
                                  </div>
                                ))}
                              </div>
                            )}
                          </CardBody>
                        </Card>
                      </Col>
                    )} */}
                  </Row>
                </Col>
              </Container>
            </Form>
          </FormProvider>
        </div>
      </div>
      {isCardOpen === false && !editId && (
        <div
          className={
            location?.state?.type === "from_po"
              ? "d-none"
              : "style-of-qicklinks"
          }
        >
          <Button
            className="px-2 mb-3 py-2  btn btn-primary rotate-0f-qicklinks"
            onClick={() => setCardOpen(true)}
          >
            Quick Links
          </Button>
        </div>
      )}
      <Draggable handle=".modal">
        <Modal
          isOpen={modal}
          toggle={toggleSelect}
          size="xl"
          unmountOnClose={false}
          className="custom-modal-ht"
          backdrop={"static"}
        >
          {/* <Draggable handle=".custom-modal-header"> */}
          <div className="draggable-modal-content">
            <ModalHeader className="custom-modal-header cursor-grab">
              <div className="d-flex justify-content-between">
                <h5 className="ms-2">
                  Details{" "}
                  {([13, 15, 1, 3, 6, 8]?.includes?.(
                    watch("voucher_id")?.value
                  ) ||
                    ([13, 15, 1, 3, 6, 8]?.includes?.(
                      watch("voucher_id")?.parent_id
                    ) &&
                      (watch("voucher_id")?.value == 13 ||
                        watch("voucher_id")?.parent_id) == 13)) &&
                  rSelected == 1
                    ? calculationSale("total_amount")
                    : (watch("voucher_id")?.value == 15 ||
                        watch("voucher_id")?.parent_id == 15) &&
                      rSelected == 1
                    ? calculation("total_amount")
                    : ([13, 15, 1, 3, 6, 8]?.includes?.(
                        watch("voucher_id")?.value
                      ) ||
                        [13, 15, 1, 3, 6, 8]?.includes?.(
                          watch("voucher_id")?.parent_id
                        )) &&
                      rSelected == 2 &&
                      watch(`voucher_contra.${viewData?.currIndex}.debit`) != 0
                    ? watch(`voucher_contra.${viewData?.currIndex}.debit`)
                    : ([13, 15, 18].includes(watch("voucher_id")?.value) ||
                        [13, 15, 18].includes(
                          watch("voucher_id")?.parent_id
                        )) &&
                      rSelected == 3
                    ? ""
                    : watch(`voucher_contra.${viewData?.currIndex}.credit`)}
                </h5>
                <img
                  src={closeIcon}
                  alt=""
                  onClick={toggleSelectModal}
                  width="10"
                  role="button"
                />
              </div>
            </ModalHeader>
            <ModalBody>
              <Row className="mb-4">
                <Col lg={12} className="mb-4">
                  <table className="estimation-table mb-4">
                    <thead>
                      <tr>
                        <th>Reference Type</th>
                        <th>Reference</th>
                        <th>Bill Date</th>
                        <th>Due Date</th>
                        <th>Amount</th>
                        {/* <th>Dr/Cr</th> */}
                        {([13, 15, 6, 1, 3, 8].includes(
                          watch("voucher_id")?.value
                        ) ||
                          [13, 15, 6, 1, 3, 8].includes(
                            watch("voucher_id")?.parent_id
                          )) && <th></th>}
                      </tr>
                    </thead>
                    <tbody>
                      {contraFieldsPartial?.map((item, index) => (
                        <>
                          <tr key={`purchase${item.id || index}`}>
                            <td>
                              <ReferenceType
                                control={control}
                                placeholder="Select"
                                name={`voucher_contra_partial_pay.${index}.ref_id`}
                                target=".modal"
                                onSelectChange={e => handleRefAgainst(e, index)}
                              />
                            </td>
                            <td>
                              <UFInput
                                control={control}
                                placeholder="Code"
                                name={`voucher_contra_partial_pay.${index}.code`}
                                className="ps-1"
                              />
                            </td>
                            <td>
                              <UFDate
                                control={control}
                                placeholder="Select Date"
                                name={`voucher_contra_partial_pay.${index}.bill_date`}
                                className="ps-1"
                                // onChange={(e) => handleDateContraPartial(e, index)}
                                disableCondition={true}
                              />
                            </td>
                            <td>
                              <UFDate
                                control={control}
                                placeholder="Select Date"
                                name={`voucher_contra_partial_pay.${index}.date`}
                                className="ps-1"
                                onChange={e =>
                                  handleDateContraPartial(e, index)
                                }
                              />
                            </td>
                            <td>
                              <UFInputNumber
                                control={control}
                                placeholder="Amount"
                                name={`voucher_contra_partial_pay.${index}.amount`}
                                className="ps-1"
                                isDecimal={true}
                                decimalLength={desimalrange || 2}
                              />
                            </td>
                            {/* <td>
                            <DebitCreditDrop
                              control={control}
                              placeholder="Select"
                              name={`voucher_contra_partial_pay.${index}.nature`}
                              target=".modal"
                              // onSelectChange={e => handleNature(e?.value, index, "ref")}
                            />
                          </td> */}
                            {([13, 15, 6, 1, 3, 8].includes(
                              watch("voucher_id")?.value
                            ) ||
                              [13, 15, 6, 1, 3, 8].includes(
                                watch("voucher_id")?.parent_id
                              )) && (
                              <td>
                                <div className="pb-1 px-2 d-flex justify-content-center">
                                  <div
                                    className="trash-img pointer"
                                    onClick={() =>
                                      contraPartialListRemove(index)
                                    }
                                  >
                                    <TrashIcon />
                                  </div>
                                </div>
                              </td>
                            )}
                          </tr>
                        </>
                      ))}
                    </tbody>
                  </table>
                  {([13, 15, 6, 1, 3, 8, 4, 18].includes(
                    watch("voucher_id")?.value
                  ) ||
                    [13, 15, 6, 1, 3, 8, 4, 13].includes(
                      watch("voucher_id")?.parent_id
                    )) && (
                    <div className="text-end mt-2 note-txt">
                      Press TAB to handle Values
                    </div>
                  )}
                  {/* {[13, 15].includes(watch("voucher_id")?.value) && (
                  <Col
                    lg="12"
                    xs={12}
                    md={2}
                    sm={12}
                    className="d-flex justify-content-end"
                  >
                    {!fromDashboard && (
                      <Button
                        color="primary"
                        className="addButton mt-2"
                        onClick={() => {
                          contraPartialListAppend({
                            account_id: "",
                            debit: 0,
                            credit: 0,
                            chk: viewData?.currIndex,
                            code: watch("code"),
                            nature:
                              watch("voucher_id")?.value == 13
                                ? { label: "Dr", value: "debit" }
                                : { label: "Cr", value: "credit" },
                          })
                          setViewVouchersLi(false)
                        }}
                      >
                        + Row
                      </Button>
                    )}
                  </Col>
                )} */}
                </Col>
                <Col lg="12">
                  {viewVouchersLi ? (
                    <VoucherEntrySearch
                      fromDashboard={true}
                      editPartial={editPartial} // Added by Adithyan
                      editId={editId} // Added by Adithyan
                      handilUpdate={handilUpdate} // Added by Adithyan
                      onSelect={handlePOSelect}
                      voucherType={viewData?.voucher_type}
                      ledgerId={viewData?.ledger_id}
                      partialPayment={true}
                      voucherLocation={watch("voucher_id")?.value}
                      selectedAgainstRef={selectedAgainstRef}
                    />
                  ) : (
                    <></>
                  )}
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              {[1, 3, 4].includes(rSelected) &&
              ([13, 15, 4, 18].includes(watch("voucher_id")?.value) ||
                [13, 15, 4, 18].includes(watch("voucher_id")?.parent_id)) ? (
                <LoadingButton
                  form={`request-form`}
                  color={"primary"}
                  loading={isLoading}
                  disabled={isLoading}
                  type="submit"
                >
                  Save
                </LoadingButton>
              ) : (
                <LoadingButton
                  color={"primary"}
                  // loading={isLoading}
                  // disabled={isLoading}
                  // type={rSelected == 1 ? "submit" : "button"}
                  // onClick={() => handleModalData(viewData?.currIndex)}
                  onClick={() => handleModalData(viewData?.currIndex, true)}
                >
                  Save
                </LoadingButton>
              )}
            </ModalFooter>
          </div>
          {/* </Draggable> */}
        </Modal>
      </Draggable>
      <Modal isOpen={confirmModal} toggle={() => setConfirmModal(false)}>
        <ModalHeader toggle={() => setConfirmModal(false)}>
          Do you want to Print?
        </ModalHeader>

        <ModalFooter>
          <Button color="secondary" onClick={() => setConfirmModal(false)}>
            No
          </Button>
          <Button
            color="primary"
            // onClick={async () => {
            //   if (confirmType === "delete") {
            //     await handleDelete(selectedId)
            //   } else if (confirmType === "cancel") {
            //     await handleCancel(selectedId)
            //   }
            //   setConfirmModal(false)
            // }}
            // onClick={() => setConfirmModal(false)}
            onClick={() => {
              openAndPrintFile({
                url: `invoice/${printID}`,
                extension: "pdf",
              })
              setConfirmModal(false)
            }}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={ccModal}
        toggle={() => setCCModal(false)}
        unmountOnClose={false}
      >
        <ModalHeader toggle={() => setCCModal(false)}>Details</ModalHeader>
        <ModalBody>
          {viewData?.showCC ? (
            <>
              <Col
                lg={"auto"}
                className="mt-auto"
                onClick={() => handleCCCheck(costCenterCheck)}
              >
                <FormGroup>
                  <input
                    type="checkbox"
                    className="ever-rise-checkbox"
                    name={"is_cc"}
                    checked={costCenterCheck}
                  />
                  <Label className="ms-2">Not Applicable</Label>
                </FormGroup>
              </Col>
              <Col lg="12" xs={12} md={12} sm={12}>
                <FormGroup className="mb-4">
                  <Label>Cost Center</Label>
                  <FinCostCenterLi
                    control={control}
                    placeholder="Select"
                    name={`cost_center_id`}
                    invalid={!!errors?.cost_center_id}
                    disabled={costCenterCheck ? true : false}
                  />
                  <FormFeedback invalid>
                    {errors?.cost_center_id?.message}
                  </FormFeedback>
                </FormGroup>
              </Col>
            </>
          ) : (
            <></>
          )}
          {console.log(viewData, "taxChk")}
          {viewData?.taxChk == 1 ? (
            <Col lg="12" xs={12} md={12} sm={12}>
              <FormGroup className="mb-4">
                <Label>Nature Of Transactions</Label>
                <NatureOfTransactions
                  control={control}
                  placeholder="Select"
                  name={`transaction_type`}
                  invalid={!!errors?.transaction_type}
                />
                <FormFeedback invalid>
                  {errors?.transaction_type?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
          ) : (
            <></>
          )}
        </ModalBody>
        <ModalFooter>
          <LoadingButton
            color={"primary"}
            onClick={() => handleCCModalData(viewData?.currIndex)}
          >
            Save
          </LoadingButton>
        </ModalFooter>
      </Modal>
      {/* <Modal
        isOpen={transactionModal}
        toggle={() => setTransactionModal(false)}
        unmountOnClose={false}
      >
        <ModalHeader toggle={() => setTransactionModal(false)}>
          Select Nature of Transaction
        </ModalHeader>
        <ModalBody>
          <Col lg="12" xs={12} md={12} sm={12}>
            <FormGroup className="mb-4">
              <Label>
                Nature Of Transactions
              </Label>
              <NatureOfTransactions
                control={control}
                placeholder="Select"
                name={`transaction_type`}
                invalid={!!errors?.transaction_type}
              />
              <FormFeedback invalid>
                {errors?.transaction_type?.message}
              </FormFeedback>
            </FormGroup>
          </Col>
        </ModalBody>
        <ModalFooter>
          <LoadingButton
            color={"primary"}
            onClick={() => handleTransactionModalData(viewData?.currIndex)}
          >
            Save
          </LoadingButton>
        </ModalFooter>
      </Modal> */}
      <Modal
        isOpen={bankModal}
        toggle={handleBankModalClose}
        size="xl"
        unmountOnClose={false}
        className="custom-modal-ht"
        backdrop={"static"}
      >
        <ModalHeader toggle={handleBankModalClose}>Bank Details</ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Payment Type</Label>
                <BankPaymentType
                  control={control}
                  placeholder="Select"
                  name={`payment_type_id`}
                  invalid={!!errors?.payment_type_id}
                />
                <FormFeedback invalid>
                  {errors?.payment_type_id?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
            {watch("payment_type_id")?.value == 3 ? (
              <Col
                lg={"auto"}
                className="mt-auto"
                onClick={() => handlePDCCheck(pdcCheck)}
              >
                <FormGroup>
                  <input
                    type="checkbox"
                    className="ever-rise-checkbox"
                    name={"is_pdc"}
                    checked={pdcCheck}
                  />
                  <Label className="ms-2">PDC</Label>
                </FormGroup>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Date</Label>
                <UFDate
                  control={control}
                  placeholder="Enter the Date "
                  name={"bank_date"}
                  disabled={true}
                />
                <FormFeedback invalid>{errors.bank_date?.message}</FormFeedback>
              </FormGroup>
            </Col>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Instrument Number</Label>
                <UFInput
                  control={control}
                  placeholder="Enter Instrument Number"
                  name={`instrument_no`}
                  invalid={!!errors?.instrument_no}
                  // disabled={true}
                />
                <FormFeedback invalid>
                  {errors.instrument_no?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Instrument Date</Label>
                <UFDate
                  control={control}
                  placeholder="Enter the Date "
                  name={"instrument_date"}
                  minDate={
                    pdcCheck
                      ? moment().add(1, "day").startOf("day").toDate()
                      : undefined
                  }
                  // disabled={true}
                />
                <FormFeedback invalid>
                  {errors.instrument_date?.message}
                </FormFeedback>
              </FormGroup>
            </Col>

            {watch("payment_type_id")?.value == 2 ? (
              <Col lg="4" xs={12} md={6} sm={12}>
                <FormGroup className="mb-4">
                  <Label>Currency</Label>
                  <BankCurrency
                    control={control}
                    placeholder="Select"
                    name={`currency`}
                    invalid={!!errors?.currency}
                  />
                  <FormFeedback invalid>
                    {errors?.currency?.message}
                  </FormFeedback>
                </FormGroup>
              </Col>
            ) : (
              <></>
            )}
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Amount</Label>
                <UFInputNumber
                  control={control}
                  placeholder="Enter Amount"
                  name={`bank_amount`}
                  invalid={!!errors?.bank_amount}
                  isDecimal={true}
                  decimalLength={desimalrange || 2}
                  // disabled={true}
                />
                <FormFeedback invalid>
                  {errors.bank_amount?.message}
                </FormFeedback>
              </FormGroup>
            </Col>
            <Col lg="4" xs={12} md={6} sm={12}>
              <FormGroup className="mb-4">
                <Label>Remarks</Label>
                <UFEditor
                  control={control}
                  placeholder="Enter the Remarks"
                  rows="5"
                  name={"remarks"}
                  invalid={!!errors.remarks}
                  className={"pb-0"}
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <LoadingButton
            color={"primary"}
            onClick={() => handleBankModalData(viewData?.currIndex)}
          >
            Save
          </LoadingButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

export default EditVoucherEntry
